import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import CONFIG from "../../Config";
import Service from "Service/Service";
import Infodata from "data/Infodata";

let authheader = {
  "Content-Type": "application/json",
  accept: "application/json",
};

let authheaderFormData = {
  accept: "application/json",
  "Content-Type": "multipart/form-data",
};
let uplodatHeader = { "Content-Type": "multipart/form-data" };
let authheaderTockenAndHed = Service.getAuthTokenAndHeader();
let authheaderUser = Service.getAuthUser();

//Usersignin
export const Usersignin = createAsyncThunk(
  "Usersignin",
  async (userdata, thunkAPI) => {
    try {
      let result = await axios({
        method: "POST",
        baseURL: CONFIG.BASE_URL_LOGIN,
        // headers: authheader,
        url: `api/login`,
        data: { ...userdata, devicePlateform: "web" },
      });
      // isUsersigninotp
      if (result.data.success) {
        if (result?.data?.data?.two_factor_authentication) {
          // await Service.setauthToken(result.data.token);
          // await Service.setCredit(result.data.data.credit);
          // await Service.setUserdata(result.data.data);
          // await Service.setIsLoginData(result.data);
          await Service.setlocation({ latitude: userdata.latitude, longitude: userdata.longitude });
          return result.data;
        } else {
          await Service.setauthToken(result.data.token);
          await Service.setCredit(result.data.data.credit);
          await Service.setUserdata(result.data.data);
          await Service.setIsLoginData(result.data);
          await Service.setlocation({ latitude: userdata.latitude, longitude: userdata.longitude });
          return result.data;
        }
      } else {
        return thunkAPI.rejectWithValue({ error: result.data.errorMessage });
      }
    } catch (error) {
      console.error("try catch [ Usersignin ] error.message >>", error.message);
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);
export const Verifyotp = createAsyncThunk(
  "Verifyotp",
  async (userdata, thunkAPI) => {
    try {
      let result = await axios({
        method: "POST",
        baseURL: CONFIG.BASE_URL_LOGIN,
        headers: {
          ...authheader,
          token: userdata?.UsersignupData?.token
        },
        url: `api/2fa/verify-otp`,
        data: { otp_code: userdata.otp },
      });
      // isUsersigninotp
      if (result.data.success) {
        await Service.setauthToken(userdata?.UsersignupData?.token);
        await Service.setCredit(userdata?.UsersignupData?.data?.credit);
        await Service.setUserdata(userdata?.UsersignupData?.data);
        await Service.setIsLoginData(userdata?.UsersignupData);

        return { ...result.data, adminTrue: userdata?.UsersignupData?.data?.two_factor_authentication || false };
      } else {
        return thunkAPI.rejectWithValue({ error: result.data.errorMessage });
      }
    } catch (error) {
      console.error("try catch [ Verifyotp ] error.message >>", error.message);
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);


//HelpdeskTicketList
export const HelpdeskTicketList = createAsyncThunk(
  "HelpdeskTicketList",
  async (_, thunkAPI) => {
    try {
      let result = await axios({
        method: "GET",
        baseURL: CONFIG.BASE_URL_LOGIN,
        // headers: authheader,
        url: `helpdesk/ticket_list`,
        params: _,
      });
      if (result.data.success) {
        return result.data;
      } else {
        return thunkAPI.rejectWithValue({ error: result.data.errorMessage });
      }
    } catch (error) {
      console.error("try catch [ HelpdeskTicketList ] error.message >>", error.message);
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);
//HelpdeskTicketCreate
export const HelpdeskTicketCreate = createAsyncThunk(
  "HelpdeskTicketCreate",
  async (_, thunkAPI) => {
    try {
      let result = await axios({
        method: "POST",
        baseURL: CONFIG.BASE_URL_LOGIN,
        url: `helpdesk/ticket_create`,
        headers: { 'Content-Type': 'multipart/form-data' },
        data: _,
      });
      if (result.data.success) {
        return result.data;
      } else {
        return thunkAPI.rejectWithValue({ error: result.data.errorMessage });
      }
    } catch (error) {
      console.error("try catch [ HelpdeskTicketCreate ] error.message >>", error.message);
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);
//ReUsersignin
export const ReUsersignin = createAsyncThunk(
  "ReUsersignin",
  async (userdata, thunkAPI) => {
    try {
      let result = await axios({
        method: "POST",
        baseURL: CONFIG.BASE_URL_LOGIN,
        // headers: authheader,
        url: `api/login`,
        data: { ...userdata, devicePlateform: "web" },
      });
      if (result.data.success) {
        await Service.setauthToken(result.data.token);
        await Service.setCredit(result.data.data.credit);
        await Service.setUserdata(result.data.data);
        await Service.setIsLoginData(result.data);
        return result.data;
      } else {
        return thunkAPI.rejectWithValue({ error: result.data.errorMessage });
      }
    } catch (error) {
      console.error(
        "try catch [ ReUsersignin ] error.message >>",
        error.message
      );
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);
// fact/reset_password
export const ResetPassword = createAsyncThunk(
  "ResetPassword",
  async (userdata, thunkAPI) => {
    try {
      let result = await axios({
        method: "POST",
        baseURL: CONFIG.BASE_URL_LOGIN,
        url: `fact/reset_password`,
        data: userdata,
      });
      if (result.data.success) {
        return result.data;
      } else {
        return thunkAPI.rejectWithValue({ error: result.data.errorMessage });
      }
    } catch (error) {
      console.error(
        "try catch [ ResetPassword ] error.message >>",
        error.message
      );
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);
// GetPincodeLatLong
export const GetPincodeLatLongGST = createAsyncThunk(
  "GetPincodeLatLongGST",
  async (userdata, thunkAPI) => {
    try {
      let result = await axios({
        method: "GET",
        baseURL: CONFIG.BASE_URL_ALL,
        url: `GST/GetGSTDetailsByPinCode`,
        headers: Service.infoDataHead(),
        params: userdata,
      });
      if (result.data.success) {
        return result.data;
      } else {
        return thunkAPI.rejectWithValue({ error: result.data.errorMessage });
      }
    } catch (error) {
      console.error(
        "try catch [ GetPincodeLatLongGST ] error.message >>",
        error.message
      );
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

// GetIECPincodeLatLong
export const GetPincodeLatLongIEC = createAsyncThunk(
  "GetPincodeLatLongIEC",
  async (userdata, thunkAPI) => {
    try {
      let result = await axios({
        method: "GET",
        baseURL: CONFIG.BASE_URL_ALL,
        url: `IEC/GetIECDetailsByPinCode`,
        headers: Service.infoDataHead(),
        params: userdata,
      });
      if (result.data.success) {
        return result.data;
      } else {
        return thunkAPI.rejectWithValue({ error: result.data.errorMessage });
      }
    } catch (error) {
      console.error(
        "try catch [ GetPincodeLatLongIEC ] error.message >>",
        error.message
      );
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);
export const Panverify = createAsyncThunk(
  "Panverify",
  async (userdata, thunkAPI) => {
    try {
      let result = await axios({
        method: "GET",
        baseURL: CONFIG.BASE_URL_ALL,
        url: `/GST/panverify`,
        headers: Service.infoDataHead(),
        params: userdata,
      });
      if (result.data.success) {
        return result.data;
      } else {
        return thunkAPI.rejectWithValue({ error: result.data.errorMessage });
      }
    } catch (error) {
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);
export const Emailverify = createAsyncThunk(
  "Emailverify",
  async (userdata, thunkAPI) => {
    try {
      let result = await axios({
        method: "GET",
        baseURL: CONFIG.BASE_URL_ALL,
        url: `/PortalAdmin/emailverify`,
        headers: Service.infoDataHead(),
        params: userdata,
      });
      if (result?.data?.success) {
        return result.data;
      } else {
        return thunkAPI.rejectWithValue({ error: result.data });
      }
    } catch (error) {
      console.error(
        "try catch [ Emailverify ] error.message >>",
        error.message
      );
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);
export const Gstverify = createAsyncThunk(
  "Gstverify",
  async (userdata, thunkAPI) => {
    try {
      let result = await axios({
        method: "GET",
        baseURL: CONFIG.BASE_URL_ALL,
        url: `/GST/gstverify`,
        headers: Service.infoDataHead(),
        params: userdata,
      });
      return result.data;
    } catch (error) {
      console.error("try catch [ Gstverify ] error.message >>", error.message);
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

// -------------
export const Gstsearch = createAsyncThunk(
  "Gstsearch",
  async (userdata, thunkAPI) => {
    try {
      // let result = await axios({
      //   method: "GET",
      //   baseURL: CONFIG.BASE_URL_ALL,
      //   url: `/GST/gstsearch`,
      //   headers: Service.infoDataHead(),
      //   params: userdata,
      // });
      let result = await axios({
        method: "POST",
        baseURL: CONFIG.BASE_URL_ALL,
        url: `GST/GSTAdvanceSearch`,
        headers: Service.infoDataHead(),
        data: {
          "gstNumber": userdata.gstin,
          "hsnDetails": true,
          "branchDetails": true,
          "filingDetails": true,
          "filingFrequency": true,
          "liabilityPaidDetails": true
        },
      });

      if (result?.data?.success) {
        return result.data.data;
      } else {
        return thunkAPI.rejectWithValue({ error: result.data.errorMessage });
      }
    } catch (error) {
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);
export const GetMasterDataList = createAsyncThunk(
  "GetMasterDataList",
  async (_, thunkAPI) => {
    try {
      let result = await axios({
        method: "GET",
        baseURL: CONFIG.BASE_URL_ALL,
        url: `GST/GetMasterDataList`,
        headers: Service.infoDataHead(),
      });

      if (result?.data?.success) {
        return result.data;
      } else {
        return thunkAPI.rejectWithValue({ error: result.data.errorMessage });
      }
    } catch (error) {
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);
// MobileToMultipleUPI
export const MobileToMultipleUPI = createAsyncThunk(
  "MobileToMultipleUPI",
  async (userdata, thunkAPI) => {
    try {
      let result = await axios({
        method: "GET",
        baseURL: CONFIG.BASE_URL_ALL,
        url: `GST/MobileToMultipleUPI`,
        headers: Service.infoDataHead(),
        params: userdata,
      });
      if (result?.data?.success) {
        return result.data.data;
      } else {
        return thunkAPI.rejectWithValue({ error: result.data.errorMessage });
      }
    } catch (error) {
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);
// -------------
export const GstsearchRefreshDetails = createAsyncThunk(
  "GstsearchRefreshDetails",
  async (userdata, thunkAPI) => {
    try {
      let result = await axios({
        method: "POST",
        baseURL: CONFIG.BASE_URL_ALL,
        url: `GST/RefreshGSTAdvanceSearch`,
        headers: Service.infoDataHead(),
        data: {
          "gstNumber": userdata.gstin,
          "hsnDetails": true,
          "branchDetails": true,
          "filingDetails": true,
          "filingFrequency": true,
          "liabilityPaidDetails": true
        },
      });

      if (result?.data?.success) {
        return result.data.data;
      } else {
        return thunkAPI.rejectWithValue({ error: result.data.errorMessage });
      }
    } catch (error) {
      console.error("Error in [GstsearchRefreshDetails] Try Catch:", error);

      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);
// -------------RefreshDINDetails
export const RefreshCinDINDetails = createAsyncThunk(
  "RefreshCinDINDetails",
  async (userdata, thunkAPI) => {
    try {
      let result = await axios({
        method: "GET",
        baseURL: CONFIG.BASE_URL_ALL,
        url: `CIN/RefreshDINDetails`,
        headers: Service.infoDataHead(),
        params: userdata,
      });

      if (result?.data?.success) {
        return result.data.data;
      } else {
        return thunkAPI.rejectWithValue({ error: result.data.errorMessage });
      }
    } catch (error) {
      console.error("Error in [RefreshCinDINDetails] Try Catch:", error);

      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);
// -------------RefreshDINDetailsByDIN
export const RefreshDINDetailsByDIN = createAsyncThunk(
  "RefreshDINDetailsByDIN",
  async (userdata, thunkAPI) => {
    try {
      let result = await axios({
        method: "GET",
        baseURL: CONFIG.BASE_URL_ALL,
        url: `CIN/RefreshDINDetailsByDIN`,
        headers: Service.infoDataHead(),
        params: userdata,
      });

      if (result?.data?.success) {
        return result.data.data;
      } else {
        return thunkAPI.rejectWithValue({ error: result.data.errorMessage });
      }
    } catch (error) {
      console.error("Error in [RefreshDINDetailsByDIN] Try Catch:", error);

      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);
// UpdateProfile
export const UpdateProfile = createAsyncThunk(
  "UpdateProfile",
  async (userdata, thunkAPI) => {
    try {
      let result = await axios({
        method: "POST",
        baseURL: CONFIG.BASE_URL_LOGIN,
        url: `user/edit/information`,
        headers: authheaderFormData,
        data: userdata,
      });
      if (result?.data?.success) {
        return result.data;
      } else {
        return thunkAPI.rejectWithValue({ error: result.data.errorMessage });
      }
    } catch (error) {
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);
// Mobile360 OSINT
export const Mobile360 = createAsyncThunk(
  "Mobile360",
  async (userdata, thunkAPI) => {
    try {
      let result = await axios({
        method: "GET",
        baseURL: CONFIG.BASE_URL_ALL,
        url: `IEC/GetAllMobile360Detail`,
        headers: Service.infoDataHead(),
        params: userdata,
      });
      if (result.data) {
        if (result?.data?.success) {
          return result.data.data;
        }
      } else {
        return thunkAPI.rejectWithValue({ error: result.data.errorMessage });
      }
    } catch (error) {
      console.error("try catch [ Mobile360 ] error.message >>", error.message);
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);
// OSINT/GetFactAppInfoByPhone OSINT
export const GetFactAppInfoByPhone = createAsyncThunk(
  "GetFactAppInfoByPhone",
  async (userdata, thunkAPI) => {
    try {
      let result = await axios({
        method: "GET",
        baseURL: CONFIG.BASE_URL_ALL,
        url: `OSINT/GetFactAppInfoByPhone`,
        headers: await Service.infoDataHead(authheaderTockenAndHed),
        params: userdata,
      });
      if (result.data) {
        if (result?.data?.success) {
          if (result.data.data.id) {
            return result?.data.data;
          } else {
            return JSON.parse(result?.data?.data);
          }
        } else {
          return thunkAPI.rejectWithValue({ error: result.data.errorMessage });
        }
      } else {
        return thunkAPI.rejectWithValue({ error: result.data.errorMessage });
      }
    } catch (error) {
      console.error(
        "try catch [ GetFactAppInfoByPhone ] error.message >>",
        error.message
      );
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);
// OSINT/GetFactAppInfoMoreByPhone
export const GetFactAppInfoMoreByPhone = createAsyncThunk(
  "GetFactAppInfoMoreByPhone",
  async (userdata, thunkAPI) => {
    try {
      let result = await axios({
        method: "GET",
        baseURL: CONFIG.BASE_URL_ALL,
        url: `OSINT/GetFactAppInfoMoreByPhone`,
        headers: await Service.infoDataHead(authheaderTockenAndHed),
        params: userdata,
      });
      if (result.data) {
        if (result?.data?.success) {
          if (result.data.data.id) {
            return result?.data.data;
          } else {
            return JSON.parse(result?.data?.data);
          }
        } else {
          return thunkAPI.rejectWithValue({ error: result.data.errorMessage });
        }
      } else {
        return thunkAPI.rejectWithValue({ error: result.data.errorMessage });
      }
    } catch (error) {
      console.error(
        "try catch [ GetFactAppInfoMoreByPhone ] error.message >>",
        error.message
      );
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);
// OSINT/GetFactAppInfoByEmail
export const GetFactAppInfoByEmail = createAsyncThunk(
  "GetFactAppInfoByEmail",
  async (userdata, thunkAPI) => {
    try {
      let result = await axios({
        method: "GET",
        baseURL: CONFIG.BASE_URL_ALL,
        url: `OSINT/GetFactAppInfoByEmail`,
        headers: await Service.infoDataHead(authheaderTockenAndHed),
        params: userdata,
      });
      if (result.data) {
        if (result?.data?.success) {
          if (result.data.data.id) {
            return result?.data.data;
          } else {
            return JSON.parse(result?.data?.data);
          }
        } else {
          return thunkAPI.rejectWithValue({ error: result.data.errorMessage });
        }
      } else {
        return thunkAPI.rejectWithValue({ error: result.data.errorMessage });
      }
    } catch (error) {
      console.error(
        "try catch [ GetFactAppInfoByEmail ] error.message >>",
        error.message
      );
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);
// OSINT/GetFactAppInfoMoreByEmail
export const GetFactAppInfoMoreByEmail = createAsyncThunk(
  "GetFactAppInfoMoreByEmail",
  async (userdata, thunkAPI) => {
    try {
      let result = await axios({
        method: "GET",
        baseURL: CONFIG.BASE_URL_ALL,
        url: `OSINT/GetFactAppInfoMoreByEmail`,
        headers: await Service.infoDataHead(authheaderTockenAndHed),
        params: userdata,
      });
      if (result.data) {
        if (result?.data?.success) {
          if (result.data.data.id) {
            return result?.data.data;
          } else {
            return JSON.parse(result?.data?.data);
          }
        } else {
          return thunkAPI.rejectWithValue({ error: result.data.errorMessage });
        }
      } else {
        return thunkAPI.rejectWithValue({ error: result.data.errorMessage });
      }
    } catch (error) {
      console.error(
        "try catch [ GetFactAppInfoMoreByEmail ] error.message >>",
        error.message
      );
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);
// OSINT/GetFactAppInfoByUserName
export const GetFactAppInfoByUserName = createAsyncThunk(
  "GetFactAppInfoByUserName",
  async (userdata, thunkAPI) => {
    try {
      let result = await axios({
        method: "GET",
        baseURL: CONFIG.BASE_URL_ALL,
        url: `OSINT/GetFactAppInfoByUserName`,
        headers: Service.infoDataHead(),
        params: userdata,
      });
      if (result.data) {
        if (result?.data?.success) {
          return result?.data;
        } else {
          return thunkAPI.rejectWithValue({ error: result.data.errorMessage });
        }
      } else {
        return thunkAPI.rejectWithValue({ error: result.data.errorMessage });
      }
    } catch (error) {
      console.error(
        "try catch [ GetFactAppInfoByUserName ] error.message >>",
        error.message
      );
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

// GetCoordinates
export const GetCoordinates = createAsyncThunk(
  "GetCoordinates",

  async (userdata, thunkAPI) => {
    try {
      let result = await axios({
        method: "GET",
        baseURL: `https://maps.googleapis.com/maps/api/geocode/json?address=${userdata.address}&key=${CONFIG.MAPS_APIKEY}`,
      });

      if (result?.data?.results) {
        let LantLong = result.data.results[0].geometry.location;
        return { ...LantLong, cinname: userdata.cin };
      } else {
        return thunkAPI.rejectWithValue({ error: result.data.errorMessage });
      }
    } catch (error) {
      console.error(
        "try catch [ GetCoordinates ] error.message >>",
        error.message
      );
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);
// Cin
export const Cin = createAsyncThunk("Cin", async (userdata, thunkAPI) => {
  try {
    let result = await axios({
      method: "GET",
      baseURL: CONFIG.BASE_URL_ALL,
      // url: `/CIN/CINDetails`,
      url: `/CIN/NewCINDetails`,
      headers: Service.infoDataHead(),
      params: userdata,
    });
    if (result.data) {
      if (result?.data?.success) {
        return result.data.data;
      }
    } else {
      return thunkAPI.rejectWithValue({ error: result.data.errorMessage });
    }
  } catch (error) {
    console.error("try catch [ Cin ] error.message >>", error.message);
    return thunkAPI.rejectWithValue({ error: error.message });
  }
});
// DarpanSearchApi
export const DarpanSearchApi = createAsyncThunk(
  "DarpanSearchApi",
  async (userdata, thunkAPI) => {
    try {
      let result = await axios({
        method: "GET",
        baseURL: CONFIG.BASE_URL_ALL,
        url: `DARPAN/GetDARPANDetail`,
        headers: Service.infoDataHead(),
        params: userdata,
      });
      if (result.data) {
        if (result?.data?.success) {
          return result.data;
        }
      } else {
        return thunkAPI.rejectWithValue({ error: result.data.errorMessage });
      }
    } catch (error) {
      console.error("try catch [ DarpanSearchApi ] error.message >>", error.message);
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  });
// GetDarpanDashboardData
export const GetDarpanDashboardData = createAsyncThunk(
  "GetDarpanDashboardData",
  async (_, thunkAPI) => {
    try {
      let result = await axios({
        method: "GET",
        baseURL: CONFIG.BASE_URL_DARPAN,
        url: `DARPAN/GetDarpanDashboardData`,
        headers: Service.infoDataHead(),
      });
      if (result.data) {
        if (result?.data?.success) {
          return result.data;
        }
      } else {
        return thunkAPI.rejectWithValue({ error: result.data.errorMessage });
      }
    } catch (error) {
      console.error("try catch [ GetDarpanDashboardData ] error.message >>", error.message);
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  });
// GetIECDashboardData
export const GetIECDashboardData = createAsyncThunk(
  "GetIECDashboardData",
  async (_, thunkAPI) => {
    try {
      let result = await axios({
        method: "GET",
        baseURL: CONFIG.BASE_URL_IEC,
        url: `IEC/GetIECDashboardData`,
        headers: Service.infoDataHead(),
      });
      if (result.data) {
        if (result?.data?.success) {
          return result.data;
        }
      } else {
        return thunkAPI.rejectWithValue({ error: result.data.errorMessage });
      }
    } catch (error) {
      console.error("try catch [ GetIECDashboardData ] error.message >>", error.message);
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  });
// api/Darpan/GetFileLogListByUserName
export const GetFileLogListByUserName = createAsyncThunk(
  "GetFileLogListByUserName",
  async (userdata, thunkAPI) => {
    try {
      let result = await axios({
        method: "GET",
        baseURL: CONFIG.BASE_URL_ALL,
        url: `CIN/GetFileLogListByUserName`,
        headers: Service.infoDataHead(),
        params: userdata,
      });
      if (result.data) {
        if (result?.data?.success) {
          return result.data;
        }
      } else {
        return thunkAPI.rejectWithValue({ error: result.data.errorMessage });
      }
    } catch (error) {
      console.error("try catch [ GetFileLogListByUserName ] error.message >>", error.message);
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  });
//SearchCINByAdvanceSearch
export const SearchCINByAdvanceSearch = createAsyncThunk(
  "SearchCINByAdvanceSearch",
  async (userdata, thunkAPI) => {
    try {
      let result = await axios({
        method: "POST",
        baseURL: CONFIG.BASE_URL_ALL,
        url: `CIN/SearchCINByAdvanceSearch`,
        headers: Service.infoDataHead(),
        data: userdata,
      });

      if (result.data) {
        if (result?.data?.success) {
          return result.data.data;
        } else {
          return thunkAPI.rejectWithValue({ error: result.data.errorMessage });
        }
      }
    } catch (error) {
      console.error(
        "try catch [ SearchCINByAdvanceSearch ] error.message >>",
        error.message
      );
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);
//DesboadSearchCINByAdvanceSearch
export const DesboadSearchCINByAdvanceSearch = createAsyncThunk(
  "DesboadSearchCINByAdvanceSearch",
  async (userdata, thunkAPI) => {
    try {
      let result = await axios({
        method: "POST",
        baseURL: CONFIG.BASE_URL_ALL,
        url: `EPFO/GetGSTCINMasterDataList`,
        headers: Service.infoDataHead(),
        data: userdata,
      });

      if (result.data) {
        if (result?.data?.success) {
          return result.data;
        } else {
          return thunkAPI.rejectWithValue({ error: result.data.errorMessage });
        }
      }
    } catch (error) {
      console.error(
        "try catch [ DesboadSearchCINByAdvanceSearch ] error.message >>",
        error.message
      );
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);
//SearchGSTByAdvanceSearch
export const SearchGSTByAdvanceSearch = createAsyncThunk(
  "SearchGSTByAdvanceSearch",
  async (userdata, thunkAPI) => {
    try {
      let result = await axios({
        method: "POST",
        baseURL: CONFIG.BASE_URL_ALL,
        url: `GST/SearchGSTByAdvanceSearch`,
        headers: Service.infoDataHead(),
        data: userdata,
      });

      if (result.data) {
        if (result?.data?.success) {
          return { ...result.data.data, userdata: userdata };
        }
      } else {
        return thunkAPI.rejectWithValue({ error: result.data.errorMessage });
      }
    } catch (error) {
      console.error(
        "try catch [ SearchGSTByAdvanceSearch ] error.message >>",
        error.message
      );
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

//DesboadSearchGSTByAdvanceSearch
export const DesboadSearchGSTByAdvanceSearch = createAsyncThunk(
  "DesboadSearchGSTByAdvanceSearch",
  async (userdata, thunkAPI) => {
    try {
      let result = await axios({
        method: "POST",
        baseURL: CONFIG.BASE_URL_ALL,
        url: `GST/SearchGSTByAdvanceSearch`,
        headers: Service.infoDataHead(),
        data: userdata,
      });

      if (result.data) {
        if (result?.data?.success) {
          return result.data;
        }
      } else {
        return thunkAPI.rejectWithValue({ error: result.data.errorMessage });
      }
    } catch (error) {
      console.error(
        "try catch [ DesboadSearchGSTByAdvanceSearch ] error.message >>",
        error.message
      );
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);
//SearchGSTByAdvanceSearchMore
export const SearchGSTByAdvanceSearchMore = createAsyncThunk(
  "SearchGSTByAdvanceSearchMore",
  async (userdata, thunkAPI) => {
    try {
      let result = await axios({
        method: "POST",
        baseURL: CONFIG.BASE_URL_ALL,
        url: `GST/SearchGSTByAdvanceSearch`,
        headers: Service.infoDataHead(),
        data: userdata,
      });

      if (result.data) {
        if (result?.data?.success) {
          return result.data.data;
        }
      } else {
        return thunkAPI.rejectWithValue({ error: result.data.errorMessage });
      }
    } catch (error) {
      console.error(
        "try catch [ SearchGSTByAdvanceSearchMore ] error.message >>",
        error.message
      );
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);
//CinGetIndustryList
export const CinGetIndustryList = createAsyncThunk(
  "CinGetIndustryList",
  async (userdata, thunkAPI) => {
    try {
      let result = await axios({
        method: "GET",
        baseURL: CONFIG.BASE_URL_ALL,
        url: `CIN/GetIndustryList`,
        headers: Service.infoDataHead(),
        params: userdata,
      });
      if (result.data) {
        if (result?.data?.success) {
          return result.data.data;
        }
      } else {
        return thunkAPI.rejectWithValue({ error: result.data.errorMessage });
      }
    } catch (error) {
      console.error(
        "try catch [ CinGetIndustryList ] error.message >>",
        error.message
      );
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);
export const CinGetSegmentList = createAsyncThunk(
  "CinGetSegmentList",
  async (userdata, thunkAPI) => {
    try {
      let result = await axios({
        method: "GET",
        baseURL: CONFIG.BASE_URL_ALL,
        url: `CIN/GetSegmentList`,
        headers: Service.infoDataHead(),
        params: userdata,
      });
      if (result.data) {
        if (result?.data?.success) {
          return result.data.data;
        }
      } else {
        return thunkAPI.rejectWithValue({ error: result.data.errorMessage });
      }
    } catch (error) {
      console.error(
        "try catch [ CinGetSegmentList ] error.message >>",
        error.message
      );
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);
// CinRefreshCINDetails
export const CinRefreshCINDetails = createAsyncThunk(
  "CinRefreshCINDetails",
  async (userdata, thunkAPI) => {
    try {
      let result = await axios({
        method: "GET",
        baseURL: CONFIG.BASE_URL_ALL,
        // url: `CIN/RefreshCINDetails`,
        url: `CIN/RefreshNewCINDetails`,
        headers: Service.infoDataHead(),
        params: userdata,
      });
      if (result.data) {
        if (result?.data?.success) {
          return result.data;
        }
      } else {
        return thunkAPI.rejectWithValue({ error: result.data.errorMessage });
      }
    } catch (error) {
      console.error(
        "try catch [ CinRefreshCINDetails ] error.message >>",
        error.message
      );
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);
// GetGSTCINDetailByEmail
export const GetGSTCINDetailByEmail = createAsyncThunk(
  "GetGSTCINDetailByEmail",
  async (userdata, thunkAPI) => {
    try {
      let result = await axios({
        method: "GET",
        baseURL: CONFIG.BASE_URL_ALL,
        url: `GST/GetGSTCINDetailByEmail`,
        headers: Service.infoDataHead(),
        params: userdata,
      });
      if (result.data) {
        if (result?.data?.success) {
          return result.data;
        }
      } else {
        return thunkAPI.rejectWithValue({ error: result.data.errorMessage });
      }
    } catch (error) {
      console.error(
        "try catch [ GetGSTCINDetailByEmail ] error.message >>",
        error.message
      );
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);
// Din
export const Din = createAsyncThunk("Din", async (userdata, thunkAPI) => {
  try {
    let result = await axios({
      method: "GET",
      baseURL: CONFIG.BASE_URL_ALL,
      url: `/CIN/DINDetails`,
      headers: Service.infoDataHead(),
      params: userdata,
    });
    if (result.data) {
      if (result?.data?.success) {
        return result.data.data;
      }
    } else {
      return thunkAPI.rejectWithValue({ error: result.data.errorMessage });
    }
  } catch (error) {
    console.error("try catch [ Din ] error.message >>", error.message);
    return thunkAPI.rejectWithValue({ error: error.message });
  }
});
// IESDetailApi
export const IESDetailApi = createAsyncThunk(
  "IESDetailApi",
  async (userdata, thunkAPI) => {
    try {
      let result = await axios({
        method: "GET",
        baseURL: CONFIG.BASE_URL_ALL,
        url: `IEC/GetIECDetail`,
        headers: Service.infoDataHead(),
        params: userdata,
      });
      if (result.data) {
        if (result?.data?.success) {
          return { ...result.data.data, snumber: userdata.searchNumber };
        }
      } else {
        return thunkAPI.rejectWithValue({ error: result.data.errorMessage });
      }
    } catch (error) {
      console.error(
        "try catch [ IESDetailApi ] error.message >>",
        error.message
      );
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);
// MSME
export const Msme = createAsyncThunk("Msme", async (userdata, thunkAPI) => {
  try {
    let result = await axios({
      method: "GET",
      baseURL: CONFIG.BASE_URL_ALL,
      url: `/MSME/GetMSMEDetail`,
      headers: Service.infoDataHead(),
      params: userdata,
    });
    if (result.data) {
      if (result?.data?.success) {
        return result.data.data;
      }
    } else {
      return thunkAPI.rejectWithValue({ error: result.data.errorMessage });
    }
  } catch (error) {
    console.error("try catch [ Msme ] error.message >>", error.message);
    return thunkAPI.rejectWithValue({ error: error.message });
  }
});
// MsmeRefreshDetails
export const MsmeRefreshDetails = createAsyncThunk(
  "MsmeRefreshDetails",

  async (userdata, thunkAPI) => {
    try {
      let result = await axios({
        method: "GET",
        baseURL: CONFIG.BASE_URL_ALL,
        url: `MSME/RefreshMSMEDetail`,
        headers: Service.infoDataHead(),
        params: userdata,
      });
      if (result.data) {
        if (result?.data?.success) {
          return result.data.data;
        }
      } else {
        return thunkAPI.rejectWithValue({ error: result.data.errorMessage });
      }
    } catch (error) {
      console.error(
        "try catch [ MsmeRefreshDetails ] error.message >>",
        error.message
      );
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);
// MobileToMSME
export const MobileToMSME = createAsyncThunk(
  "MobileToMSME",
  async (userdata, thunkAPI) => {
    try {
      let result = await axios({
        method: "GET",
        baseURL: CONFIG.BASE_URL_ALL,
        url: `MSME/MobileToMSME`,
        headers: Service.infoDataHead(),
        params: userdata,
      });
      if (result.data) {
        if (result?.data?.success) {
          return result.data;
        }
      } else {
        return thunkAPI.rejectWithValue({ error: result.data.errorMessage });
      }
    } catch (error) {
      console.error("try catch [ Msme ] error.message >>", error.message);
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);
// CINDetailsByDate
export const CINDetailsByDate = createAsyncThunk(
  "CINDetailsByDate",
  async (userdata, thunkAPI) => {
    try {
      let result = await axios({
        method: "GET",
        baseURL: CONFIG.BASE_URL_ALL,
        url: `CIN/CINDetailsByDate`,
        headers: Service.infoDataHead(),
        params: userdata,
      });
      if (result?.data?.success) {
        return result.data.data;
      } else {
        return thunkAPI.rejectWithValue({ error: result.data.errorMessage });
      }
    } catch (error) {
      console.error("try catch [ Msme ] error.message >>", error.message);
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);
// /api/CIN/GetCINAddressByPin
export const GetCINAddressByPin = createAsyncThunk(
  "GetCINAddressByPin",
  async (userdata, thunkAPI) => {
    try {
      let result = await axios({
        method: "GET",
        baseURL: CONFIG.BASE_URL_ALL,
        url: `CIN/GetCINAddressByPin`,
        headers: Service.infoDataHead(),
        params: userdata,
      });
      if (result?.data?.success) {
        return result.data;
      } else {
        return thunkAPI.rejectWithValue({ error: result.data.errorMessage });
      }
    } catch (error) {
      console.error(
        "try catch [ GetCINAddressByPin ] error.message >>",
        error.message
      );
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);
// GetPincodeLatLong/
export const GetPincodeLatLong = createAsyncThunk(
  "GetPincodeLatLong",
  async (userdata, thunkAPI) => {
    try {
      let result = await axios({
        method: "GET",
        baseURL: `https://maps.googleapis.com/maps/api/geocode/json?latlng=${userdata.latitude},${userdata.longitude}&key=${CONFIG.MAPS_APIKEY}`,
        // url: `get-pincode/`,
        // data: userdata,
      });

      if (result?.data.results) {
        return result.data.results;
      } else {
        return thunkAPI.rejectWithValue({ error: result.data.errorMessage });
      }
    } catch (error) {
      console.error(
        "try catch [ GetPincodeLatLong ] error.message >>",
        error.message
      );
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

// PanSearch
export const PanSearch = createAsyncThunk(
  "PanSearch",
  async (userdata, thunkAPI) => {
    try {
      let result = await axios({
        method: "GET",
        baseURL: CONFIG.BASE_URL_ALL,
        url: `/GST/PANAllDetail`,
        headers: Service.infoDataHead(),
        params: userdata,
      });
      if (result?.data?.success) {
        return result.data.data;
      } else {
        return thunkAPI.rejectWithValue({ error: result.data.errorMessage });
      }
    } catch (error) {
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

// PansearchRefreshDetails
export const PansearchRefreshDetails = createAsyncThunk(
  "PansearchRefreshDetails",
  async (userdata, thunkAPI) => {
    try {
      let result = await axios({
        method: "GET",
        baseURL: CONFIG.BASE_URL_ALL,
        // url: `/GST/RefreshPANSearch`,
        url: `/GST/RefreshPANAllDetail`,
        headers: Service.infoDataHead(),
        params: userdata,
      });
      if (result?.data?.success) {
        return result.data.data;
      } else {
        return thunkAPI.rejectWithValue({ error: result.data.errorMessage });
      }
    } catch (error) {
      console.error(
        "try catch [ PansearchRefreshDetails ] error.message >>",
        error.message
      );
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);
// GetMCAReport
export const GetMCAReport = createAsyncThunk(
  "GetMCAReport",
  async (userdata, thunkAPI) => {
    try {
      let result = await axios({
        method: "GET",
        baseURL: CONFIG.BASE_URL_ALL,
        url: `CIN/GetMCAReport`,
        headers: await Service.infoDataHead(authheaderUser),
        params: userdata,
      });
      console.log("result?.data?", result?.data);
      if (result?.data?.success) {
        return JSON.parse(result?.data?.data);
      } else {
        return thunkAPI.rejectWithValue({ error: result.data.errorMessage });
      }
    } catch (error) {
      console.error("try catch [ PanSearch ] error.message >>", error.message);
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);
// GetNewGSTList
export const GetNewGSTList = createAsyncThunk(
  "GetNewGSTList",
  async ({ token, inputdate }, thunkAPI) => {
    try {
      let result = await axios({
        method: "GET",
        baseURL: CONFIG.BASE_URL_ALL,
        url: `/GST/GetNewGSTList`,
        headers: Service.infoDataHead(),
        params: { token, inputdate },
      });
      if (result.data) {
        if (result?.data?.success) {
          return result.data;
        }
      } else {
        return thunkAPI.rejectWithValue({ error: result.data.errorMessage });
      }
    } catch (error) {
      console.error(
        "try catch [ GetNewGSTList ] error.message >>",
        error.message
      );
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);
// GetNewGSTDetail
export const GetNewGSTDetail = createAsyncThunk(
  "GetNewGSTDetail",
  async ({ token, gstNumber }, thunkAPI) => {
    try {
      let result = await axios({
        method: "GET",
        baseURL: CONFIG.BASE_URL_ALL,
        url: `/GST/GetNewGSTDetail`,
        headers: Service.infoDataHead(),
        params: { token, gstNumber },
      });
      if (result.data) {
        if (result?.data?.success) {
          return result.data;
        }
      } else {
        return thunkAPI.rejectWithValue({ error: result.data.errorMessage });
      }
    } catch (error) {
      console.error(
        "try catch [ GetNewGSTDetail ] error.message >>",
        error.message
      );
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);
// GstContact
export const GstContact = createAsyncThunk(
  "GstContact",
  async ({ gstin }, thunkAPI) => {
    try {
      let result = await axios({
        method: "GET",
        baseURL: CONFIG.BASE_URL_ALL,
        url: `/GST/gstContact`,
        headers: Service.infoDataHead(),
        params: { gstin },
      });
      if (result.data) {
        if (result?.data?.success) {
          return result.data;
        }
      } else {
        return thunkAPI.rejectWithValue({ error: result.data.errorMessage });
      }
    } catch (error) {
      console.error("try catch [ GstContact ] error.message >>", error.message);
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);
// BankPincode
export const BankPincode = createAsyncThunk(
  "BankPincode",
  async (userdata, thunkAPI) => {
    try {
      let result = await axios({
        method: "POST",
        baseURL: CONFIG.BASE_URL_ALL,
        url: `EPFO/GetAllBankDetailByPincodeSearch`,
        headers: Service.infoDataHead(),
        data: userdata,
      });
      if (result.data) {
        if (result?.data?.success) {
          return result.data;
        }
      } else {
        return thunkAPI.rejectWithValue({ error: result.data.errorMessage });
      }
    } catch (error) {
      console.error("try catch [ BankPincode ] error.message >>", error.message);
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

export const GetBankMasterDataList = createAsyncThunk(
  "GetBankMasterDataList",
  async (userdata, thunkAPI) => {
    try {
      let result = await axios({
        method: "POST",
        baseURL: CONFIG.BASE_URL_ALL,
        url: `EPFO/GetBankMasterDataList`,
        headers: Service.infoDataHead(),
        data: userdata,
      });
      if (result.data) {
        if (result?.data?.success) {
          return result.data;
        }
      } else {
        return thunkAPI.rejectWithValue({ error: result.data.errorMessage });
      }
    } catch (error) {
      console.error("try catch [ GetBankMasterDataList ] error.message >>", error.message);
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

export const GetPopulationMasterDataList = createAsyncThunk(
  "GetPopulationMasterDataList",
  async (userdata, thunkAPI) => {
    try {
      let result = await axios({
        method: "POST",
        baseURL: CONFIG.BASE_URL_ALL,
        url: `EPFO/GetPopulationMasterDataList`,
        headers: Service.infoDataHead(),
        data: userdata,
      });
      if (result.data) {
        if (result?.data?.success) {
          return result.data;
        }
      } else {
        return thunkAPI.rejectWithValue({ error: result.data.errorMessage });
      }
    } catch (error) {
      console.error("try catch [ GetBankMasterDataList ] error.message >>", error.message);
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

export const GetBankDependentDropdown = createAsyncThunk(
  "GetBankDependentDropdown",
  async (userdata, thunkAPI) => {
    try {
      let result = await axios({
        method: "POST",
        baseURL: CONFIG.BASE_URL_ALL,
        url: `EPFO/GetBankDependentDropdown`,
        headers: Service.infoDataHead(),
        data: userdata,
      });
      if (result.data) {
        if (result?.data?.success) {
          return result.data;
        }
      } else {
        return thunkAPI.rejectWithValue({ error: result.data.errorMessage });
      }
    } catch (error) {
      console.error("try catch [ GetBankDependentDropdown ] error.message >>", error.message);
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

export const GetFTIReportRequestList = createAsyncThunk(
  "GetFTIReportRequestList",
  async (userdata, thunkAPI) => {
    try {
      let result = await axios({
        method: "GET",
        baseURL: CONFIG.BASE_URL_ALL,
        url: `IEC/GetFTIReportRequestList`,
        headers: Service.infoDataHead({ accept: "*/*" }),
        params: userdata,
      });
      if (result.data) {
        if (result?.data?.success) {
          return result.data;
        }
      } else {
        return thunkAPI.rejectWithValue({ error: result.data.errorMessage });
      }
    } catch (error) {
      console.error("try catch [ GetFTIReportRequestList ] error.message >>", error.message);
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

export const ViewFTIReport = createAsyncThunk(
  "ViewFTIReport",
  async (userdata, thunkAPI) => {
    try {
      let result = await axios({
        method: "GET",
        baseURL: CONFIG.BASE_URL_ALL,
        url: `IEC/ViewFTIReport`,
        headers: Service.infoDataHead({ accept: "*/*" }),
        params: userdata,
      });
      if (result.data) {
        if (result?.data?.success) {
          return result.data;
        }
      } else {
        return thunkAPI.rejectWithValue({ error: result.data.errorMessage });
      }
    } catch (error) {
      console.error("try catch [ ViewFTIReport ] error.message >>", error.message);
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

export const CreateFTIReport = createAsyncThunk(
  "CreateFTIReport",
  async (userdata, thunkAPI) => {
    try {
      let result = await axios({
        method: "GET",
        baseURL: CONFIG.BASE_URL_ALL,
        url: `IEC/CreateFTIReportNew`,
        headers: Service.infoDataHead({ accept: "*/*" }),
        params: userdata,
      });
      if (result.data) {
        if (result?.data?.success) {
          return result.data;
        }
      } else {
        return thunkAPI.rejectWithValue({ error: result.data.errorMessage });
      }
    } catch (error) {
      console.error("try catch [ CreateFTIReport ] error.message >>", error.message);
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

export const GetPopulationDependentDropdown = createAsyncThunk(
  "GetPopulationDependentDropdown",
  async (userdata, thunkAPI) => {
    try {
      let result = await axios({
        method: "POST",
        baseURL: CONFIG.BASE_URL_ALL,
        url: `EPFO/GetPopulationDependentDropdown`,
        headers: Service.infoDataHead(),
        data: userdata,
      });
      if (result.data) {
        if (result?.data?.success) {
          return result.data;
        }
      } else {
        return thunkAPI.rejectWithValue({ error: result.data.errorMessage });
      }
    } catch (error) {
      console.error("try catch [ GetPopulationDependentDropdown ] error.message >>", error.message);
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);
// // TokenVerify
// export const TokenVerify = createAsyncThunk(
//   "TokenVerify",
//   async (userdata, thunkAPI) => {
//     try {
//       let result = await axios({
//         method: "POST",
//         baseURL: CONFIG.BASE_URL_LOGIN,
//         url: `verify/token`,
//         data: userdata,
//       });
//       if (result.data) {
//         if (result?.data?.success) {
//           return result.data;
//         }
//       } else {
//         console.log("result.data", result.data.errorMessage);
//         // return thunkAPI.rejectWithValue({ error: result.data.errorMessage });
//       }
//     } catch (error) {
//       console.log("error", error);
//       // console.error(
//       //   "try catch [ TokenVerify ] error.message >>",
//       //   error.message
//       // );
//       // return thunkAPI.rejectWithValue({ error: error.message });
//     }
//   }
// );
// Ewallet
export const Ewallet = createAsyncThunk(
  "Ewallet",
  async (userdata, thunkAPI) => {
    try {
      if (userdata.apiFeature) {
        let result = await axios({
          method: "POST",
          headers: await Service.GetAuthHeader(),
          baseURL: CONFIG.BASE_URL_LOGIN,
          url: `credit/check`,
          data: userdata,
        });
        if (result.data.success) {
          await Service.setCredit(result.data.credit);
          let existdata = result.data;
          let maindata = {
            ...existdata,
            productvname: userdata.productName,
            value: userdata?.value || userdata?.MoreValue?.panNumber || "",
            MoreValue: userdata?.MoreValue,
          };
          return maindata;
        } else {
          return thunkAPI.rejectWithValue({ error: result.data });
        }
      } else {
        return thunkAPI.rejectWithValue({ error: `${Infodata.InfoByApiFichar}` });
      }
    } catch (error) {
      console.error("try catch [ Ewallet ] error.message >>", error);
      return thunkAPI.rejectWithValue({ error: error });
    }
  }
);
// Popularsearch
export const Popularsearch = createAsyncThunk(
  "Popularsearch",
  async (thunkAPI) => {
    try {
      let result = await axios({
        method: "GET",
        // headers: await Service.GetAuthHeader(),
        baseURL: CONFIG.BASE_URL_LOGIN,
        url: `maximum/hit`,
      });

      if (result.data.success) {
        return result.data.data;
      } else {
        return thunkAPI.rejectWithValue({ error: result.data });
      }
    } catch (error) {
      console.error("try catch [ Popularsearch ] error.message >>", error);
      return thunkAPI.rejectWithValue({ error: error });
    }
  }
);
// dataStoreWalletUpadate /data/store
export const dataStoreWalletUpadate = createAsyncThunk(
  "dataStoreWalletUpadate",
  async (userdata, thunkAPI) => {
    try {
      let result = await axios({
        method: "POST",
        baseURL: CONFIG.BASE_URL_LOGIN,
        headers: await Service.GetAuthHeader(),
        url: `data/store`,
        data: userdata,
      });
      if (result.data.success) {
        let existdata1 = result.data;
        let maindata1 = {
          ...existdata1,
          navigetName: userdata.productName,
          value: userdata.value,
        };
        return maindata1;
      } else {
        return thunkAPI.rejectWithValue({ error: result.data.errorMessage });
      }
    } catch (error) {
      console.error(
        "try catch [ dataStoreWalletUpadate ] error.message >>",
        error
      );
      return thunkAPI.rejectWithValue({ error: error });
    }
  }
);
// UploadCIN
export const UploadCIN = createAsyncThunk(
  "UploadCIN",
  async (userdata, thunkAPI) => {
    try {
      let result = await axios({
        method: "POST",
        baseURL: CONFIG.BASE_URL_ALL,
        headers: await Service.infoDataHead(uplodatHeader),
        url: `CIN/UploadCINData`,
        params: userdata,
      });
      if (result.data) {
        return result.data;
      } else {
        return thunkAPI.rejectWithValue({ error: result.data });
      }
    } catch (error) {
      console.error("try catch [ Ewallet ] error.message >>", error.message);
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);
// UploadCIN
export const SearchCompanyName = createAsyncThunk(
  "SearchCompanyName",
  async (userdata, thunkAPI) => {
    try {
      let result = await axios({
        method: "GET",
        baseURL: CONFIG.BASE_URL_ALL,
        url: `CIN/SearchCINDetailByKeyword`,
        headers: Service.infoDataHead(),
        params: userdata,
      });
      if (result.data) {
        return result.data;
      } else {
        return thunkAPI.rejectWithValue({ error: result.data });
      }
    } catch (error) {
      console.error(
        "try catch [ SearchCompanyName ] error.message >>",
        error.message
      );
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);
// UploadGST
export const SearchCompanyNameGSt = createAsyncThunk(
  "SearchCompanyNameGSt",
  async (userdata, thunkAPI) => {
    try {
      let result = await axios({
        method: "GET",
        baseURL: CONFIG.BASE_URL_ALL,
        url: `GST/SearchGSTDetailByKeyword`,
        headers: Service.infoDataHead(),
        params: userdata,
      });
      if (result.data) {
        return result.data;
      } else {
        return thunkAPI.rejectWithValue({ error: result.data });
      }
    } catch (error) {
      console.error(
        "try catch [ SearchCompanyNameGSt ] error.message >>",
        error.message
      );
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);
// GSTByLastDays
export const GSTByLastDays = createAsyncThunk(
  "GSTByLastDays",
  async (userdata, thunkAPI) => {
    try {
      let result = await axios({
        method: "GET",
        baseURL: CONFIG.BASE_URL_ALL,
        url: `GST/GetGSTDetailsCountByLastXDays`,
        headers: Service.infoDataHead(),
        params: userdata,
      });
      if (result.data) {
        return result.data;
      } else {
        return thunkAPI.rejectWithValue({ error: result.data });
      }
    } catch (error) {
      console.error(
        "try catch [ GSTByLastDays ] error.message >>",
        error.message
      );
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

// RefreshCalendarCount
export const RefreshCalendarCount = createAsyncThunk(
  "RefreshCalendarCount",
  async (userdata, thunkAPI) => {
    try {
      let result = await axios({
        method: "GET",
        baseURL: CONFIG.BASE_URL_ALL,
        url: `CIN/RefreshCalendarCount`,
        headers: Service.infoDataHead(),
        params: userdata,
      });
      if (result.data) {
        return result.data;
      } else {
        return thunkAPI.rejectWithValue({ error: result.data });
      }
    } catch (error) {
      console.error(
        "try catch [ RefreshCalendarCount ] error.message >>",
        error.message
      );
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);
// GST/GetGSTDetailsCountByLastXDays/Pincode
export const GSTByLastDaysPincode = createAsyncThunk(
  "GSTByLastDaysPincode",
  async (userdata, thunkAPI) => {
    try {
      let result = await axios({
        method: "GET",
        baseURL: CONFIG.BASE_URL_ALL,
        url: `GST/GetGSTDetailsCountByLastXDays`,
        headers: Service.infoDataHead(),
        params: userdata,
      });
      if (result.data) {
        return result.data;
      } else {
        return thunkAPI.rejectWithValue({ error: result.data });
      }
    } catch (error) {
      console.error(
        "try catch [ GSTByLastDaysPincode ] error.message >>",
        error.message
      );
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);
// GetNewGSTDetailsCountByLastXDays
export const GetNewGSTDetailsCountByLastXDays = createAsyncThunk(
  "GetNewGSTDetailsCountByLastXDays",
  async (userdata, thunkAPI) => {
    try {
      let result = await axios({
        method: "GET",
        baseURL: CONFIG.BASE_URL_ALL,
        url: `GST/GetNewGSTDetailsCountByLastXDays`,
        headers: Service.infoDataHead(),
        params: userdata,
      });
      if (result.data) {
        return result.data;
      } else {
        return thunkAPI.rejectWithValue({ error: result.data });
      }
    } catch (error) {
      console.error(
        "try catch [ GetNewGSTDetailsCountByLastXDays ] error.message >>",
        error.message
      );
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);
// DarpanByLastDay
export const DarpanByLastDay = createAsyncThunk(
  "DarpanByLastDay",
  async (userdata, thunkAPI) => {
    try {
      let result = await axios({
        method: "GET",
        baseURL: CONFIG.BASE_URL_ALL,
        url: `DARPAN/GetDarpanDetailsCountByLastXDays`,
        headers: Service.infoDataHead(),
        params: userdata,
      });
      if (result.data) {
        return result.data;
      } else {
        return thunkAPI.rejectWithValue({ error: result.data });
      }
    } catch (error) {
      console.error(
        "try catch [ DarpanByLastDay ] error.message >>",
        error.message
      );
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);
// 1 /api/IEC/GetIECDetailsCountByLastXDays
export const IECByLastDays = createAsyncThunk(
  "IECByLastDays",
  async (userdata, thunkAPI) => {
    try {
      let result = await axios({
        method: "GET",
        baseURL: CONFIG.BASE_URL_ALL,
        url: `IEC/GetIECDetailsCountByLastXDays`,
        headers: Service.infoDataHead(),
        params: userdata,
      });
      if (result.data) {
        return result.data;
      } else {
        return thunkAPI.rejectWithValue({ error: result.data });
      }
    } catch (error) {
      console.error(
        "try catch [ IECByLastDays ] error.message >>",
        error.message
      );
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

// /api/CIN/GetCINDetailsCountByLastXDays
export const GetCINDetailsCountByLastXDays = createAsyncThunk(
  "GetCINDetailsCountByLastXDays",
  async (userdata, thunkAPI) => {
    try {
      let result = await axios({
        method: "GET",
        baseURL: CONFIG.BASE_URL_ALL,
        url: `CIN/GetCINDetailsCountByLastXDays`,
        headers: Service.infoDataHead(),
        params: userdata,
      });
      if (result.data.success) {
        return result.data;
      } else {
        return thunkAPI.rejectWithValue({ error: result.data });
      }
    } catch (error) {
      console.error(
        "try catch [ GetCINDetailsCountByLastXDays ] error.message >>",
        error.message
      );
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);
// api/GST/GetDashboardGstCinCount
export const GetDashboardGstCinCount = createAsyncThunk(
  "GetDashboardGstCinCount",
  async (userdata, thunkAPI) => {
    try {
      let result = await axios({
        method: "GET",
        baseURL: CONFIG.BASE_URL_ALL,
        url: `GST/GetDashboardGstCinCount`,
        headers: Service.infoDataHead(),
      });
      if (result.data.success) {
        return result.data;
      } else {
        return thunkAPI.rejectWithValue({ error: result.data });
      }
    } catch (error) {
      console.error(
        "try catch [ GetDashboardGstCinCount ] error.message >>",
        error.message
      );
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);
// /api/CIN/GetNewCINDetailsCountByLastXDays
export const GetNewCINDetailsCountByLastXDays = createAsyncThunk(
  "GetNewCINDetailsCountByLastXDays",
  async (userdata, thunkAPI) => {
    try {
      let result = await axios({
        method: "GET",
        baseURL: CONFIG.BASE_URL_ALL,
        url: `CIN/GetNewCINDetailsCountByLastXDays`,
        headers: Service.infoDataHead(),
        params: userdata,
      });
      if (result.data.success) {
        return result.data;
      } else {
        return thunkAPI.rejectWithValue({ error: result.data });
      }
    } catch (error) {
      console.error(
        "try catch [ GetNewCINDetailsCountByLastXDays ] error.message >>",
        error.message
      );
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);
// /IEC/GetPdfRequestList
export const GetPdfRequestList = createAsyncThunk(
  "GetPdfRequestList",
  async (userdata, thunkAPI) => {
    try {
      let result = await axios({
        method: "GET",
        baseURL: CONFIG.BASE_URL_ALL,
        url: `IEC/GetPdfRequestList`,
        headers: Service.infoDataHead(),
        params: userdata,
      });
      if (result.data.success) {
        return result.data;
      } else {
        return thunkAPI.rejectWithValue({ error: result.data });
      }
    } catch (error) {
      console.error(
        "try catch [ GetPdfRequestList ] error.message >>",
        error.message
      );
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

// -------------
// Sendmobileotp
export const Sendmobileotp = createAsyncThunk(
  "Sendmobileotp",
  async (userdata, thunkAPI) => {
    try {
      let result = await axios({
        method: "GET",
        baseURL: CONFIG.BASE_URL_ALL,
        url: `/PortalAdmin/sendmobileotp`,
        headers: Service.infoDataHead(),
        params: userdata,
      });
      return result.data;
    } catch (error) {
      console.error(
        "try catch [ Sendmobileotp ] error.message >>",
        error.message
      );
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);
// Sendemailotp
export const Sendemailotp = createAsyncThunk(
  "Sendemailotp",
  async (userdata, thunkAPI) => {
    try {
      let result = await axios({
        method: "GET",
        baseURL: CONFIG.BASE_URL_ALL,
        url: `/PortalAdmin/sendemailotp`,
        headers: Service.infoDataHead(),
        params: userdata,
      });
      return result.data;
    } catch (error) {
      console.error(
        "try catch [ sendemailotp ] error.message >>",
        error.message
      );
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);
// usersignup
export const Usersignup = createAsyncThunk(
  "Usersignup",
  async (userdata, thunkAPI) => {
    try {
      let result = await axios({
        method: "POST",
        baseURL: CONFIG.BASE_URL_ALL,
        headers: await Service.infoDataHead(authheader),
        url: `/PortalAdmin/usersignup`,
        data: userdata,
      });
      if (result.data.success) {
        return result.data;
      } else {
        return thunkAPI.rejectWithValue({ error: result.data });
      }
    } catch (error) {
      console.error("try catch [ Usersignup ] error.message >>", error.message);
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);
// ECOMMERCE
export const Ecommerce = createAsyncThunk(
  "Ecommerce",
  async (userdata, thunkAPI) => {
    try {
      let result = await axios({
        method: "POST",
        baseURL: CONFIG.BASE_URL_LOGIN,
        // headers: authheader_ecommerce,
        url: `/check_registration`,
        data: userdata,
      });
      return result.data;
    } catch (error) {
      console.error("try catch [ Ecommerce ] error.message >>", error.message);
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);
// EwalletHistory
export const EwalletHistory = createAsyncThunk(
  "EwalletHistory",
  async (_, thunkAPI) => {
    let errorMessageValue = "";
    try {
      let result = await axios({
        method: "GET",
        baseURL: CONFIG.BASE_URL_LOGIN,
        url: `/payment/history`,
        headers: await Service.GetAuthHeader(),
      });
      if (result.data.success) {
        return result.data;
      } else {
        errorMessageValue = result.data.errorMessage || "Unexpected error occurred";
        return thunkAPI.rejectWithValue({ error: errorMessageValue });
      }
    } catch (error) {
      console.error("try catch [ EwalletHistory ] error.message >>", error);
      return thunkAPI.rejectWithValue({
        error: errorMessageValue || error.message || "Unknown error",
      });
    }
  }
);
// GetDashboardCount
export const GetDashboardCount = createAsyncThunk(
  "GetDashboardCount",
  async (thunkAPI) => {
    try {
      let result = await axios({
        method: "GET",
        baseURL: CONFIG.BASE_URL_ALL,
        headers: Service.infoDataHead(),
        url: `IEC/GetDashboardCount`,
      });
      if (result.data.success) {
        return result.data.data;
      } else {
        return thunkAPI.rejectWithValue({ error: result.data });
      }
    } catch (error) {
      console.error(
        "try catch [ GetDashboardCount ] error.message >>",
        error.message
      );
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);
// CIN/GetDashboardCategoryCount"
export const GetDashboardCategoryCount = createAsyncThunk(
  "GetDashboardCategoryCount",
  async (thunkAPI) => {
    try {
      let result = await axios({
        method: "GET",
        baseURL: CONFIG.BASE_URL_ALL,
        headers: Service.infoDataHead(),
        url: `CIN/GetDashboardCategoryCount`,
      });
      if (result.data.success) {
        return result.data.data;
      } else {
        return thunkAPI.rejectWithValue({ error: result.data });
      }
    } catch (error) {
      console.error(
        "try catch [ GetDashboardCount ] error.message >>",
        error.message
      );
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);
// GST/GetGSTDetailsBySelectedDate
export const GetGSTDetailsBySelectedDateAllData = createAsyncThunk(
  "GetGSTDetailsBySelectedDateAllData",
  async (userdata, thunkAPI) => {
    try {
      let result = await axios({
        method: "GET",
        baseURL: CONFIG.BASE_URL_ALL,
        headers: Service.infoDataHead(),
        url: `GST/GetGSTDetailsBySelectedDate`,
        params: userdata,
      });
      if (result.data.success) {
        return result.data.data;
      } else {
        return thunkAPI.rejectWithValue({ error: result.data });
      }
    } catch (error) {
      console.error(
        "try catch [ GetGSTDetailsBySelectedDateAllData ] error.message >>",
        error.message
      );
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);
// GST/GetGSTDetailsByRegDate
export const GetGSTDetailsByRegDate = createAsyncThunk(
  "GetGSTDetailsByRegDate",
  async (userdata, thunkAPI) => {
    try {
      const effectiveDate =
        typeof userdata === "string"
          ? userdata
          : userdata?.effectiveDateofregistration || userdata?.effectiveDateOfRegistration;

      let result = await axios({
        method: "GET",
        baseURL: CONFIG.BASE_URL_ALL,
        url: `GST/GetGSTDetailsByRegDate`,
        headers: Service.infoDataHead(),
        params: {
          effectiveDateofregistration: effectiveDate,
        },
      });

      if (result.data) {
        if (result.data.success && Array.isArray(result.data.data)) {
          return result.data.data;
        } else if (Array.isArray(result.data.data)) {
          return result.data.data;
        } else if (Array.isArray(result.data)) {
          return result.data;
        } else {
          return result.data.data || [];
        }
      } else {
        return thunkAPI.rejectWithValue({
          error: "Failed to fetch GST details",
        });
      }
    } catch (error) {
      console.error(
        "try catch [ GetGSTDetailsByRegDate ] error.message >>",
        error.message
      );
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);
// CIN/GetCINAddressByRegDate
export const GetCINAddressByRegDate = createAsyncThunk(
  "GetCINAddressByRegDate",
  async (userdata, thunkAPI) => {
    try {
      const regDate =
        typeof userdata === "string"
          ? userdata
          : userdata?.companyRegistrationdate_date || userdata?.effectiveDateofregistration || userdata?.date;

      let result = await axios({
        method: "GET",
        baseURL: CONFIG.BASE_URL_ALL,
        url: `CIN/GetCINAddressByRegDate`,
        headers: Service.infoDataHead(),
        params: {
          companyRegistrationdate_date: regDate,
        },
      });

      if (result.data) {
        if (result.data.success && Array.isArray(result.data.data)) {
          return result.data.data;
        } else if (Array.isArray(result.data.data)) {
          return result.data.data;
        } else if (Array.isArray(result.data)) {
          return result.data;
        } else {
          return result.data.data || [];
        }
      } else {
        return thunkAPI.rejectWithValue({
          error: "Failed to fetch CIN details",
        });
      }
    } catch (error) {
      console.error(
        "try catch [ GetCINAddressByRegDate ] error.message >>",
        error.message
      );
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);
// Darpan/GetDarpanDetailsBySelectedDate
export const GetDarpanDetailsBySelectedDate = createAsyncThunk(
  "GetDarpanDetailsBySelectedDate",
  async (userdata, thunkAPI) => {
    // console.log("Service.infoDataHead()>>>>", Service.infoDataHead());
    try {
      let result = await axios({
        method: "GET",
        baseURL: CONFIG.BASE_URL_ALL,
        headers: Service.infoDataHead(),
        url: `DARPAN/GetDARPANDetailsByPinCode`,
        params: userdata,
      });
      if (result.data.success) {
        return result.data.data;
      } else {
        return thunkAPI.rejectWithValue({ error: result.data });
      }
    } catch (error) {
      console.error(
        "try catch [ GetDarpanDetailsBySelectedDate ] error.message >>",
        error.message
      );
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

// Darpan/GetAllDarpanDetailsBySelectedDate
export const GetAllDarpanDetailsBySelectedDate = createAsyncThunk(
  "GetAllDarpanDetailsBySelectedDate",
  async (userdata, thunkAPI) => {
    console.log("userdata", userdata);
    try {
      let result = await axios({
        method: "GET",
        baseURL: CONFIG.BASE_URL_ALL,
        headers: Service.infoDataHead(),
        url: `DARPAN/GetDarpanDetailsBySelectedDate`,
        params: userdata,
      });
      if (result.data.success) {
        return result.data.data;
      } else {
        return thunkAPI.rejectWithValue({ error: result.data });
      }
    } catch (error) {
      console.error(
        "try catch [ GetAllDarpanDetailsBySelectedDate ] error.message >>",
        error.message
      );
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);
//2 api/IEC/GetIECDetailsBySelectedDate
export const GetIECDetailsBySelectedDate = createAsyncThunk(
  "GetIECDetailsBySelectedDate",
  async (userdata, thunkAPI) => {
    try {
      let result = await axios({
        method: "GET",
        baseURL: CONFIG.BASE_URL_ALL,
        headers: Service.infoDataHead(),
        url: `IEC/GetIECDetailsBySelectedDate`,
        params: userdata,
      });
      if (result.data.success) {
        return result.data.data;
      } else {
        return thunkAPI.rejectWithValue({ error: result.data });
      }
    } catch (error) {
      console.error(
        "try catch [ GetIECDetailsBySelectedDate ] error.message >>",
        error.message
      );
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

// IEC/GetAllIECCountByLastXDays
export const GetAllIECCountByLastXDays = createAsyncThunk(
  "GetAllIECCountByLastXDays",
  async (userdata, thunkAPI) => {
    try {
      let result = await axios({
        method: "GET",
        baseURL: CONFIG.BASE_URL_ALL,
        url: `IEC/GetAllIECCountByLastXDays`,
        headers: Service.infoDataHead(),
        params: userdata,
      });
      if (result.data) {
        return result.data;
      } else {
        return thunkAPI.rejectWithValue({ error: result.data });
      }
    } catch (error) {
      console.error(
        "try catch [ GetAllIECCountByLastXDays ] error.message >>",
        error.message
      );
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

// IEC/GetAllIECDetailsBySelectedDate
export const GetAllIECDetailsBySelectedDate = createAsyncThunk(
  "GetAllIECDetailsBySelectedDate",
  async (userdata, thunkAPI) => {
    console.log("userdata", userdata);
    try {
      let result = await axios({
        method: "GET",
        baseURL: CONFIG.BASE_URL_ALL,
        headers: Service.infoDataHead(),
        url: `IEC/GetAllIECDetailsBySelectedDate`,
        params: userdata,
      });
      if (result.data.success) {
        return result.data.data;
      } else {
        return thunkAPI.rejectWithValue({ error: result.data });
      }
    } catch (error) {
      console.error(
        "try catch [ GetAllIECDetailsBySelectedDate ] error.message >>",
        error.message
      );
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

// GST/PincodeGet
export const PincodeGet = createAsyncThunk(
  "PincodeGet",
  async (userdata, thunkAPI) => {
    try {
      let result = await axios({
        method: "GET",
        baseURL: CONFIG.BASE_URL_ALL,
        headers: Service.infoDataHead(),
        url: `GST/GetUserPinCodeListByUsername`,
        params: userdata,
      });
      if (result.data.success) {
        return result.data;
      } else {
        return thunkAPI.rejectWithValue({ error: result.data });
      }
    } catch (error) {
      console.error(
        "try catch [ PincodeGet ] error.message >>",
        error.message
      );
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);
// CIN/GetCompanyAndDirectorDetailBySelectedDate
export const CinGetCompanyAndDirectorDetailBySelected = createAsyncThunk(
  "CinGetCompanyAndDirectorDetailBySelected",
  async (userdata, thunkAPI) => {
    try {
      let result = await axios({
        method: "GET",
        baseURL: CONFIG.BASE_URL_ALL,
        headers: Service.infoDataHead(),
        url: `CIN/GetCompanyAndDirectorDetailBySelectedDate`,
        params: userdata,
      });
      if (result.data.success) {
        return result.data.data;
      } else {
        return thunkAPI.rejectWithValue({ error: result.data });
      }
    } catch (error) {
      console.error(
        "try catch [ CinGetCompanyAndDirectorDetailBySelected ] error.message >>",
        error.message
      );
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);
// IEC/SavePdfRequest"
export const SavePdfRequest = createAsyncThunk(
  "SavePdfRequest",
  async (userdata, thunkAPI) => {
    try {
      let result = await axios({
        method: "POST",
        baseURL: CONFIG.BASE_URL_ALL,
        headers: Service.infoDataHead(),
        url: `IEC/SavePdfRequest`,
        data: userdata,
      });
      if (result.data.success) {
        return result.data.data;
      } else {
        return thunkAPI.rejectWithValue({ error: result.data });
      }
    } catch (error) {
      console.error(
        "try catch [ SavePdfRequest ] error.message >>",
        error.message
      );
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

// IEC/GetCompanyAndDirectorDetailBySelectedDate
export const IECGetCompanyAndDirectorDetailBySelected = createAsyncThunk(
  "IECGetCompanyAndDirectorDetailBySelected",
  async (userdata, thunkAPI) => {
    try {
      let result = await axios({
        method: "GET",
        baseURL: CONFIG.BASE_URL_ALL,
        headers: Service.infoDataHead(),
        url: `SIEC/GetCompanyAndDirectorDetailBySelectedDate`,
        params: userdata,
      });
      if (result.data.success) {
        return result.data.data;
      } else {
        return thunkAPI.rejectWithValue({ error: result.data });
      }
    } catch (error) {
      console.error(
        "try catch [ IECGetCompanyAndDirectorDetailBySelected ] error.message >>",
        error.message
      );
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);
// darpan/GetCompanyAndDirectorDetailBySelectedDate
export const DarpanGetCompanyAndDirectorDetailBySelected = createAsyncThunk(
  "DarpanGetCompanyAndDirectorDetailBySelected",
  async (userdata, thunkAPI) => {
    try {
      let result = await axios({
        method: "GET",
        baseURL: CONFIG.BASE_URL_ALL,
        headers: Service.infoDataHead(),
        url: `darpan/GetCompanyAndDirectorDetailBySelectedDate`,
        params: userdata,
      });
      if (result.data.success) {
        return result.data.data;
      } else {
        return thunkAPI.rejectWithValue({ error: result.data });
      }
    } catch (error) {
      console.error(
        "try catch [ DarpanGetCompanSyAndDirectorDetailBySelected ] error.message >>",
        error.message
      );
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);
// GST/SaveUserPinCode
export const SaveUserPinCode = createAsyncThunk(
  "SaveUserPinCode",
  async (userdata, thunkAPI) => {
    try {
      let result = await axios({
        method: "POST",
        baseURL: CONFIG.BASE_URL_ALL,
        headers: Service.infoDataHead(),
        url: `GST/SaveUserPinCode`,
        data: userdata,
      });
      if (result.data.success) {
        return result.data.data;
      } else {
        return thunkAPI.rejectWithValue({ error: result.data });
      }
    } catch (error) {
      console.error(
        "try catch [ SaveUserPinCode ] error.message >>",
        error.message
      );
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);
export const TBSlice = createSlice({
  name: "TBSlice",
  initialState: {
    ref1: null,
    ref2: null,
    ref3: null,

    location: {},
    madAdminConfig: false,

    darkmode: false,

    isGstsearch: false,
    isGstsearchFetching: false,
    isGstsearchRefreshDetailsFetching: false,
    GstsearchData: {},

    isGetMasterDataList: false,
    isGetMasterDataListFetching: false,
    GetMasterDataListData: {},

    isMe: {},

    isScreenShowPath: "",

    viewPortal: "FaList",

    isloading: false,

    isGetGSTCINDetailByEmail: false,
    isGetGSTCINDetailByEmailFetching: false,
    GetGSTCINDetailByEmailData: {},

    isGetGSTDetailsBySelectedDateAllData: false,
    isGetGSTDetailsBySelectedDateAllDataFetching: false,
    GetGSTDetailsBySelectedDateAllDataData: [],

    isGetGSTDetailsByRegDate: false,
    isGetGSTDetailsByRegDateFetching: false,
    GetGSTDetailsByRegDateData: [],

    isGetCINAddressByRegDate: false,
    isGetCINAddressByRegDateFetching: false,
    GetCINAddressByRegDateData: [],

    isGetDarpanDetailsBySelectedDate: false,
    isGetDarpanDetailsBySelectedDateFetching: false,
    GetDarpanDetailsBySelectedDateData: [],


    isGetAllDarpanDetailsBySelectedDate: false,
    isGetAllDarpanDetailsBySelectedDateFetching: false,
    GetAllDarpanDetailsBySelectedDateData: [],

    isGetIECDetailsBySelectedDate: false,
    isGetIECDetailsBySelectedDateFetching: false,
    GetIECDetailsBySelectedDateData: [],

    isGetAllIECCountByLastXDays: false,
    isGetAllIECCountByLastXDaysFetching: false,
    GetAllIECCountByLastXDaysData: [],

    isGetAllIECDetailsBySelectedDate: false,
    isGetAllIECDetailsBySelectedDateFetching: false,
    GetAllIECDetailsBySelectedDateData: [],

    isPincodeGet: false,
    isPincodeGetFetching: false,
    PincodeGetData: [],

    isCinGetCompanyAndDirectorDetailBySelected: false,
    isCinGetCompanyAndDirectorDetailBySelectedFetching: false,
    CinGetCompanyAndDirectorDetailBySelectedData: [],

    isSaveUserPinCode: false,
    isSaveUserPinCodeFetching: false,

    isDarpanGetCompanyAndDirectorDetailBySelected: false,
    isDarpanGetCompanyAndDirectorDetailBySelectedFetching: false,
    DarpanGetCompanyAndDirectorDetailBySelectedData: [],

    isIECGetCompanyAndDirectorDetailBySelected: false,
    isIECGetCompanyAndDirectorDetailBySelectedFetching: false,
    IECGetCompanyAndDirectorDetailBySelectedData: [],

    isSavePdfRequest: false,
    isSavePdfRequestFetching: false,
    SavePdfRequestData: {},

    isRefreshCinDINDetails: false,
    isRefreshCinDINDetailsFetching: false,
    RefreshCinDINDetailsData: [],

    isRefreshDINDetailsByDIN: false,
    isRefreshDINDetailsByDINFetching: false,
    RefreshDINDetailsByDINData: {},

    isPopularsearch: false,
    isPopularsearchFetching: false,
    PopularsearchData: {},

    isMobile360: false,
    isMobile360Fetching: false,
    Mobile360Data: {},

    isCin: false,
    isCinFetching: false,
    isCinRefreshCINDetailsFetching: false,
    CinData: {},

    isDarpanSearchApi: false,
    isDarpanSearchApiFetching: false,
    DarpanSearchApiData: {},

    isGetDarpanDashboardData: false,
    isGetDarpanDashboardDataFetching: false,
    GetDarpanDashboardDataData: null,

    isGetIECDashboardData: false,
    isGetIECDashboardDataFetching: false,
    GetIECDashboardDataData: null,

    isGetFileLogListByUserName: false,
    isGetFileLogListByUserNameFetching: false,
    GetFileLogListByUserNameData: [],

    isSearchCINByAdvanceSearch: false,
    isSearchCINByAdvanceSearchFetching: false,
    SearchCINByAdvanceSearchData: [],

    isDesboadSearchCINByAdvanceSearch: false,
    isDesboadSearchCINByAdvanceSearchFetching: false,
    DesboadSearchCINByAdvanceSearchData: {},

    isDesboadSearchGSTByAdvanceSearch: false,
    isDesboadSearchGSTByAdvanceSearchFetching: false,
    DesboadSearchGSTByAdvanceSearchData: {},

    isSearchGSTByAdvanceSearch: false,
    isSearchGSTByAdvanceSearchFetching: false,
    SearchGSTByAdvanceSearchData: [],
    SearchGSTByAdvanceSearchpageNumber: 1,
    SearchGSTByAdvanceSearchTotalData: "",
    SearchGSTByAdvanceSearchUserdata: {},

    isCinGetIndustryList: false,
    isCinGetIndustryListFetching: false,
    CinGetIndustryListData: [],

    isCinGetSegmentList: false,
    isCinGetSegmentListFetching: false,
    CinGetSegmentListData: [],

    isUpdateProfile: false,
    isUpdateProfileFetching: false,
    UpdateProfileData: {},

    isReUsersignin: false,
    isReUsersigninFetching: false,
    ReUsersigninData: {},

    isVerifyotp: false,
    isVerifyotpFetching: false,
    VerifyotpData: {},

    isEcommerce: false,
    isEcommerceFetching: false,
    EcommerceData: {},

    isDin: false,
    isDinFetching: false,
    DinData: [],

    isIESDetailApi: false,
    isIESDetailApiFetching: false,
    IESDetailApiData: {},

    isGetPincodeLatLong: false,
    isGetPincodeLatLongFetching: false,
    GetPincodeLatLongData: {},

    isMsme: false,
    isMsmeFetching: false,
    isMsmeRefreshDetailsFetching: false,
    MsmeData: {},

    isGetFactAppInfoByPhone: false,
    isGetFactAppInfoByPhoneFetching: false,
    GetFactAppInfoByPhoneData: {},

    isGetFactAppInfoMoreByPhone: false,
    isGetFactAppInfoMoreByPhoneFetching: false,
    GetFactAppInfoMoreByPhoneData: {},

    isGetFactAppInfoByEmail: false,
    isGetFactAppInfoByEmailFetching: false,
    GetFactAppInfoByEmailData: {},

    isGetFactAppInfoMoreByEmail: false,
    isGetFactAppInfoMoreByEmailFetching: false,
    GetFactAppInfoMoreByEmailData: {},

    isGetFactAppInfoByUserName: false,
    isGetFactAppInfoByUserNameFetching: false,
    GetFactAppInfoByUserNameData: [],

    isResetPassword: false,
    isResetPasswordFetching: false,
    ResetPasswordData: {},

    isGetCINAddressByPin: false,
    isGetCINAddressByPinFetching: false,
    GetCINAddressByPinData: {},

    isMobileToMSME: false,
    isMobileToMSMEFetching: false,
    MobileToMSMEData: {},

    isPanSearch: false,
    isPanSearchFetching: false,
    isPansearchRefreshDetailsFetching: false,
    PanSearchData: {},



    isCINDetailsByDate: false,
    isCINDetailsByDateFetching: false,
    CINDetailsByDateData: {},

    isMobileToMultipleUPI: false,
    isMobileToMultipleUPIFetching: false,
    MobileToMultipleUPIData: [],

    isGetPincodeLatLongGST: false,
    isGetPincodeLatLongGSTFetching: false,
    GetPincodeLatLongGSTData: {},


    isGetPincodeLatLongIEC: false,
    isGetPincodeLatLongIECFetching: false,
    GetPincodeLatLongIECData: {},

    isSearchCompanyName: false,
    isSearchCompanyNameFetching: false,
    SearchCompanyNameData: [],

    isSearchCompanyNameGSt: false,
    isSearchCompanyNameGStFetching: false,
    SearchCompanyNameGStData: [],

    isGetNewGSTList: false,
    isGetNewGSTListFetching: false,
    GetNewGSTListData: {},

    isGetMCAReport: false,
    isGetMCAReportFetching: false,
    GetMCAReportData: {},

    isHelpdeskTicketList: false,
    isHelpdeskTicketListFetching: false,
    HelpdeskTicketListData: {},

    isHelpdeskTicketCreate: false,
    isHelpdeskTicketCreateFetching: false,
    HelpdeskTicketCreateData: {},

    isGetNewGSTDetail: false,
    isGetNewGSTDetailFetching: false,
    GetNewGSTDetailData: {},

    isGstContact: false,
    isGstContactFetching: false,
    GstContactData: {},

    isUploadCIN: false,
    isUploadCINFetching: false,
    UploadCINData: {},

    isUsersignup: false,
    isUsersignupFetching: false,
    UsersignupData: {},

    isUsersignin: false,
    isUsersigninFetching: false,
    isUsersigninNaviget: false,
    isUsersigninotp: false,
    UsersigninData: {},

    isGetCINDetailsCountByLastXDays: false,
    isGetCINDetailsCountByLastXDaysFetching: false,
    GetCINDetailsCountByLastXDaysData: [],

    isGetDashboardGstCinCount: false,
    isGetDashboardGstCinCountFetching: false,
    GetDashboardGstCinCountData: [],

    isGetNewCINDetailsCountByLastXDays: false,
    isGetNewCINDetailsCountByLastXDaysFetching: false,
    GetNewCINDetailsCountByLastXDaysData: [],

    isGetPdfRequestList: false,
    isGetPdfRequestListFetching: false,
    GetPdfRequestListData: [],

    isdataStoreWalletUpadate: false,
    isdataStoreWalletUpadateFetching: false,
    dataStoreWalletUpadateData: {},

    isSendmobileotp: false,
    isSendmobileotpFetching: false,
    SendmobileotpData: {},

    isSendemailotp: false,
    isSendemailotpFetching: false,
    SendemailotpData: {},

    isPanverify: false,
    isPanverifyFetching: false,
    PanverifyData: {},

    isGstverify: false,
    isGstverifyFetching: false,
    GstverifyData: {},

    PanDetailsData: {},

    isEmailverify: false,
    isEmailverifyFetching: false,
    EmailverifyData: {},

    isGSTByLastDays: false,
    isGSTByLastDaysFetching: false,
    GSTByLastDaysData: [],

    isGSTByLastDaysPincode: false,
    isGSTByLastDaysPincodeFetching: false,
    GSTByLastDaysPincodeData: [],

    isGetNewGSTDetailsCountByLastXDays: false,
    isGetNewGSTDetailsCountByLastXDaysFetching: false,
    GetNewGSTDetailsCountByLastXDaysData: [],

    isDarpanByLastDay: false,
    isDarpanByLastDayFetching: false,
    DarpanByLastDayData: [],

    isIECByLastDays: false,
    isIECByLastDaysFetching: false,
    IECByLastDaysData: [],

    isEwalletHistory: false,
    isEwalletHistoryFetching: false,
    CreditData: 0,
    UsedCreditData: 0,
    TotalCreditData: 0,
    EwalletHistoryData: [],

    isGetCoordinates: false,
    isGetCoordinatesFetching: false,
    GetCoordinatesData: {},

    isGetDashboardCount: false,
    isGetDashboardCountFetching: false,
    GetDashboardCountData: {},

    isBankPincode: false,
    isBankPincodeFetching: false,
    BankPincodeData: [],

    isGetBankMasterDataList: false,
    isGetBankMasterDataListFetching: false,
    GetBankMasterDataListData: {},

    isGetPopulationMasterDataList: false,
    isGetPopulationMasterDataListFetching: false,
    GetPopulationMasterDataListData: {},

    isGetBankDependentDropdown: false,
    isGetBankDependentDropdownFetching: false,
    GetBankDependentDropdownData: {},

    isGetPopulationDependentDropdown: false,
    isGetPopulationDependentDropdownFetching: false,
    GetPopulationDependentDropdownData: {},

    isEwallet: false,
    isEwalletFetching: false,
    EwalletData: "",
    Ewalletexpired: "",
    ProductName: "",
    ProductValue: "",
    ProductMoreValue: {},

    MaltGstDetailData: [],

    isEmailAvlebl: false,

    isSignin: false,
    isSigninFetching: false,

    isGetDashboardCategoryCount: false,
    isGetDashboardCategoryCountFetching: false,
    GetDashboardCategoryCountData: [],

    MaltGstContactData: [],

    isPanDetailsFetching: false,
    isFetching: false,

    isError: false,
    errorMessage: "",
    errorMessage: "",
  },
  reducers: {
    updateState: (state, { payload }) => {
      state.ref1 = payload.ref1 !== undefined ? payload.ref1 : state.ref1;
      state.ref2 = payload.ref2 !== undefined ? payload.ref2 : state.ref2;
      state.successMessage = payload.successMessage !== undefined ? payload.successMessage : state.successMessage;

      state.isMe = payload.isMe !== undefined ? payload.isMe : state.isMe;
      state.madAdminConfig = payload.madAdminConfig !== undefined ? payload.madAdminConfig : state.madAdminConfig;

      state.isPincodeGet = payload.isPincodeGet !== undefined ? payload.isPincodeGet : state.isPincodeGet;

      state.isDarpanSearchApi = payload.isDarpanSearchApi !== undefined ? payload.isDarpanSearchApi : state.isDarpanSearchApi;
      state.DarpanSearchApiData = payload.DarpanSearchApiData !== undefined ? payload.DarpanSearchApiData : state.DarpanSearchApiData;

      state.isGetDarpanDashboardData = payload.isGetDarpanDashboardData !== undefined ? payload.isGetDarpanDashboardData : state.isGetDarpanDashboardData;
      state.GetDarpanDashboardDataData = payload.GetDarpanDashboardDataData !== undefined ? payload.GetDarpanDashboardDataData : state.GetDarpanDashboardDataData;

      state.isGetIECDashboardData = payload.isGetIECDashboardData !== undefined ? payload.isGetIECDashboardData : state.isGetIECDashboardData;
      state.GetIECDashboardDataData = payload.GetIECDashboardDataData !== undefined ? payload.GetIECDashboardDataData : state.GetIECDashboardDataData;

      state.isGetFileLogListByUserName = payload.isGetFileLogListByUserName !== undefined ? payload.isGetFileLogListByUserName : state.isGetFileLogListByUserName;
      state.GetFileLogListByUserNameData = payload.GetFileLogListByUserNameData !== undefined ? payload.GetFileLogListByUserNameData : state.GetFileLogListByUserNameData;

      state.darkmode =
        payload.darkmode !== undefined ? payload.darkmode : state.darkmode;

      state.viewPortal =
        payload.viewPortal !== undefined
          ? payload.viewPortal
          : state.viewPortal;

      state.isloading =
        payload.isloading !== undefined ? payload.isloading : state.isloading;

      state.isScreenShowPath =
        payload.isScreenShowPath !== undefined ? payload.isScreenShowPath : state.isScreenShowPath;

      state.isSaveUserPinCode =
        payload.isSaveUserPinCode !== undefined ? payload.isSaveUserPinCode : state.isSaveUserPinCode;

      state.isSavePdfRequest =
        payload.isSavePdfRequest !== undefined ? payload.isSavePdfRequest : state.isSavePdfRequest;

      state.ProductValue =
        payload.ProductValue !== undefined
          ? payload.ProductValue
          : state.ProductValue;
      state.ProductName =
        payload.ProductName !== undefined
          ? payload.ProductName
          : state.ProductName;

      state.isGstsearch =
        payload.isGstsearch !== undefined
          ? payload.isGstsearch
          : state.isGstsearch;
      state.GstsearchData =
        payload.GstsearchData !== undefined
          ? payload.GstsearchData
          : state.GstsearchData;

      state.isGetGSTDetailsBySelectedDateAllData =
        payload.isGetGSTDetailsBySelectedDateAllData !== undefined
          ? payload.isGetGSTDetailsBySelectedDateAllData
          : state.isGetGSTDetailsBySelectedDateAllData;
      state.GetGSTDetailsBySelectedDateAllDataData =
        payload.GetGSTDetailsBySelectedDateAllDataData !== undefined
          ? payload.GetGSTDetailsBySelectedDateAllDataData
          : state.GetGSTDetailsBySelectedDateAllDataData;

      state.isGetGSTDetailsByRegDate =
        payload.isGetGSTDetailsByRegDate !== undefined
          ? payload.isGetGSTDetailsByRegDate
          : state.isGetGSTDetailsByRegDate;
      state.isGetGSTDetailsByRegDateFetching =
        payload.isGetGSTDetailsByRegDateFetching !== undefined
          ? payload.isGetGSTDetailsByRegDateFetching
          : state.isGetGSTDetailsByRegDateFetching;
      state.GetGSTDetailsByRegDateData =
        payload.GetGSTDetailsByRegDateData !== undefined
          ? payload.GetGSTDetailsByRegDateData
          : state.GetGSTDetailsByRegDateData;

      state.isGetCINAddressByRegDate =
        payload.isGetCINAddressByRegDate !== undefined
          ? payload.isGetCINAddressByRegDate
          : state.isGetCINAddressByRegDate;
      state.isGetCINAddressByRegDateFetching =
        payload.isGetCINAddressByRegDateFetching !== undefined
          ? payload.isGetCINAddressByRegDateFetching
          : state.isGetCINAddressByRegDateFetching;
      state.GetCINAddressByRegDateData =
        payload.GetCINAddressByRegDateData !== undefined
          ? payload.GetCINAddressByRegDateData
          : state.GetCINAddressByRegDateData;

      state.isGetDarpanDetailsBySelectedDate =
        payload.isGetDarpanDetailsBySelectedDate !== undefined
          ? payload.isGetDarpanDetailsBySelectedDate
          : state.isGetDarpanDetailsBySelectedDate;
      state.GetDarpanDetailsBySelectedDateData =
        payload.GetDarpanDetailsBySelectedDateData !== undefined
          ? payload.GetDarpanDetailsBySelectedDateData
          : state.GetDarpanDetailsBySelectedDateData;

      state.isGetAllDarpanDetailsBySelectedDate =
        payload.isGetAllDarpanDetailsBySelectedDate !== undefined
          ? payload.isGetAllDarpanDetailsBySelectedDate
          : state.isGetAllDarpanDetailsBySelectedDate;
      state.GetAllDarpanDetailsBySelectedDateData =
        payload.GetAllDarpanDetailsBySelectedDateData !== undefined
          ? payload.GetAllDarpanDetailsBySelectedDateData
          : state.GetAllDarpanDetailsBySelectedDateData;

      state.isGetIECDetailsBySelectedDate =
        payload.isGetIECDetailsBySelectedDate !== undefined
          ? payload.isGetIECDetailsBySelectedDate
          : state.isGetIECDetailsBySelectedDate;
      state.GetIECDetailsBySelectedDateData =
        payload.GetIECDetailsBySelectedDateData !== undefined
          ? payload.GetIECDetailsBySelectedDateData
          : state.GetIECDetailsBySelectedDateData;

      state.isGetAllIECCountByLastXDays =
        payload.isGetAllIECCountByLastXDays !== undefined
          ? payload.isGetAllIECCountByLastXDays
          : state.isGetAllIECCountByLastXDays;
      state.GetAllIECCountByLastXDaysData =
        payload.GetAllIECCountByLastXDaysData !== undefined
          ? payload.GetAllIECCountByLastXDaysData
          : state.GetAllIECCountByLastXDaysData;

      state.isGetAllIECDetailsBySelectedDate =
        payload.isGetAllIECDetailsBySelectedDate !== undefined
          ? payload.isGetAllIECDetailsBySelectedDate
          : state.isGetAllIECDetailsBySelectedDate;
      state.GetAllIECDetailsBySelectedDateData =
        payload.GetAllIECDetailsBySelectedDateData !== undefined
          ? payload.GetAllIECDetailsBySelectedDateData
          : state.GetAllIECDetailsBySelectedDateData;

      state.isCinGetCompanyAndDirectorDetailBySelected =
        payload.isCinGetCompanyAndDirectorDetailBySelected !== undefined
          ? payload.isCinGetCompanyAndDirectorDetailBySelected
          : state.isCinGetCompanyAndDirectorDetailBySelected;
      state.CinGetCompanyAndDirectorDetailBySelectedData =
        payload.CinGetCompanyAndDirectorDetailBySelectedData !== undefined
          ? payload.CinGetCompanyAndDirectorDetailBySelectedData
          : state.CinGetCompanyAndDirectorDetailBySelectedData;

      state.isIECGetCompanyAndDirectorDetailBySelected =
        payload.isIECGetCompanyAndDirectorDetailBySelected !== undefined
          ? payload.isIECGetCompanyAndDirectorDetailBySelected
          : state.isIECGetCompanyAndDirectorDetailBySelected;
      state.IECGetCompanyAndDirectorDetailBySelectedData =
        payload.IECGetCompanyAndDirectorDetailBySelectedData !== undefined
          ? payload.IECGetCompanyAndDirectorDetailBySelectedData
          : state.IECGetCompanyAndDirectorDetailBySelectedData;

      state.isBankPincode =
        payload.isBankPincode !== undefined
          ? payload.isBankPincode
          : state.isBankPincode;
      state.BankPincodeData =
        payload.BankPincodeData !== undefined
          ? payload.BankPincodeData
          : state.BankPincodeData;

      state.isReUsersignin =
        payload.isReUsersignin !== undefined
          ? payload.isReUsersignin
          : state.isReUsersignin;
      state.ReUsersigninData =
        payload.ReUsersigninData !== undefined
          ? payload.ReUsersigninData
          : state.ReUsersigninData;

      state.isGetFactAppInfoByPhone =
        payload.isGetFactAppInfoByPhone !== undefined
          ? payload.isGetFactAppInfoByPhone
          : state.isGetFactAppInfoByPhone;
      state.GetFactAppInfoByPhoneData =
        payload.GetFactAppInfoByPhoneData !== undefined
          ? payload.GetFactAppInfoByPhoneData
          : state.GetFactAppInfoByPhoneData;

      state.isGetFactAppInfoMoreByPhone =
        payload.isGetFactAppInfoMoreByPhone !== undefined
          ? payload.isGetFactAppInfoMoreByPhone
          : state.isGetFactAppInfoMoreByPhone;
      state.GetFactAppInfoMoreByPhoneData =
        payload.GetFactAppInfoMoreByPhoneData !== undefined
          ? payload.GetFactAppInfoMoreByPhoneData
          : state.GetFactAppInfoMoreByPhoneData;

      state.isGetFactAppInfoByEmail =
        payload.isGetFactAppInfoByEmail !== undefined
          ? payload.isGetFactAppInfoByEmail
          : state.isGetFactAppInfoByEmail;
      state.GetFactAppInfoByEmailData =
        payload.GetFactAppInfoByEmailData !== undefined
          ? payload.GetFactAppInfoByEmailData
          : state.GetFactAppInfoByEmailData;

      state.isGetFactAppInfoMoreByEmail =
        payload.isGetFactAppInfoMoreByEmail !== undefined
          ? payload.isGetFactAppInfoMoreByEmail
          : state.isGetFactAppInfoMoreByEmail;
      state.GetFactAppInfoMoreByEmailData =
        payload.GetFactAppInfoMoreByEmailData !== undefined
          ? payload.GetFactAppInfoMoreByEmailData
          : state.GetFactAppInfoMoreByEmailData;

      state.isGetFactAppInfoByUserName =
        payload.isGetFactAppInfoByUserName !== undefined
          ? payload.isGetFactAppInfoByUserName
          : state.isGetFactAppInfoByUserName;
      state.GetFactAppInfoByUserNameData =
        payload.GetFactAppInfoByUserNameData !== undefined
          ? payload.GetFactAppInfoByUserNameData
          : state.GetFactAppInfoByUserNameData;

      state.isIESDetailApi =
        payload.isIESDetailApi !== undefined
          ? payload.isIESDetailApi
          : state.isIESDetailApi;
      state.IESDetailApiData =
        payload.IESDetailApiData !== undefined
          ? payload.IESDetailApiData
          : state.IESDetailApiData;

      state.isdataStoreWalletUpadate =
        payload.isdataStoreWalletUpadate !== undefined
          ? payload.isdataStoreWalletUpadate
          : state.isdataStoreWalletUpadate;

      state.isGetGSTCINDetailByEmail =
        payload.isGetGSTCINDetailByEmail !== undefined
          ? payload.isGetGSTCINDetailByEmail
          : state.isGetGSTCINDetailByEmail;
      state.GetGSTCINDetailByEmailData =
        payload.GetGSTCINDetailByEmailData !== undefined
          ? payload.GetGSTCINDetailByEmailData
          : state.GetGSTCINDetailByEmailData;

      state.isRefreshCinDINDetails =
        payload.isRefreshCinDINDetails !== undefined
          ? payload.isRefreshCinDINDetails
          : state.isRefreshCinDINDetails;
      state.RefreshCinDINDetailsData =
        payload.RefreshCinDINDetailsData !== undefined
          ? payload.RefreshCinDINDetailsData
          : state.RefreshCinDINDetailsData;

      state.isRefreshDINDetailsByDIN =
        payload.isRefreshDINDetailsByDIN !== undefined
          ? payload.isRefreshDINDetailsByDIN
          : state.isRefreshDINDetailsByDIN;
      state.RefreshDINDetailsByDINData =
        payload.RefreshDINDetailsByDINData !== undefined
          ? payload.RefreshDINDetailsByDINData
          : state.RefreshDINDetailsByDINData;

      state.isUpdateProfile =
        payload.isUpdateProfile !== undefined
          ? payload.isUpdateProfile
          : state.isUpdateProfile;
      state.UpdateProfileData =
        payload.UpdateProfileData !== undefined
          ? payload.UpdateProfileData
          : state.UpdateProfileData;

      state.isHelpdeskTicketList =
        payload.isHelpdeskTicketList !== undefined
          ? payload.isHelpdeskTicketList
          : state.isHelpdeskTicketList;
      state.HelpdeskTicketListData =
        payload.HelpdeskTicketListData !== undefined
          ? payload.HelpdeskTicketListData
          : state.HelpdeskTicketListData;

      state.isHelpdeskTicketCreate =
        payload.isHelpdeskTicketCreate !== undefined
          ? payload.isHelpdeskTicketCreate
          : state.isHelpdeskTicketCreate;
      state.HelpdeskTicketCreateData =
        payload.HelpdeskTicketCreateData !== undefined
          ? payload.HelpdeskTicketCreateData
          : state.HelpdeskTicketCreateData;

      state.isPanverify =
        payload.isPanverify !== undefined
          ? payload.isPanverify
          : state.isPanverify;
      state.PanverifyData =
        payload.PanverifyData !== undefined
          ? payload.PanverifyData
          : state.PanverifyData;

      state.isMobileToMultipleUPI =
        payload.isMobileToMultipleUPI !== undefined
          ? payload.isMobileToMultipleUPI
          : state.isMobileToMultipleUPI;
      state.MobileToMultipleUPIData =
        payload.MobileToMultipleUPIData !== undefined
          ? payload.MobileToMultipleUPIData
          : state.MobileToMultipleUPIData;

      state.isResetPassword =
        payload.isResetPassword !== undefined
          ? payload.isResetPassword
          : state.isResetPassword;
      state.ResetPasswordData =
        payload.ResetPasswordData !== undefined
          ? payload.ResetPasswordData
          : state.ResetPasswordData;


      state.isGetPincodeLatLongGST =
        payload.isGetPincodeLatLongGST !== undefined
          ? payload.isGetPincodeLatLongGST
          : state.isGetPincodeLatLongGST;
      state.GetPincodeLatLongGSTData =
        payload.GetPincodeLatLongGSTData !== undefined
          ? payload.GetPincodeLatLongGSTData
          : state.GetPincodeLatLongGSTData;

      state.isGetPincodeLatLongIEC =
        payload.isGetPincodeLatLongIEC !== undefined
          ? payload.isGetPincodeLatLongIEC
          : state.isGetPincodeLatLongIEC;
      state.GetPincodeLatLongIECData =
        payload.GetPincodeLatLongIECData !== undefined
          ? payload.GetPincodeLatLongIECData
          : state.GetPincodeLatLongIECData;

      state.location =
        payload.location !== undefined ? payload.location : state.location;

      state.isMobileToMSME =
        payload.isMobileToMSME !== undefined
          ? payload.isMobileToMSME
          : state.isMobileToMSME;
      state.MobileToMSMEData =
        payload.MobileToMSMEData !== undefined
          ? payload.MobileToMSMEData
          : state.MobileToMSMEData;

      state.isGetCINDetailsCountByLastXDays =
        payload.isGetCINDetailsCountByLastXDays !== undefined
          ? payload.isGetCINDetailsCountByLastXDays
          : state.isGetCINDetailsCountByLastXDays;
      state.GetCINDetailsCountByLastXDaysData =
        payload.GetCINDetailsCountByLastXDaysData !== undefined
          ? payload.GetCINDetailsCountByLastXDaysData
          : state.GetCINDetailsCountByLastXDaysData;

      state.isGetDashboardGstCinCount =
        payload.isGetDashboardGstCinCount !== undefined
          ? payload.isGetDashboardGstCinCount
          : state.isGetDashboardGstCinCount;
      state.GetDashboardGstCinCountData =
        payload.GetDashboardGstCinCountData !== undefined
          ? payload.GetDashboardGstCinCountData
          : state.GetDashboardGstCinCountData;

      state.isGetNewCINDetailsCountByLastXDays =
        payload.isGetNewCINDetailsCountByLastXDays !== undefined
          ? payload.isGetNewCINDetailsCountByLastXDays
          : state.isGetNewCINDetailsCountByLastXDays;
      state.GetNewCINDetailsCountByLastXDaysData =
        payload.GetNewCINDetailsCountByLastXDaysData !== undefined
          ? payload.GetNewCINDetailsCountByLastXDaysData
          : state.GetNewCINDetailsCountByLastXDaysData;

      state.isGetPdfRequestList =
        payload.isGetPdfRequestList !== undefined
          ? payload.isGetPdfRequestList
          : state.isGetPdfRequestList;
      state.GetPdfRequestListData =
        payload.GetPdfRequestListData !== undefined
          ? payload.GetPdfRequestListData
          : state.GetPdfRequestListData;

      state.isSearchCompanyName =
        payload.isSearchCompanyName !== undefined
          ? payload.isSearchCompanyName
          : state.isSearchCompanyName;
      state.SearchCompanyNameData =
        payload.SearchCompanyNameData !== undefined
          ? payload.SearchCompanyNameData
          : state.SearchCompanyNameData;

      state.isSearchCompanyNameGSt =
        payload.isSearchCompanyNameGSt !== undefined
          ? payload.isSearchCompanyNameGSt
          : state.isSearchCompanyNameGSt;
      state.SearchCompanyNameGStData =
        payload.SearchCompanyNameGStData !== undefined
          ? payload.SearchCompanyNameGStData
          : state.SearchCompanyNameGStData;

      state.isEwalletHistory =
        payload.isEwalletHistory !== undefined
          ? payload.isEwalletHistory
          : state.isEwalletHistory;
      state.EwalletHistoryData =
        payload.EwalletHistoryData !== undefined
          ? payload.EwalletHistoryData
          : state.EwalletHistoryData;

      state.isGstverify =
        payload.isGstverify !== undefined
          ? payload.isGstverify
          : state.isGstverify;
      state.GstverifyData =
        payload.GstverifyData !== undefined
          ? payload.GstverifyData
          : state.GstverifyData;

      state.isUploadCIN =
        payload.isUploadCIN !== undefined
          ? payload.isUploadCIN
          : state.isUploadCIN;
      state.UploadCINData =
        payload.UploadCINData !== undefined
          ? payload.UploadCINData
          : state.UploadCINData;

      state.isCINDetailsByDate =
        payload.isCINDetailsByDate !== undefined
          ? payload.isCINDetailsByDate
          : state.isCINDetailsByDate;
      state.CINDetailsByDateData =
        payload.CINDetailsByDateData !== undefined
          ? payload.CINDetailsByDateData
          : state.CINDetailsByDateData;

      state.isGetPincodeLatLong =
        payload.isGetPincodeLatLong !== undefined
          ? payload.isGetPincodeLatLong
          : state.isGetPincodeLatLong;
      state.GetPincodeLatLongData =
        payload.GetPincodeLatLongData !== undefined
          ? payload.GetPincodeLatLongData
          : state.GetPincodeLatLongData;

      state.isUsersignup =
        payload.isUsersignup !== undefined
          ? payload.isUsersignup
          : state.isUsersignup;
      state.UsersignupData =
        payload.UsersignupData !== undefined
          ? payload.UsersignupData
          : state.UsersignupData;

      state.isGetCINAddressByPin =
        payload.isGetCINAddressByPin !== undefined
          ? payload.isGetCINAddressByPin
          : state.isGetCINAddressByPin;
      state.GetCINAddressByPinData =
        payload.GetCINAddressByPinData !== undefined
          ? payload.GetCINAddressByPinData
          : state.GetCINAddressByPinData;

      state.isUsersigninNaviget =
        payload.isUsersigninNaviget !== undefined
          ? payload.isUsersigninNaviget
          : state.isUsersigninNaviget;

      state.isUsersigninNaviget =
        payload.isUsersigninNaviget !== undefined
          ? payload.isUsersigninNaviget
          : state.isUsersigninNaviget;

      state.isUsersignin =
        payload.isUsersignin !== undefined
          ? payload.isUsersignin
          : state.isUsersignin;
      state.UsersigninData =
        payload.UsersigninData !== undefined
          ? payload.UsersigninData
          : state.UsersigninData;

      state.isGSTByLastDays =
        payload.isGSTByLastDays !== undefined
          ? payload.isGSTByLastDays
          : state.isGSTByLastDays;
      state.GSTByLastDaysData =
        payload.GSTByLastDaysData !== undefined
          ? payload.GSTByLastDaysData
          : state.GSTByLastDaysData;

      state.isGSTByLastDaysPincode =
        payload.isGSTByLastDaysPincode !== undefined
          ? payload.isGSTByLastDaysPincode
          : state.isGSTByLastDaysPincode;
      state.GSTByLastDaysPincodeData =
        payload.GSTByLastDaysPincodeData !== undefined
          ? payload.GSTByLastDaysPincodeData
          : state.GSTByLastDaysPincodeData;

      state.isGetNewGSTDetailsCountByLastXDays =
        payload.isGetNewGSTDetailsCountByLastXDays !== undefined
          ? payload.isGetNewGSTDetailsCountByLastXDays
          : state.isGetNewGSTDetailsCountByLastXDays;
      state.GetNewGSTDetailsCountByLastXDaysData =
        payload.GetNewGSTDetailsCountByLastXDaysData !== undefined
          ? payload.GetNewGSTDetailsCountByLastXDaysData
          : state.GetNewGSTDetailsCountByLastXDaysData;

      state.isDarpanByLastDay =
        payload.isDarpanByLastDay !== undefined
          ? payload.isDarpanByLastDay
          : state.isDarpanByLastDay;
      state.DarpanByLastDayData =
        payload.DarpanByLastDayData !== undefined
          ? payload.DarpanByLastDayData
          : state.DarpanByLastDayData;

      state.isIECByLastDays =
        payload.isIECByLastDays !== undefined
          ? payload.isIECByLastDays
          : state.isIECByLastDays;
      state.IECByLastDaysData =
        payload.IECByLastDaysData !== undefined
          ? payload.IECByLastDaysData
          : state.IECByLastDaysData;

      state.isEmailAvlebl =
        payload.isEmailAvlebl !== undefined
          ? payload.isEmailAvlebl
          : state.isEmailAvlebl;

      state.navigetName =
        payload.navigetName !== undefined
          ? payload.navigetName
          : state.navigetName;

      state.EwalletData =
        payload.EwalletData !== undefined
          ? payload.EwalletData
          : state.EwalletData;
      state.isEwallet =
        payload.isEwallet !== undefined ? payload.isEwallet : state.isEwallet;
      state.Ewalletexpired =
        payload.Ewalletexpired !== undefined
          ? payload.Ewalletexpired
          : state.Ewalletexpired;

      state.isSaveUser =
        payload.isSaveUser !== undefined
          ? payload.isSaveUser
          : state.isSaveUser;
      state.isEmailverify =
        payload.isEmailverify !== undefined
          ? payload.isEmailverify
          : state.isEmailverify;
      state.isSignin =
        payload.isSignin !== undefined ? payload.isSignin : state.isSignin;

      state.isMobile360 =
        payload.isMobile360 !== undefined
          ? payload.isMobile360
          : state.isMobile360;
      state.Mobile360Data =
        payload.Mobile360Data !== undefined
          ? payload.Mobile360Data
          : state.Mobile360Data;

      state.isCin = payload.isCin !== undefined ? payload.isCin : state.isCin;
      state.CinData =
        payload.CinData !== undefined ? payload.CinData : state.CinData;

      state.isSearchCINByAdvanceSearch =
        payload.isSearchCINByAdvanceSearch !== undefined
          ? payload.isSearchCINByAdvanceSearch
          : state.isSearchCINByAdvanceSearch;
      state.SearchCINByAdvanceSearchData =
        payload.SearchCINByAdvanceSearchData !== undefined
          ? payload.SearchCINByAdvanceSearchData
          : state.SearchCINByAdvanceSearchData;

      state.isDesboadSearchCINByAdvanceSearch =
        payload.isDesboadSearchCINByAdvanceSearch !== undefined
          ? payload.isDesboadSearchCINByAdvanceSearch
          : state.isDesboadSearchCINByAdvanceSearch;
      state.DesboadSearchCINByAdvanceSearchData =
        payload.DesboadSearchCINByAdvanceSearchData !== undefined
          ? payload.DesboadSearchCINByAdvanceSearchData
          : state.DesboadSearchCINByAdvanceSearchData;

      state.isDesboadSearchGSTByAdvanceSearch =
        payload.isDesboadSearchGSTByAdvanceSearch !== undefined
          ? payload.isDesboadSearchGSTByAdvanceSearch
          : state.isDesboadSearchGSTByAdvanceSearch;

      state.isSearchGSTByAdvanceSearch =
        payload.isSearchGSTByAdvanceSearch !== undefined
          ? payload.isSearchGSTByAdvanceSearch
          : state.isSearchGSTByAdvanceSearch;
      state.SearchGSTByAdvanceSearchData =
        payload.SearchGSTByAdvanceSearchData !== undefined
          ? payload.SearchGSTByAdvanceSearchData
          : state.SearchGSTByAdvanceSearchData;

      state.isCinGetIndustryList =
        payload.isCinGetIndustryList !== undefined
          ? payload.isCinGetIndustryList
          : state.isCinGetIndustryList;
      state.CinGetIndustryListData =
        payload.CinGetIndustryListData !== undefined
          ? payload.CinGetIndustryListData
          : state.CinGetIndustryListData;

      state.isCinGetSegmentList =
        payload.isCinGetSegmentList !== undefined
          ? payload.isCinGetSegmentList
          : state.isCinGetSegmentList;
      state.CinGetSegmentListData =
        payload.CinGetSegmentListData !== undefined
          ? payload.CinGetSegmentListData
          : state.CinGetSegmentListData;

      state.isGetDashboardCount =
        payload.isGetDashboardCount !== undefined
          ? payload.isGetDashboardCount
          : state.isGetDashboardCount;

      state.isEcommerce =
        payload.isEcommerce !== undefined
          ? payload.isEcommerce
          : state.isEcommerce;
      state.EcommerceData =
        payload.EcommerceData !== undefined
          ? payload.EcommerceData
          : state.EcommerceData;

      state.isDin = payload.isDin !== undefined ? payload.isDin : state.isDin;
      state.DinData =
        payload.DinData !== undefined ? payload.DinData : state.DinData;

      state.isMsme =
        payload.isMsme !== undefined ? payload.isMsme : state.isMsme;
      state.MsmeData =
        payload.MsmeData !== undefined ? payload.MsmeData : state.MsmeData;

      state.isPanSearch =
        payload.isPanSearch !== undefined
          ? payload.isPanSearch
          : state.isPanSearch;
      state.PanSearchData =
        payload.PanSearchData !== undefined
          ? payload.PanSearchData
          : state.PanSearchData;



      state.isGetNewGSTList =
        payload.isGetNewGSTList !== undefined
          ? payload.isGetNewGSTList
          : state.isGetNewGSTList;
      state.GetNewGSTListData =
        payload.GetNewGSTListData !== undefined
          ? payload.GetNewGSTListData
          : state.GetNewGSTListData;

      state.isGetMCAReport =
        payload.isGetMCAReport !== undefined
          ? payload.isGetMCAReport
          : state.isGetMCAReport;

      state.isGetBankMasterDataList =
        payload.isGetBankMasterDataList !== undefined
          ? payload.isGetBankMasterDataList
          : state.isGetBankMasterDataList;

      state.isGetPopulationMasterDataList =
        payload.isGetPopulationMasterDataList !== undefined
          ? payload.isGetPopulationMasterDataList
          : state.isGetPopulationMasterDataList;

      state.GetMCAReportData =
        payload.GetMCAReportData !== undefined
          ? payload.GetMCAReportData
          : state.GetMCAReportData;

      state.isGetNewGSTDetail =
        payload.isGetNewGSTDetail !== undefined
          ? payload.isGetNewGSTDetail
          : state.isGetNewGSTDetail;
      state.GetNewGSTDetailData =
        payload.GetNewGSTDetailData !== undefined
          ? payload.GetNewGSTDetailData
          : state.GetNewGSTDetailData;

      state.isGstContact =
        payload.isGstContact !== undefined
          ? payload.isGstContact
          : state.isGstContact;
      state.GstContactData =
        payload.GstContactData !== undefined
          ? payload.GstContactData
          : state.GstContactData;

      state.isUsersignup =
        payload.isUsersignup !== undefined
          ? payload.isUsersignup
          : state.isUsersignup;

      state.isSendmobileotp =
        payload.isSendmobileotp !== undefined
          ? payload.isSendmobileotp
          : state.isSendmobileotp;

      state.isSendemailotp =
        payload.isSendemailotp !== undefined
          ? payload.isSendemailotp
          : state.isSendemailotp;

      state.isGetCoordinates =
        payload.isGetCoordinates !== undefined
          ? payload.isGetCoordinates
          : state.isGetCoordinates;
      state.GetCoordinatesData =
        payload.GetCoordinatesData !== undefined
          ? payload.GetCoordinatesData
          : state.GetCoordinatesData;

      state.isGetDashboardCategoryCount =
        payload.isGetDashboardCategoryCount !== undefined
          ? payload.isGetDashboardCategoryCount
          : state.isGetDashboardCategoryCount;
      state.GetDashboardCategoryCountData =
        payload.GetDashboardCategoryCountData !== undefined
          ? payload.GetDashboardCategoryCountData
          : state.GetDashboardCategoryCountData;

      state.isError =
        payload.isError !== undefined ? payload.isError : state.isError;
      state.errorMessage =
        payload.errorMessage !== undefined
          ? payload.errorMessage
          : state.errorMessage;
      return state;
    },
  },
  extraReducers: (builder) => {
    //========= GetPincodeLatLongGST
    builder.addCase(GetPincodeLatLongGST.fulfilled, (state, { payload }) => {
      try {
        state.GetPincodeLatLongGSTData = payload;
        state.isGetPincodeLatLongGST = true;
        state.isGetPincodeLatLongGSTFetching = false;

        state.isError = false;
        state.errorMessage = "";
        return state;
      } catch (error) {
        console.error(
          "Error: GetPincodeLatLongGST.fulfilled try catch error >>",
          error
        );
      }
    });
    builder.addCase(GetPincodeLatLongGST.rejected, (state, { payload }) => {
      try {
        state.GetPincodeLatLongGSTData = {};
        state.isGetPincodeLatLongGST = false;
        state.isGetPincodeLatLongGSTFetching = false;
        state.isError = true;
        payload
          ? (state.errorMessage = payload.error.message
            ? "Please try again (There was some network issue)."
            : "Please try again (There was some network issue).")
          : (state.errorMessage = "API Response Invalid. Please Check API");
      } catch (error) {
        console.error(
          "Error: [GetPincodeLatLongGST.rejected] try catch error >>",
          error
        );
      }
    });
    builder.addCase(GetPincodeLatLongGST.pending, (state) => {
      state.isGetPincodeLatLongGSTFetching = true;
    });

    //========= GetPincodeLatLongIEC
    builder.addCase(GetPincodeLatLongIEC.fulfilled, (state, { payload }) => {
      try {
        state.GetPincodeLatLongIECData = payload;
        state.isGetPincodeLatLongIEC = true;
        state.isGetPincodeLatLongIECFetching = false;

        state.isError = false;
        state.errorMessage = "";
        return state;
      } catch (error) {
        console.error(
          "Error: GetPincodeLatLongIEC.fulfilled try catch error >>",
          error
        );
      }
    });
    builder.addCase(GetPincodeLatLongIEC.rejected, (state, { payload }) => {
      try {
        state.GetPincodeLatLongIECData = {};
        state.isGetPincodeLatLongIEC = false;
        state.isGetPincodeLatLongIECFetching = false;
        state.isError = true;
        payload
          ? (state.errorMessage = payload.error.message
            ? "Please try again (There was some network issue)."
            : "Please try again (There was some network issue).")
          : (state.errorMessage = "API Response Invalid. Please Check API");
      } catch (error) {
        console.error(
          "Error: [GetPincodeLatLongIEC.rejected] try catch error >>",
          error
        );
      }
    });
    builder.addCase(GetPincodeLatLongIEC.pending, (state) => {
      state.isGetPincodeLatLongIECFetching = true;
    });

    //========= Usersignin
    builder.addCase(Usersignin.fulfilled, (state, { payload }) => {
      console.log("datratatatat", payload);
      try {
        if (payload?.data?.two_factor_authentication) {
          state.UsersignupData = payload;

          state.isUsersigninotp = true;
          state.isUsersigninFetching = false;

          state.isError = false;
          state.errorMessage = "";
          return state;

        } else {
          state.UsersignupData = payload;
          state.isUsersigninNaviget = payload?.data?.is_corporate;

          state.isUsersignin = true;
          state.isUsersigninFetching = false;

          state.isError = false;
          state.errorMessage = "";
          return state;

        }

      } catch (error) {
        console.error("Error: Usersignin.fulfilled try catch error >>", error);
      }
    });
    builder.addCase(Usersignin.rejected, (state, { payload }) => {
      try {
        state.UsersignupData = {};
        state.isUsersignin = false;
        state.isUsersigninFetching = false;
        state.isError = true;
        payload
          ? (state.errorMessage = payload.error
            ? payload.error
            : "Invalid Username And Password")
          : (state.errorMessage = "API Response Invalid. Please Check API");
      } catch (error) {
        console.error(
          "Error: [UserUsersignin.rejected] try catch error >>",
          error
        );
      }
    });
    builder.addCase(Usersignin.pending, (state) => {
      state.isUsersigninFetching = true;
    });
    //========= Verifyotp
    builder.addCase(Verifyotp.fulfilled, (state, { payload }) => {
      console.log("payloadVerifyotp", payload);
      try {
        state.VerifyotpData = payload;
        state.isUsersigninotp = false;
        state.isVerifyotpFetching = false;
        state.isUsersigninNaviget = payload?.adminTrue;
        state.isUsersignin = true;

        state.isError = false;
        state.errorMessage = "";
        return state;
      } catch (error) {
        console.error("Error: Verifyotp.fulfilled try catch error >>", error);
        return state;
      }
    });
    builder.addCase(Verifyotp.rejected, (state, { payload }) => {
      try {
        state.isVerifyotpFetching = false;
        state.isError = true;
        payload
          ? (state.errorMessage = payload.error
            ? payload.error
            : "Invalid OTP")
          : (state.errorMessage = "API Response Invalid. Please Check API");
      } catch (error) {
        console.error(
          "Error: [Verifyotp.rejected] try catch error >>",
          error
        );
      }
    });
    builder.addCase(Verifyotp.pending, (state) => {
      state.isVerifyotpFetching = true;
    });
    //========= ReUsersignin
    builder.addCase(ReUsersignin.fulfilled, (state, { payload }) => {
      try {
        state.ReUsersigninData = payload;
        state.isReUsersignin = true;
        state.isReUsersigninFetching = false;

        state.isError = false;
        state.errorMessage = "";
        return state;
      } catch (error) {
        console.error(
          "Error: ReUsersignin.fulfilled try catch error >>",
          error
        );
      }
    });
    builder.addCase(ReUsersignin.rejected, (state, { payload }) => {
      try {
        state.ReUsersigninData = {};
        state.isReUsersignin = false;
        state.isReUsersigninFetching = false;
        state.isError = true;
        payload
          ? (state.errorMessage = payload.error
            ? payload.error
            : "Invalid Username And Password")
          : (state.errorMessage = "API Response Invalid. Please Check API");
      } catch (error) {
        console.error(
          "Error: [UserReUsersignin.rejected] try catch error >>",
          error
        );
      }
    });
    builder.addCase(ReUsersignin.pending, (state) => {
      state.isReUsersigninFetching = true;
    });

    //========= UpdateProfile
    builder.addCase(UpdateProfile.fulfilled, (state, { payload }) => {
      try {
        state.UpdateProfileData = payload;
        state.isUpdateProfile = true;
        state.isUpdateProfileFetching = false;

        state.isError = false;
        state.errorMessage = "";
        return state;
      } catch (error) {
        console.error(
          "Error: UpdateProfile.fulfilled try catch error >>",
          error
        );
      }
    });
    builder.addCase(UpdateProfile.rejected, (state, { payload }) => {
      try {
        state.UpdateProfileData = {};
        state.isUpdateProfile = false;
        state.isUpdateProfileFetching = false;
        state.isError = true;
        payload
          ? (state.errorMessage = payload.error.message
            ? "Please try again (There was some network issue)."
            : "Please try again (There was some network issue).")
          : (state.errorMessage = "API Response Invalid. Please Check API");
      } catch (error) {
        console.error(
          "Error: [UpdateProfile.rejected] try catch error >>",
          error
        );
      }
    });
    builder.addCase(UpdateProfile.pending, (state) => {
      state.isUpdateProfileFetching = true;
    });
    //========= ResetPassword
    builder.addCase(ResetPassword.fulfilled, (state, { payload }) => {
      try {
        state.ResetPasswordData = payload;
        state.isResetPassword = true;
        state.isResetPasswordFetching = false;

        state.isError = false;
        state.errorMessage = "";
        return state;
      } catch (error) {
        console.error(
          "Error: ResetPassword.fulfilled try catch error >>",
          error
        );
      }
    });
    builder.addCase(ResetPassword.rejected, (state, { payload }) => {
      try {
        state.ResetPasswordData = {};
        state.isResetPassword = false;
        state.isResetPasswordFetching = false;
        state.isError = true;
        payload
          ? (state.errorMessage = payload.error.message
            ? payload.error.message
            : payload.error)
          : (state.errorMessage = "API Response Invalid. Please Check API");
      } catch (error) {
        console.error(
          "Error: [ResetPassword.rejected] try catch error >>",
          error
        );
      }
    });
    builder.addCase(ResetPassword.pending, (state) => {
      state.isResetPasswordFetching = true;
    });
    //========= SavePdfRequest
    builder.addCase(SavePdfRequest.fulfilled, (state, { payload }) => {
      try {
        state.SavePdfRequestData = payload;
        state.isSavePdfRequest = true;
        state.isSavePdfRequestFetching = false;

        state.isError = false;
        state.errorMessage = "";
        return state;
      } catch (error) {
        console.error(
          "Error: SavePdfRequest.fulfilled try catch error >>",
          error
        );
      }
    });
    builder.addCase(SavePdfRequest.rejected, (state, { payload }) => {
      try {
        state.SavePdfRequestData = {};
        state.isSavePdfRequest = false;
        state.isSavePdfRequestFetching = false;
        state.isError = true;
        payload
          ? (state.errorMessage = payload.error.message
            ? payload.error.message
            : payload.error)
          : (state.errorMessage = "API Response Invalid. Please Check API");
      } catch (error) {
        console.error(
          "Error: [SavePdfRequest.rejected] try catch error >>",
          error
        );
      }
    });
    builder.addCase(SavePdfRequest.pending, (state) => {
      state.isSavePdfRequestFetching = true;
    });
    //========= SaveUserPinCode
    builder.addCase(SaveUserPinCode.fulfilled, (state, { payload }) => {
      try {
        state.isSaveUserPinCode = true;
        state.isSaveUserPinCodeFetching = false;

        state.isError = false;
        state.errorMessage = "";
        return state;
      } catch (error) {
        console.error(
          "Error: SaveUserPinCode.fulfilled try catch error >>",
          error
        );
      }
    });
    builder.addCase(SaveUserPinCode.rejected, (state, { payload }) => {
      try {
        state.SaveUserPinCodeData = {};
        state.isSaveUserPinCode = false;
        state.isSaveUserPinCodeFetching = false;
        state.isError = true;
        payload
          ? (state.errorMessage = payload.error.message
            ? payload.error.message
            : payload.error)
          : (state.errorMessage = "API Response Invalid. Please Check API");
      } catch (error) {
        console.error(
          "Error: [SaveUserPinCode.rejected] try catch error >>",
          error
        );
      }
    });
    builder.addCase(SaveUserPinCode.pending, (state) => {
      state.isSaveUserPinCodeFetching = true;
    });
    //========= Emailverify
    builder.addCase(Emailverify.fulfilled, (state, { payload }) => {
      try {
        state.EmailverifyData = payload;
        state.isEmailverify = true;
        state.isEmailverifyFetching = false;

        state.isError = false;
        state.errorMessage = "";
        return state;
      } catch (error) {
        console.error("Error: Emailverify.fulfilled try catch error >>", error);
      }
    });
    builder.addCase(Emailverify.rejected, (state, { payload }) => {
      try {
        state.EmailverifyData = {};
        state.isEmailverify = false;
        state.isEmailAvlebl = !payload.error.success;
        state.isEmailverifyFetching = false;
        state.isError = true;
        payload
          ? (state.errorMessage = payload.error.message_detail
            ? payload.error.message_detail
            : payload.error)
          : (state.errorMessage = "API Response Invalid. Please Check API");
      } catch (error) {
        console.error(
          "Error: [Emailverify.rejected] try catch error >>",
          error
        );
      }
    });
    builder.addCase(Emailverify.pending, (state) => {
      state.isEmailverifyFetching = true;
    });
    //========= Gstverify
    builder.addCase(Gstverify.fulfilled, (state, { payload }) => {
      try {
        state.GstverifyData = payload.data;
        state.isGstverify = true;
        state.isGstverifyFetching = false;

        state.isError = false;
        state.errorMessage = "";
        return state;
      } catch (error) {
        console.error("Error: Gstverify.fulfilled try catch error >>", error);
      }
    });
    builder.addCase(Gstverify.rejected, (state, { payload }) => {
      try {
        state.GstverifyData = {};
        state.isGstverify = false;
        state.isGstverifyFetching = false;
        state.isError = true;
        payload
          ? (state.errorMessage = payload.error.message_detail
            ? "Please try again (There was some network issue)."
            : "Failed to retrieve GST contact details.")
          : (state.errorMessage = "API Response Invalid. Please Check API");
      } catch (error) {
        console.error("Error: [Gstverify.rejected] try catch error >>", error);
      }
    });
    builder.addCase(Gstverify.pending, (state) => {
      state.isGstverifyFetching = true;
    });

    //========= Usersignup
    builder.addCase(Usersignup.fulfilled, (state, { payload }) => {
      try {
        state.isUsersignup = true;
        state.isUsersignupFetching = false;
        state.isError = false;
        state.errorMessage = "";
        return state;
      } catch (error) {
        console.error("Error: Usersignup.fulfilled try catch error >>", error);
      }
    });
    builder.addCase(Usersignup.rejected, (state, { payload }) => {
      try {
        state.isUsersignup = false;
        state.isUsersignupFetching = false;
        state.isError = true;
        payload
          ? (state.errorMessage = payload.error.message_detail
            ? payload.error.message_detail
            : payload.error)
          : (state.errorMessage = "API Response Invalid. Please Check API");
      } catch (error) {
        console.error("Error: [Usersignup.rejected] try catch error >>", error);
      }
    });
    builder.addCase(Usersignup.pending, (state) => {
      state.isUsersignupFetching = true;
    });
    //========= Ecommerce
    builder.addCase(Ecommerce.fulfilled, (state, { payload }) => {
      try {
        state.isEcommerce = true;
        state.EcommerceData = payload;
        state.isEcommerceFetching = false;
        state.isError = false;
        state.errorMessage = "";
        return state;
      } catch (error) {
        console.error("Error: Ecommerce.fulfilled try catch error >>", error);
      }
    });
    builder.addCase(Ecommerce.rejected, (state, { payload }) => {
      try {
        state.isEcommerce = false;
        state.isEcommerceFetching = false;
        state.isError = true;
        payload
          ? (state.errorMessage = payload.error.message_detail
            ? payload.error.message_detail
            : payload.error)
          : (state.errorMessage = "API Response Invalid. Please Check API");
      } catch (error) {
        console.error("Error: [Ecommerce.rejected] try catch error >>", error);
      }
    });
    builder.addCase(Ecommerce.pending, (state) => {
      state.isEcommerceFetching = true;
    });
    //========= Gstsearch
    builder.addCase(Gstsearch.fulfilled, (state, { payload }) => {
      try {
        state.isGstsearch = true;
        state.GstsearchData = payload;

        state.isGstsearchFetching = false;
        state.isError = false;
        state.errorMessage = "";
        return state;
      } catch (error) {
        console.error("Error: Gstsearch.fulfilled try catch error >>", error);
      }
    });
    builder.addCase(Gstsearch.rejected, (state, { payload }) => {
      try {
        state.GstsearchData = {};
        state.isGstsearch = false;
        state.isGstsearchFetching = false;
        state.isError = true;
        payload
          ? (state.errorMessage = payload.error
            ? "Please try again (There was some network issue)."
            : "Please try again (There was some network issue).")
          : (state.errorMessage = "API Response Invalid. Please Check API");
      } catch (error) {
        console.error("Error: [Gstsearch.rejected] try catch error >>", error);
      }
    });
    builder.addCase(Gstsearch.pending, (state) => {
      state.isGstsearchFetching = true;
    });
    builder.addCase(GetMasterDataList.fulfilled, (state, { payload }) => {
      try {
        state.isGetMasterDataList = true;
        state.GetMasterDataListData = payload?.data;

        state.isGetMasterDataListFetching = false;
        state.isError = false;
        state.errorMessage = "";
        return state;
      } catch (error) {
        console.error("Error: GetMasterDataList.fulfilled try catch error >>", error);
      }
    });
    builder.addCase(GetMasterDataList.rejected, (state, { payload }) => {
      try {
        state.GetMasterDataListData = {};
        state.isGetMasterDataList = false;
        state.isGetMasterDataListFetching = false;
        state.isError = true;
        payload
          ? (state.errorMessage = payload.error
            ? "Please try again (There was some network issue)."
            : "Please try again (There was some network issue).")
          : (state.errorMessage = "API Response Invalid. Please Check API");
      } catch (error) {
        console.error("Error: [GetMasterDataList.rejected] try catch error >>", error);
      }
    });
    builder.addCase(GetMasterDataList.pending, (state) => {
      state.isGetMasterDataListFetching = true;
    });
    //========= MobileToMultipleUPI
    builder.addCase(MobileToMultipleUPI.fulfilled, (state, { payload }) => {
      try {
        state.isMobileToMultipleUPI = true;
        state.MobileToMultipleUPIData = payload;

        state.isMobileToMultipleUPIFetching = false;
        state.isError = false;
        state.errorMessage = "";
        return state;
      } catch (error) {
        console.error(
          "Error: MobileToMultipleUPI.fulfilled try catch error >>",
          error
        );
      }
    });
    builder.addCase(MobileToMultipleUPI.rejected, (state, { payload }) => {
      try {
        state.MobileToMultipleUPIData = [];
        state.isMobileToMultipleUPI = false;
        state.isMobileToMultipleUPIFetching = false;
        // state.isError = true;
        // payload
        //     ? (state.errorMessage = payload.error
        //         ? "Please try again (There was some network issue For UPI)."
        //         : 'Please try again (There was some network issue For UPI).')
        //     : (state.errorMessage = 'API Response Invalid. Please Check API');
      } catch (error) {
        console.error(
          "Error: [MobileToMultipleUPI.rejected] try catch error >>",
          error
        );
      }
    });
    builder.addCase(MobileToMultipleUPI.pending, (state) => {
      state.isMobileToMultipleUPIFetching = true;
    });
    //========= GstsearchRefreshDetails
    builder.addCase(GstsearchRefreshDetails.fulfilled, (state, { payload }) => {
      try {
        state.isGstsearch = true;
        state.GstsearchData = payload;
        state.isGstsearchRefreshDetailsFetching = false;
        state.isError = false;
        state.errorMessage = "";
        return state;
      } catch (error) {
        console.error(
          "Error: GstsearchRefreshDetails.fulfilled try catch error >>",
          error
        );
      }
    });
    builder.addCase(GstsearchRefreshDetails.rejected, (state, { payload }) => {
      try {
        // state.GstsearchData = {};
        state.isGstsearch = false;
        state.isGstsearchRefreshDetailsFetching = false;
        state.isError = true;
        payload
          ? (state.errorMessage = payload.error
            ? payload.error
            : "Please try again (There was some network issue).")
          : (state.errorMessage = "API Response Invalid. Please Check API");
      } catch (error) {
        console.error(
          "Error: [GstsearchRefreshDetails.rejected] try catch error >>",
          error
        );
      }
    });
    builder.addCase(GstsearchRefreshDetails.pending, (state) => {
      state.isGstsearchRefreshDetailsFetching = true;
    });
    //========= RefreshCinDINDetails
    builder.addCase(RefreshCinDINDetails.fulfilled, (state, { payload }) => {
      try {
        if (state.CinData) {
          state.CinData.cIN_DINs = payload;
        }
        state.isRefreshCinDINDetails = true;
        state.RefreshCinDINDetailsData = payload;
        state.isRefreshCinDINDetailsFetching = false;
        state.isError = false;
        state.errorMessage = "";
        return state;
      } catch (error) {
        console.error(
          "Error: RefreshCinDINDetails.fulfilled try catch error >>",
          error
        );
      }
    });
    builder.addCase(RefreshCinDINDetails.rejected, (state, { payload }) => {
      try {
        // state.GstsearchData = {};
        state.isRefreshCinDINDetails = false;
        state.isRefreshCinDINDetailsFetching = false;
        state.isError = true;
        payload
          ? (state.errorMessage = payload.error
            ? "Please try again (There was some network issue)."
            : "Please try again (There was some network issue).")
          : (state.errorMessage = "API Response Invalid. Please Check API");
      } catch (error) {
        console.error(
          "Error: [RefreshCinDINDetails.rejected] try catch error >>",
          error
        );
      }
    });
    builder.addCase(RefreshCinDINDetails.pending, (state) => {
      state.isRefreshCinDINDetailsFetching = true;
    });
    //========= RefreshDINDetailsByDIN
    builder.addCase(RefreshDINDetailsByDIN.fulfilled, (state, { payload }) => {
      try {
        if (state.CinData) {
          const payloadData = payload;
          const updated = state.CinData?.cIN_DINs?.map((item) => {
            if (item.din === payloadData?.din) {
              return {
                ...item,
                mobileNumberRe: payloadData.mobileNumber,
                emailIdRe: payloadData.emailId,
              };
            }
            return item;
          });
          state.CinData.cIN_DINs = updated;
        }
        if (state.DinData) {
          const payloadData = payload;
          const updated = state.DinData?.map((item) => {
            if (item.din === payloadData?.din) {
              return {
                ...item,
                mobileNumberRe: payloadData.mobileNumber,
                emailIdRe: payloadData.emailId,
              };
            }
            return item;
          });
          state.DinData = updated;
        }
        state.isRefreshDINDetailsByDIN = true;
        state.RefreshDINDetailsByDINData = payload;
        state.isRefreshDINDetailsByDINFetching = false;
        state.isError = false;
        state.errorMessage = "";
        return state;
      } catch (error) {
        console.error(
          "Error: RefreshDINDetailsByDIN.fulfilled try catch error >>",
          error
        );
      }
    });
    builder.addCase(RefreshDINDetailsByDIN.rejected, (state, { payload }) => {
      try {
        // state.GstsearchData = {};
        state.isRefreshDINDetailsByDIN = false;
        state.isRefreshDINDetailsByDINFetching = false;
        state.isError = true;
        payload
          ? (state.errorMessage = payload.error
            ? "Please try again (There was some network issue)."
            : "Please try again (There was some network issue).")
          : (state.errorMessage = "API Response Invalid. Please Check API");
      } catch (error) {
        console.error(
          "Error: [RefreshDINDetailsByDIN.rejected] try catch error >>",
          error
        );
      }
    });
    builder.addCase(RefreshDINDetailsByDIN.pending, (state) => {
      state.isRefreshDINDetailsByDINFetching = true;
    });
    //========= GetGSTCINDetailByEmail
    builder.addCase(GetGSTCINDetailByEmail.fulfilled, (state, { payload }) => {
      try {
        state.isGetGSTCINDetailByEmail = true;
        state.GetGSTCINDetailByEmailData = payload;

        state.isGetGSTCINDetailByEmailFetching = false;
        state.isError = false;
        state.errorMessage = "";
        return state;
      } catch (error) {
        console.error(
          "Error: GetGSTCINDetailByEmail.fulfilled try catch error >>",
          error
        );
      }
    });
    builder.addCase(GetGSTCINDetailByEmail.rejected, (state, { payload }) => {
      try {
        state.GetGSTCINDetailByEmailData = {};
        state.isGetGSTCINDetailByEmail = false;
        state.isGetGSTCINDetailByEmailFetching = false;
        state.isError = true;
        payload
          ? (state.errorMessage = payload.error
            ? "Please try again (There was some network issue)."
            : "Please try again (There was some network issue).")
          : (state.errorMessage = "API Response Invalid. Please Check API");
      } catch (error) {
        console.error(
          "Error: [GetGSTCINDetailByEmail.rejected] try catch error >>",
          error
        );
      }
    });
    builder.addCase(GetGSTCINDetailByEmail.pending, (state) => {
      state.isGetGSTCINDetailByEmailFetching = true;
    });
    //========= GetGSTDetailsBySelectedDateAllData
    builder.addCase(GetGSTDetailsBySelectedDateAllData.fulfilled, (state, { payload }) => {
      try {
        state.isGetGSTDetailsBySelectedDateAllData = true;
        state.GetGSTDetailsBySelectedDateAllDataData = payload;

        state.isGetGSTDetailsBySelectedDateAllDataFetching = false;
        state.isError = false;
        state.errorMessage = "";
        return state;
      } catch (error) {
        console.error(
          "Error: GetGSTDetailsBySelectedDateAllData.fulfilled try catch error >>",
          error
        );
      }
    });
    builder.addCase(GetGSTDetailsBySelectedDateAllData.rejected, (state, { payload }) => {
      try {
        state.GetGSTDetailsBySelectedDateAllDataData = [];
        state.isGetGSTDetailsBySelectedDateAllData = false;
        state.isGetGSTDetailsBySelectedDateAllDataFetching = false;
        state.isError = true;
        payload
          ? (state.errorMessage = payload.error
            ? payload.error
            : "Please try again (There was some network issue).")
          : (state.errorMessage = "API Response Invalid. Please Check API");
      } catch (error) {
        console.error(
          "Error: [GetGSTDetailsBySelectedDateAllData.rejected] try catch error >>",
          error
        );
      }
    });
    builder.addCase(GetGSTDetailsBySelectedDateAllData.pending, (state) => {
      state.isGetGSTDetailsBySelectedDateAllDataFetching = true;
    });
    //========= GetGSTDetailsByRegDate
    builder.addCase(GetGSTDetailsByRegDate.fulfilled, (state, { payload }) => {
      try {
        state.isGetGSTDetailsByRegDate = true;
        state.GetGSTDetailsByRegDateData = payload || [];
        state.isGetGSTDetailsByRegDateFetching = false;
        state.isError = false;
        state.errorMessage = "";
        return state;
      } catch (error) {
        console.error(
          "Error: GetGSTDetailsByRegDate.fulfilled try catch error >>",
          error
        );
      }
    });
    builder.addCase(GetGSTDetailsByRegDate.rejected, (state, { payload }) => {
      try {
        state.GetGSTDetailsByRegDateData = [];
        state.isGetGSTDetailsByRegDate = false;
        state.isGetGSTDetailsByRegDateFetching = false;
        state.isError = true;
        payload
          ? (state.errorMessage = payload.error
            ? payload.error
            : "Please try again (There was some network issue).")
          : (state.errorMessage = "API Response Invalid. Please Check API");
      } catch (error) {
        console.error(
          "Error: [GetGSTDetailsByRegDate.rejected] try catch error >>",
          error
        );
      }
    });
    builder.addCase(GetGSTDetailsByRegDate.pending, (state) => {
      state.isGetGSTDetailsByRegDateFetching = true;
    });
    //========= GetCINAddressByRegDate
    builder.addCase(GetCINAddressByRegDate.fulfilled, (state, { payload }) => {
      try {
        state.isGetCINAddressByRegDate = true;
        state.GetCINAddressByRegDateData = payload || [];
        state.isGetCINAddressByRegDateFetching = false;
        state.isError = false;
        state.errorMessage = "";
        return state;
      } catch (error) {
        console.error(
          "Error: GetCINAddressByRegDate.fulfilled try catch error >>",
          error
        );
      }
    });
    builder.addCase(GetCINAddressByRegDate.rejected, (state, { payload }) => {
      try {
        state.GetCINAddressByRegDateData = [];
        state.isGetCINAddressByRegDate = false;
        state.isGetCINAddressByRegDateFetching = false;
        state.isError = true;
        payload
          ? (state.errorMessage = payload.error
            ? payload.error
            : "Please try again (There was some network issue).")
          : (state.errorMessage = "API Response Invalid. Please Check API");
      } catch (error) {
        console.error(
          "Error: [GetCINAddressByRegDate.rejected] try catch error >>",
          error
        );
      }
    });
    builder.addCase(GetCINAddressByRegDate.pending, (state) => {
      state.isGetCINAddressByRegDateFetching = true;
    });
    //========= GetDarpanDetailsBySelectedDate
    builder.addCase(GetDarpanDetailsBySelectedDate.fulfilled, (state, { payload }) => {
      try {
        state.isGetDarpanDetailsBySelectedDate = true;
        state.GetDarpanDetailsBySelectedDateData = payload;

        state.isGetDarpanDetailsBySelectedDateFetching = false;
        state.isError = false;
        state.errorMessage = "";
        return state;
      } catch (error) {
        console.error(
          "Error: GetDarpanDetailsBySelectedDate.fulfilled try catch error >>",
          error
        );
      }
    });
    builder.addCase(GetDarpanDetailsBySelectedDate.rejected, (state, { payload }) => {
      try {
        state.GetDarpanDetailsBySelectedDateData = [];
        state.isGetDarpanDetailsBySelectedDate = false;
        state.isGetDarpanDetailsBySelectedDateFetching = false;
        state.isError = true;
        payload
          ? (state.errorMessage = payload.error
            ? payload.error
            : "Please try again (There was some network issue).")
          : (state.errorMessage = "API Response Invalid. Please Check API");
      } catch (error) {
        console.error(
          "Error: [GetDarpanDetailsBySelectedDate.rejected] try catch error >>",
          error
        );
      }
    });
    builder.addCase(GetDarpanDetailsBySelectedDate.pending, (state) => {
      state.isGetDarpanDetailsBySelectedDateFetching = true;
    });


    //========= GetAllDarpanDetailsBySelectedDate
    builder.addCase(GetAllDarpanDetailsBySelectedDate.fulfilled, (state, { payload }) => {
      try {
        state.isGetAllDarpanDetailsBySelectedDate = true;
        state.GetAllDarpanDetailsBySelectedDateData = payload;

        state.isGetAllDarpanDetailsBySelectedDateFetching = false;
        state.isError = false;
        state.errorMessage = "";
        return state;
      } catch (error) {
        console.error(
          "Error: GetAllDarpanDetailsBySelectedDate.fulfilled try catch error >>",
          error
        );
      }
    });
    builder.addCase(GetAllDarpanDetailsBySelectedDate.rejected, (state, { payload }) => {
      try {
        state.GetAllDarpanDetailsBySelectedDateData = [];
        state.isGetAllDarpanDetailsBySelectedDate = false;
        state.isGetAllDarpanDetailsBySelectedDateFetching = false;
        state.isError = true;
        payload
          ? (state.errorMessage = payload.error
            ? payload.error
            : "Please try again (There was some network issue).")
          : (state.errorMessage = "API Response Invalid. Please Check API");
      } catch (error) {
        console.error(
          "Error: [GetAllDarpanDetailsBySelectedDate.rejected] try catch error >>",
          error
        );
      }
    });
    builder.addCase(GetAllDarpanDetailsBySelectedDate.pending, (state) => {
      state.isGetAllDarpanDetailsBySelectedDateFetching = true;
    });
    //========= GetIECDetailsBySelectedDate
    builder.addCase(GetIECDetailsBySelectedDate.fulfilled, (state, { payload }) => {
      try {
        state.isGetIECDetailsBySelectedDate = true;
        state.GetIECDetailsBySelectedDateData = payload;

        state.isGetIECDetailsBySelectedDateFetching = false;
        state.isError = false;
        state.errorMessage = "";
        return state;
      } catch (error) {
        console.error(
          "Error: GetIECDetailsBySelectedDate.fulfilled try catch error >>",
          error
        );
      }
    });
    builder.addCase(GetIECDetailsBySelectedDate.rejected, (state, { payload }) => {
      try {
        state.GetIECDetailsBySelectedDateData = [];
        state.isGetIECDetailsBySelectedDate = false;
        state.isGetIECDetailsBySelectedDateFetching = false;
        state.isError = true;
        payload
          ? (state.errorMessage = payload.error
            ? payload.error
            : "Please try again (There was some network issue).")
          : (state.errorMessage = "API Response Invalid. Please Check API");
      } catch (error) {
        console.error(
          "Error: [GetIECDetailsBySelectedDate.rejected] try catch error >>",
          error
        );
      }
    });
    builder.addCase(GetIECDetailsBySelectedDate.pending, (state) => {
      state.isGetIECDetailsBySelectedDateFetching = true;
    });

    //========= GetAllIECCountByLastXDays
    builder.addCase(GetAllIECCountByLastXDays.fulfilled, (state, { payload }) => {
      try {
        state.isGetAllIECCountByLastXDays = true;
        state.GetAllIECCountByLastXDaysData = payload.data;

        state.isGetAllIECCountByLastXDaysFetching = false;
        state.isError = false;
        state.errorMessage = "";
        return state;
      } catch (error) {
        console.error(
          "Error: GetAllIECCountByLastXDays.fulfilled try catch error >>",
          error
        );
      }
    });
    builder.addCase(GetAllIECCountByLastXDays.rejected, (state, { payload }) => {
      try {
        state.GetAllIECCountByLastXDaysData = [];
        state.isGetAllIECCountByLastXDays = false;
        state.isGetAllIECCountByLastXDaysFetching = false;
        state.isError = true;
        payload
          ? (state.errorMessage = payload.error
            ? payload.error
            : "Please try again (There was some network issue).")
          : (state.errorMessage = "API Response Invalid. Please Check API");
      } catch (error) {
        console.error(
          "Error: [GetAllIECCountByLastXDays.rejected] try catch error >>",
          error
        );
      }
    });
    builder.addCase(GetAllIECCountByLastXDays.pending, (state) => {
      state.isGetAllIECCountByLastXDaysFetching = true;
    });

    //========= GetAllIECDetailsBySelectedDate
    builder.addCase(GetAllIECDetailsBySelectedDate.fulfilled, (state, { payload }) => {
      try {
        state.isGetAllIECDetailsBySelectedDate = true;
        state.GetAllIECDetailsBySelectedDateData = payload;

        state.isGetAllIECDetailsBySelectedDateFetching = false;
        state.isError = false;
        state.errorMessage = "";
        return state;
      } catch (error) {
        console.error(
          "Error: GetAllIECDetailsBySelectedDate.fulfilled try catch error >>",
          error
        );
      }
    });
    builder.addCase(GetAllIECDetailsBySelectedDate.rejected, (state, { payload }) => {
      try {
        state.GetAllIECDetailsBySelectedDateData = [];
        state.isGetAllIECDetailsBySelectedDate = false;
        state.isGetAllIECDetailsBySelectedDateFetching = false;
        state.isError = true;
        payload
          ? (state.errorMessage = payload.error
            ? payload.error
            : "Please try again (There was some network issue).")
          : (state.errorMessage = "API Response Invalid. Please Check API");
      } catch (error) {
        console.error(
          "Error: [GetAllIECDetailsBySelectedDate.rejected] try catch error >>",
          error
        );
      }
    });
    builder.addCase(GetAllIECDetailsBySelectedDate.pending, (state) => {
      state.isGetAllIECDetailsBySelectedDateFetching = true;
    });

    //========= CinGetCompanyAndDirectorDetailBySelected
    builder.addCase(CinGetCompanyAndDirectorDetailBySelected.fulfilled, (state, { payload }) => {
      try {
        state.isCinGetCompanyAndDirectorDetailBySelected = true;
        state.CinGetCompanyAndDirectorDetailBySelectedData = payload;

        state.isCinGetCompanyAndDirectorDetailBySelectedFetching = false;
        state.isError = false;
        state.errorMessage = "";
        return state;
      } catch (error) {
        console.error(
          "Error: CinGetCompanyAndDirectorDetailBySelected.fulfilled try catch error >>",
          error
        );
      }
    });
    builder.addCase(CinGetCompanyAndDirectorDetailBySelected.rejected, (state, { payload }) => {
      try {
        state.CinGetCompanyAndDirectorDetailBySelectedData = [];
        state.isCinGetCompanyAndDirectorDetailBySelected = false;
        state.isCinGetCompanyAndDirectorDetailBySelectedFetching = false;
        state.isError = true;
        payload
          ? (state.errorMessage = payload.error
            ? payload.error
            : "Please try again (There was some network issue).")
          : (state.errorMessage = "API Response Invalid. Please Check API");
      } catch (error) {
        console.error(
          "Error: [CinGetCompanyAndDirectorDetailBySelected.rejected] try catch error >>",
          error
        );
      }
    });
    builder.addCase(CinGetCompanyAndDirectorDetailBySelected.pending, (state) => {
      state.isCinGetCompanyAndDirectorDetailBySelectedFetching = true;
    });
    //========= DarpanGetCompanyAndDirectorDetailBySelected
    builder.addCase(DarpanGetCompanyAndDirectorDetailBySelected.fulfilled, (state, { payload }) => {
      try {
        state.isDarpanGetCompanyAndDirectorDetailBySelected = true;
        state.DarpanGetCompanyAndDirectorDetailBySelectedData = payload;

        state.isDarpanGetCompanyAndDirectorDetailBySelectedFetching = false;
        state.isError = false;
        state.errorMessage = "";
        return state;
      } catch (error) {
        console.error(
          "Error: DarpanGetCompanyAndDirectorDetailBySelected.fulfilled try catch error >>",
          error
        );
      }
    });
    builder.addCase(DarpanGetCompanyAndDirectorDetailBySelected.rejected, (state, { payload }) => {
      try {
        state.DarpanGetCompanyAndDirectorDetailBySelectedData = [];
        state.isDarpanGetCompanyAndDirectorDetailBySelected = false;
        state.isDarpanGetCompanyAndDirectorDetailBySelectedFetching = false;
        state.isError = true;
        payload
          ? (state.errorMessage = payload.error
            ? payload.error
            : "Please try again (There was some network issue).")
          : (state.errorMessage = "API Response Invalid. Please Check API");
      } catch (error) {
        console.error(
          "Error: [DarpanGetCompanyAndDirectorDetailBySelected.rejected] try catch error >>",
          error
        );
      }
    });
    builder.addCase(DarpanGetCompanyAndDirectorDetailBySelected.pending, (state) => {
      state.isDarpanGetCompanyAndDirectorDetailBySelectedFetching = true;
    });
    //========= IECGetCompanyAndDirectorDetailBySelected
    builder.addCase(IECGetCompanyAndDirectorDetailBySelected.fulfilled, (state, { payload }) => {
      try {
        state.isIECGetCompanyAndDirectorDetailBySelected = true;
        state.IECGetCompanyAndDirectorDetailBySelectedData = payload;

        state.isIECGetCompanyAndDirectorDetailBySelectedFetching = false;
        state.isError = false;
        state.errorMessage = "";
        return state;
      } catch (error) {
        console.error(
          "Error: IECGetCompanyAndDirectorDetailBySelected.fulfilled try catch error >>",
          error
        );
      }
    });
    builder.addCase(IECGetCompanyAndDirectorDetailBySelected.rejected, (state, { payload }) => {
      try {
        state.IECGetCompanyAndDirectorDetailBySelectedData = [];
        state.isIECGetCompanyAndDirectorDetailBySelected = false;
        state.isIECGetCompanyAndDirectorDetailBySelectedFetching = false;
        state.isError = true;
        payload
          ? (state.errorMessage = payload.error
            ? payload.error
            : "Please try again (There was some network issue).")
          : (state.errorMessage = "API Response Invalid. Please Check API");
      } catch (error) {
        console.error(
          "Error: [IECGetCompanyAndDirectorDetailBySelected.rejected] try catch error >>",
          error
        );
      }
    });
    builder.addCase(IECGetCompanyAndDirectorDetailBySelected.pending, (state) => {
      state.isIECGetCompanyAndDirectorDetailBySelectedFetching = true;
    });
    //========= Popularsearch
    builder.addCase(Popularsearch.fulfilled, (state, { payload }) => {
      try {
        state.isPopularsearch = true;
        state.PopularsearchData = payload;

        state.isPopularsearchFetching = false;
        state.isError = false;
        state.errorMessage = "";
        return state;
      } catch (error) {
        console.error(
          "Error: Popularsearch.fulfilled try catch error >>",
          error
        );
      }
    });
    builder.addCase(Popularsearch.rejected, (state, { payload }) => {
      try {
        state.PopularsearchData = {};
        state.isPopularsearch = false;
        state.isPopularsearchFetching = false;
        state.isError = true;
        payload
          ? (state.errorMessage = payload.error
            ? "Please try again (There was some network issue)."
            : "Please try again (There was some network issue).")
          : (state.errorMessage = "API Response Invalid. Please Check API");
      } catch (error) {
        console.error(
          "Error: [Popularsearch.rejected] try catch error >>",
          error
        );
      }
    });
    builder.addCase(Popularsearch.pending, (state) => {
      state.isPopularsearchFetching = true;
    });
    //========= Moblie360
    builder.addCase(Mobile360.fulfilled, (state, { payload }) => {
      try {
        state.isMobile360 = true;
        state.Mobile360Data = payload;

        state.isMobile360Fetching = false;
        state.isError = false;
        state.errorMessage = "";
        return state;
      } catch (error) {
        console.error("Error: Mobile360.fulfilled try catch error >>", error);
      }
    });
    builder.addCase(Mobile360.rejected, (state, { payload }) => {
      try {
        state.Mobile360Data = {};
        state.isMobile360 = false;
        state.isMobile360Fetching = false;
        state.isError = true;
        payload
          ? (state.errorMessage = payload.error
            ? "Please try again (There was some network issue)."
            : "Please try again (There was some network issue).")
          : (state.errorMessage = "API Response Invalid. Please Check API");
      } catch (error) {
        console.error("Error: [Mobile360.rejected] try catch error >>", error);
      }
    });
    builder.addCase(Mobile360.pending, (state) => {
      state.isMobile360Fetching = true;
    });
    //========= GetFactAppInfoByPhone
    builder.addCase(GetFactAppInfoByPhone.fulfilled, (state, { payload }) => {
      try {
        state.isGetFactAppInfoByPhone = true;
        state.GetFactAppInfoByPhoneData = payload;
        state.isGetFactAppInfoByPhoneFetching = false;
        state.isError = false;
        state.errorMessage = "";
        return state;
      } catch (error) {
        console.error(
          "Error: GetFactAppInfoByPhone.fulfilled try catch error >>",
          error
        );
      }
    });
    builder.addCase(GetFactAppInfoByPhone.rejected, (state, { payload }) => {
      try {
        state.GetFactAppInfoByPhoneData = {};
        state.isGetFactAppInfoByPhone = false;
        state.isGetFactAppInfoByPhoneFetching = false;
        state.isError = true;
        payload
          ? (state.errorMessage = payload.error ? payload.error : payload.error)
          : (state.errorMessage = "API Response Invalid. Please Check API");
      } catch (error) {
        console.error(
          "Error: [GetFactAppInfoByPhone.rejected] try catch error >>",
          error
        );
      }
    });
    builder.addCase(GetFactAppInfoByPhone.pending, (state) => {
      state.isGetFactAppInfoByPhoneFetching = true;
    });

    //========= GetFactAppInfoMoreByPhone
    builder.addCase(
      GetFactAppInfoMoreByPhone.fulfilled,
      (state, { payload }) => {
        try {
          state.isGetFactAppInfoMoreByPhone = true;
          state.GetFactAppInfoMoreByPhoneData = payload;
          state.isGetFactAppInfoMoreByPhoneFetching = false;
          state.isError = false;
          state.errorMessage = "";
          return state;
        } catch (error) {
          console.error(
            "Error: GetFactAppInfoMoreByPhone.fulfilled try catch error >>",
            error
          );
        }
      }
    );
    builder.addCase(
      GetFactAppInfoMoreByPhone.rejected,
      (state, { payload }) => {
        try {
          state.GetFactAppInfoMoreByPhoneData = {};
          state.isGetFactAppInfoMoreByPhone = false;
          state.isGetFactAppInfoMoreByPhoneFetching = false;
          state.isError = true;
          payload
            ? (state.errorMessage = payload.error
              ? payload.error
              : payload.error)
            : (state.errorMessage = "API Response Invalid. Please Check API");
        } catch (error) {
          console.error(
            "Error: [GetFactAppInfoMoreByPhone.rejected] try catch error >>",
            error
          );
        }
      }
    );
    builder.addCase(GetFactAppInfoMoreByPhone.pending, (state) => {
      state.isGetFactAppInfoMoreByPhoneFetching = true;
    });

    //========= GetFactAppInfoMoreByEmail
    builder.addCase(
      GetFactAppInfoMoreByEmail.fulfilled,
      (state, { payload }) => {
        try {
          state.isGetFactAppInfoMoreByEmail = true;
          state.GetFactAppInfoMoreByEmailData = payload;
          state.isGetFactAppInfoMoreByEmailFetching = false;
          state.isError = false;
          state.errorMessage = "";
          return state;
        } catch (error) {
          console.error(
            "Error: GetFactAppInfoMoreByEmail.fulfilled try catch error >>",
            error
          );
        }
      }
    );
    builder.addCase(
      GetFactAppInfoMoreByEmail.rejected,
      (state, { payload }) => {
        try {
          state.GetFactAppInfoMoreByEmailData = {};
          state.isGetFactAppInfoMoreByEmail = false;
          state.isGetFactAppInfoMoreByEmailFetching = false;
          state.isError = true;
          payload
            ? (state.errorMessage = payload.error
              ? payload.error
              : payload.error)
            : (state.errorMessage = "API Response Invalid. Please Check API");
        } catch (error) {
          console.error(
            "Error: [GetFactAppInfoMoreByEmail.rejected] try catch error >>",
            error
          );
        }
      }
    );
    builder.addCase(GetFactAppInfoMoreByEmail.pending, (state) => {
      state.isGetFactAppInfoMoreByEmailFetching = true;
    });
    //========= GetFactAppInfoByUserName
    builder.addCase(
      GetFactAppInfoByUserName.fulfilled,
      (state, { payload }) => {
        try {
          state.isGetFactAppInfoByUserName = true;
          state.GetFactAppInfoByUserNameData = payload.data;
          state.isGetFactAppInfoByUserNameFetching = false;
          state.isError = false;
          state.errorMessage = "";
          return state;
        } catch (error) {
          console.error(
            "Error: GetFactAppInfoByUserName.fulfilled try catch error >>",
            error
          );
        }
      }
    );
    builder.addCase(GetFactAppInfoByUserName.rejected, (state, { payload }) => {
      try {
        state.GetFactAppInfoByUserNameData = [];
        state.isGetFactAppInfoByUserName = false;
        state.isGetFactAppInfoByUserNameFetching = false;
        // state.isError = true;
        // payload
        //   ? (state.errorMessage = payload.error ? payload.error : payload.error)
        //   : (state.errorMessage = "API Response Invalid. Please Check API");
      } catch (error) {
        console.error(
          "Error: [GetFactAppInfoByUserName.rejected] try catch error >>",
          error
        );
      }
    });
    builder.addCase(GetFactAppInfoByUserName.pending, (state) => {
      state.isGetFactAppInfoByUserNameFetching = true;
    });
    //========= PincodeGet
    builder.addCase(
      PincodeGet.fulfilled,
      (state, { payload }) => {
        try {
          state.isPincodeGet = true;
          state.PincodeGetData = payload.data;
          state.isPincodeGetFetching = false;
          state.isError = false;
          state.errorMessage = "";
          return state;
        } catch (error) {
          console.error(
            "Error: PincodeGet.fulfilled try catch error >>",
            error
          );
        }
      }
    );
    builder.addCase(PincodeGet.rejected, (state, { payload }) => {
      try {
        state.PincodeGetData = [];
        state.isPincodeGet = false;
        state.isPincodeGetFetching = false;
        // state.isError = true;
        // payload
        //   ? (state.errorMessage = payload.error ? payload.error : payload.error)
        //   : (state.errorMessage = "API Response Invalid. Please Check API");
      } catch (error) {
        console.error(
          "Error: [PincodeGet.rejected] try catch error >>",
          error
        );
      }
    });
    builder.addCase(PincodeGet.pending, (state) => {
      state.isPincodeGetFetching = true;
    });

    //========= GetFactAppInfoByEmail
    builder.addCase(GetFactAppInfoByEmail.fulfilled, (state, { payload }) => {
      try {
        state.isGetFactAppInfoByEmail = true;
        state.GetFactAppInfoByEmailData = payload;
        state.isGetFactAppInfoByEmailFetching = false;
        state.isError = false;
        state.errorMessage = "";
        return state;
      } catch (error) {
        console.error(
          "Error: GetFactAppInfoByEmail.fulfilled try catch error >>",
          error
        );
      }
    });
    builder.addCase(GetFactAppInfoByEmail.rejected, (state, { payload }) => {
      try {
        state.GetFactAppInfoByEmailData = {};
        state.isGetFactAppInfoByEmail = false;
        state.isGetFactAppInfoByEmailFetching = false;
        state.isError = true;
        payload
          ? (state.errorMessage = payload.error ? payload.error : payload.error)
          : (state.errorMessage = "API Response Invalid. Please Check API");
      } catch (error) {
        console.error(
          "Error: [GetFactAppInfoByEmail.rejected] try catch error >>",
          error
        );
      }
    });
    builder.addCase(GetFactAppInfoByEmail.pending, (state) => {
      state.isGetFactAppInfoByEmailFetching = true;
    });

    //========= MobileToMSME
    builder.addCase(MobileToMSME.fulfilled, (state, { payload }) => {
      try {
        state.isMobileToMSME = true;
        state.MobileToMSMEData = payload;

        state.isMobileToMSMEFetching = false;
        state.isError = false;
        state.errorMessage = "";
        return state;
      } catch (error) {
        console.error(
          "Error: MobileToMSME.fulfilled try catch error >>",
          error
        );
      }
    });
    builder.addCase(MobileToMSME.rejected, (state, { payload }) => {
      try {
        state.MobileToMSMEData = {};
        state.isMobileToMSME = false;
        state.isMobileToMSMEFetching = false;
        state.isError = true;
        payload
          ? (state.errorMessage = payload.error
            ? "Please try again (There was some network issue)."
            : "Please try again (There was some network issue).")
          : (state.errorMessage = "API Response Invalid. Please Check API");
      } catch (error) {
        console.error(
          "Error: [MobileToMSME.rejected] try catch error >>",
          error
        );
      }
    });
    builder.addCase(MobileToMSME.pending, (state) => {
      state.isMobileToMSMEFetching = true;
    });
    //========= GetCoordinatesData
    builder.addCase(GetCoordinates.fulfilled, (state, { payload }) => {
      try {
        state.isGetCoordinates = true;
        state.GetCoordinatesData = payload;
        state.isGetCoordinatesFetching = false;
        state.isError = false;
        state.errorMessage = "";
        return state;
      } catch (error) {
        console.error(
          "Error: GetCoordinates.fulfilled try catch error >>",
          error
        );
      }
    });
    builder.addCase(GetCoordinates.rejected, (state, { payload }) => {
      try {
        state.GetCoordinatesData = {};
        state.isGetCoordinates = false;
        state.isGetCoordinatesFetching = false;
        state.isError = true;
        payload
          ? (state.errorMessage = payload.error
            ? "Please try again (There was some network issue)."
            : "Please try again (There was some network issue).")
          : (state.errorMessage = "API Response Invalid. Please Check API");
      } catch (error) {
        console.error(
          "Error: [GetCoordinates.rejected] try catch error >>",
          error
        );
      }
    });
    builder.addCase(GetCoordinates.pending, (state) => {
      state.isGetCoordinatesFetching = true;
    });
    //========= Cin
    builder.addCase(Cin.fulfilled, (state, { payload }) => {
      try {
        state.isCin = true;
        state.CinData = payload;

        state.isCinFetching = false;
        state.isError = false;
        state.errorMessage = "";
        return state;
      } catch (error) {
        console.error("Error: Cin.fulfilled try catch error >>", error);
      }
    });
    builder.addCase(Cin.rejected, (state, { payload }) => {
      try {
        state.CinData = {};
        state.isCin = false;
        state.isCinFetching = false;
        state.isError = true;
        payload
          ? (state.errorMessage = payload.error
            ? "Please try again (There was some network issue)."
            : "Please try again (There was some network issue).")
          : (state.errorMessage = "API Response Invalid. Please Check API");
      } catch (error) {
        console.error("Error: [Cin.rejected] try catch error >>", error);
      }
    });
    builder.addCase(Cin.pending, (state) => {
      state.isCinFetching = true;
    });
    //========= SearchCINByAdvanceSearch
    builder.addCase(
      SearchCINByAdvanceSearch.fulfilled,
      (state, { payload }) => {
        try {
          state.isSearchCINByAdvanceSearch = true;
          state.SearchCINByAdvanceSearchData = payload;

          state.isSearchCINByAdvanceSearchFetching = false;
          state.isError = false;
          state.errorMessage = "";
          return state;
        } catch (error) {
          console.error(
            "Error: SearchCINByAdvanceSearch.fulfilled try catch error >>",
            error
          );
        }
      }
    );
    builder.addCase(SearchCINByAdvanceSearch.rejected, (state, { payload }) => {
      try {
        state.SearchCINByAdvanceSearchData = [];
        state.isSearchCINByAdvanceSearch = false;
        state.isSearchCINByAdvanceSearchFetching = false;
        state.isError = true;
        payload
          ? (state.errorMessage = payload.error
            ? "Please try again (There was some network issue)."
            : "Please try again (There was some network issue).")
          : (state.errorMessage = "API Response Invalid. Please Check API");
      } catch (error) {
        console.error(
          "Error: [SearchCINByAdvanceSearch.rejected] try catch error >>",
          error
        );
      }
    });
    builder.addCase(SearchCINByAdvanceSearch.pending, (state) => {
      state.isSearchCINByAdvanceSearchFetching = true;
    });
    //========= DesboadSearchCINByAdvanceSearch
    builder.addCase(
      DesboadSearchCINByAdvanceSearch.fulfilled,
      (state, { payload }) => {
        try {
          state.isDesboadSearchCINByAdvanceSearch = true;
          state.DesboadSearchCINByAdvanceSearchData = payload?.data;

          state.isDesboadSearchCINByAdvanceSearchFetching = false;
          state.isError = false;
          state.errorMessage = "";
          return state;
        } catch (error) {
          console.error(
            "Error: DesboadSearchCINByAdvanceSearch.fulfilled try catch error >>",
            error
          );
        }
      }
    );
    builder.addCase(DesboadSearchCINByAdvanceSearch.rejected, (state, { payload }) => {
      try {
        state.DesboadSearchCINByAdvanceSearchData = [];
        state.isDesboadSearchCINByAdvanceSearch = false;
        state.isDesboadSearchCINByAdvanceSearchFetching = false;
        state.isError = true;
        payload
          ? (state.errorMessage = payload.error
            ? "Please try again (There was some network issue)."
            : "Please try again (There was some network issue).")
          : (state.errorMessage = "API Response Invalid. Please Check API");
      } catch (error) {
        console.error(
          "Error: [DesboadSearchCINByAdvanceSearch.rejected] try catch error >>",
          error
        );
      }
    });
    builder.addCase(DesboadSearchCINByAdvanceSearch.pending, (state) => {
      state.isDesboadSearchCINByAdvanceSearchFetching = true;
    });
    //========= DarpanSearchApi
    builder.addCase(
      DarpanSearchApi.fulfilled,
      (state, { payload }) => {
        try {
          state.isDarpanSearchApi = true;
          state.DarpanSearchApiData = payload.data;

          state.isDarpanSearchApiFetching = false;
          state.isError = false;
          state.errorMessage = "";
          return state;
        } catch (error) {
          console.error(
            "Error: DarpanSearchApi.fulfilled try catch error >>",
            error
          );
        }
      }
    );
    builder.addCase(DarpanSearchApi.rejected, (state, { payload }) => {
      try {
        state.DarpanSearchApiData = {};
        state.isDarpanSearchApi = false;
        state.isDarpanSearchApiFetching = false;
        state.isError = true;
        payload
          ? (state.errorMessage = payload.error
            ? payload.error
            : "Please try again (There was some network issue).")
          : (state.errorMessage = "API Response Invalid. Please Check API");
      } catch (error) {
        console.error(
          "Error: [DarpanSearchApi.rejected] try catch error >>",
          error
        );
      }
    });
    builder.addCase(DarpanSearchApi.pending, (state) => {
      state.isDarpanSearchApiFetching = true;
    });
    //========= GetDarpanDashboardData
    builder.addCase(
      GetDarpanDashboardData.fulfilled,
      (state, { payload }) => {
        try {
          state.isGetDarpanDashboardData = true;
          state.GetDarpanDashboardDataData = payload.data;
          state.isGetDarpanDashboardDataFetching = false;
          state.isError = false;
          state.errorMessage = "";
          return state;
        } catch (error) {
          console.error(
            "Error: GetDarpanDashboardData.fulfilled try catch error >>",
            error
          );
        }
      }
    );
    builder.addCase(GetDarpanDashboardData.rejected, (state, { payload }) => {
      try {
        state.GetDarpanDashboardDataData = null;
        state.isGetDarpanDashboardData = false;
        state.isGetDarpanDashboardDataFetching = false;
        state.isError = true;
        payload
          ? (state.errorMessage = payload.error
            ? payload.error
            : "Please try again (There was some network issue).")
          : (state.errorMessage = "API Response Invalid. Please Check API");
      } catch (error) {
        console.error(
          "Error: [GetDarpanDashboardData.rejected] try catch error >>",
          error
        );
      }
    });
    builder.addCase(GetDarpanDashboardData.pending, (state) => {
      state.isGetDarpanDashboardDataFetching = true;
    });
    //========= GetIECDashboardData
    builder.addCase(
      GetIECDashboardData.fulfilled,
      (state, { payload }) => {
        try {
          state.isGetIECDashboardData = true;
          state.GetIECDashboardDataData = payload.data;
          state.isGetIECDashboardDataFetching = false;
          state.isError = false;
          state.errorMessage = "";
          return state;
        } catch (error) {
          console.error(
            "Error: GetIECDashboardData.fulfilled try catch error >>",
            error
          );
        }
      }
    );
    builder.addCase(GetIECDashboardData.rejected, (state, { payload }) => {
      try {
        state.GetIECDashboardDataData = null;
        state.isGetIECDashboardData = false;
        state.isGetIECDashboardDataFetching = false;
        state.isError = true;
        payload
          ? (state.errorMessage = payload.error
            ? payload.error
            : "Please try again (There was some network issue).")
          : (state.errorMessage = "API Response Invalid. Please Check API");
      } catch (error) {
        console.error(
          "Error: [GetIECDashboardData.rejected] try catch error >>",
          error
        );
      }
    });
    builder.addCase(GetIECDashboardData.pending, (state) => {
      state.isGetIECDashboardDataFetching = true;
    });
    //========= GetFileLogListByUserName
    builder.addCase(
      GetFileLogListByUserName.fulfilled,
      (state, { payload }) => {
        try {
          state.isGetFileLogListByUserName = true;
          state.GetFileLogListByUserNameData = payload.data;

          state.isGetFileLogListByUserNameFetching = false;
          state.isError = false;
          state.errorMessage = "";
          return state;
        } catch (error) {
          console.error(
            "Error: GetFileLogListByUserName.fulfilled try catch error >>",
            error
          );
        }
      }
    );
    builder.addCase(GetFileLogListByUserName.rejected, (state, { payload }) => {
      try {
        state.GetFileLogListByUserNameData = [];
        state.isGetFileLogListByUserName = false;
        state.isGetFileLogListByUserNameFetching = false;
        state.isError = true;
        payload
          ? (state.errorMessage = payload.error
            ? payload.error
            : "Please try again (There was some network issue).")
          : (state.errorMessage = "API Response Invalid. Please Check API");
      } catch (error) {
        console.error(
          "Error: [GetFileLogListByUserName.rejected] try catch error >>",
          error
        );
      }
    });
    builder.addCase(GetFileLogListByUserName.pending, (state) => {
      state.isGetFileLogListByUserNameFetching = true;
    });
    //========= SearchGSTByAdvanceSearch
    builder.addCase(
      SearchGSTByAdvanceSearch.fulfilled,
      (state, { payload }) => {
        try {
          state.SearchGSTByAdvanceSearchTotalData = payload.totalRecord;
          state.SearchGSTByAdvanceSearchData = payload.gSTAdvanceSearchResults;
          state.SearchGSTByAdvanceSearchUserdata = payload.userdata;
          state.SearchGSTByAdvanceSearchpageNumber = 2;
          state.isSearchGSTByAdvanceSearch = true;
          state.isSearchGSTByAdvanceSearchFetching = false;

          state.isError = false;
          state.errorMessage = "";
          return state;
        } catch (error) {
          console.log(
            "Error: SearchGSTByAdvanceSearch.fulfilled try catch error >>",
            error
          );
        }
      }
    );
    builder.addCase(SearchGSTByAdvanceSearch.rejected, (state, { payload }) => {
      console.log(
        "[SearchGSTByAdvanceSearch.rejected] >>>payload>>>>",
        payload
      );
      try {
        state.SearchGSTByAdvanceSearchTotalData = "";
        state.SearchGSTByAdvanceSearchData = [];
        state.SearchGSTByAdvanceSearchUserdata = {};
        state.isSearchGSTByAdvanceSearch = false;
        state.isSearchGSTByAdvanceSearchFetching = false;

        state.isError = true;
        payload
          ? (state.errorMessage = payload.error
            ? payload.error
            : "Failed to retrieve pincode details.")
          : (state.errorMessage = "API Response Invalid. Please Check API");
      } catch (error) {
        console.log(
          "Error: [SearchGSTByAdvanceSearch.rejected] try catch error >>",
          error
        );
      }
    });
    builder.addCase(SearchGSTByAdvanceSearch.pending, (state) => {
      state.isSearchGSTByAdvanceSearchFetching = true;
    });

    //========= DesboadSearchGSTByAdvanceSearch
    builder.addCase(
      DesboadSearchGSTByAdvanceSearch.fulfilled,
      (state, { payload }) => {
        try {
          state.DesboadSearchGSTByAdvanceSearchData = payload?.data || {};
          state.isDesboadSearchGSTByAdvanceSearch = true;
          state.isDesboadSearchGSTByAdvanceSearchFetching = false;

          state.isError = false;
          state.errorMessage = "";
          return state;
        } catch (error) {
          console.log(
            "Error: DesboadSearchGSTByAdvanceSearch.fulfilled try catch error >>",
            error
          );
        }
      }
    );
    builder.addCase(DesboadSearchGSTByAdvanceSearch.rejected, (state, { payload }) => {
      console.log(
        "[DesboadSearchGSTByAdvanceSearch.rejected] >>>payload>>>>",
        payload
      );
      try {
        state.DesboadSearchGSTByAdvanceSearchData = {};
        state.isDesboadSearchGSTByAdvanceSearch = false;
        state.isDesboadSearchGSTByAdvanceSearchFetching = false;

        state.isError = true;
        payload
          ? (state.errorMessage = payload.error
            ? payload.error
            : "Failed to retrieve pincode details.")
          : (state.errorMessage = "API Response Invalid. Please Check API");
      } catch (error) {
        console.log(
          "Error: [DesboadSearchGSTByAdvanceSearch.rejected] try catch error >>",
          error
        );
      }
    });
    builder.addCase(DesboadSearchGSTByAdvanceSearch.pending, (state) => {
      state.isDesboadSearchGSTByAdvanceSearchFetching = true;
    });

    //========= SearchGSTByAdvanceSearch
    builder.addCase(
      SearchGSTByAdvanceSearchMore.fulfilled,
      (state, { payload }) => {
        // console.log("[SearchGSTByAdvanceSearchMore.fulfilled]>>>payload>>>", payload)
        try {
          state.SearchGSTByAdvanceSearchData = payload.gSTAdvanceSearchResults;
          state.SearchGSTByAdvanceSearchpageNumber =
            state.SearchGSTByAdvanceSearchpageNumber + 1;

          state.isSearchGSTByAdvanceSearch = true;
          state.isSearchGSTByAdvanceSearchFetching = false;

          state.isError = false;
          state.errorMessage = "";
          return state;
        } catch (error) {
          console.log(
            "Error: SearchGSTByAdvanceSearchMore.fulfilled try catch error >>",
            error
          );
        }
      }
    );
    builder.addCase(
      SearchGSTByAdvanceSearchMore.rejected,
      (state, { payload }) => {
        // console.log("[SearchGSTByAdvanceSearchMore.rejected] >>>payload>>>>", payload)
        try {
          state.SearchGSTByAdvanceSearchData =
            state.SearchGSTByAdvanceSearchData;
          state.SearchGSTByAdvanceSearchpageNumber =
            state.SearchGSTByAdvanceSearchpageNumber;
          state.isSearchGSTByAdvanceSearch = false;
          state.isSearchGSTByAdvanceSearchFetching = false;

          state.isError = true;
          payload
            ? (state.errorMessage = payload.error
              ? payload.error
              : "Failed to retrieve pincode details.")
            : (state.errorMessage = "API Response Invalid. Please Check API");
        } catch (error) {
          console.log(
            "Error: [SearchGSTByAdvanceSearchMore.rejected] try catch error >>",
            error
          );
        }
      }
    );
    builder.addCase(SearchGSTByAdvanceSearchMore.pending, (state) => {
      state.isSearchGSTByAdvanceSearchFetching = true;
    });
    //========= CinGetIndustryList
    builder.addCase(CinGetIndustryList.fulfilled, (state, { payload }) => {
      try {
        state.isCinGetIndustryList = true;
        state.CinGetIndustryListData = payload;

        state.isCinGetIndustryListFetching = false;
        state.isError = false;
        state.errorMessage = "";
        return state;
      } catch (error) {
        console.error(
          "Error: CinGetIndustryList.fulfilled try catch error >>",
          error
        );
      }
    });
    builder.addCase(CinGetIndustryList.rejected, (state, { payload }) => {
      try {
        state.CinGetIndustryListData = [];
        state.isCinGetIndustryList = false;
        state.isCinGetIndustryListFetching = false;
        // state.isError = true;
        // payload
        //   ? (state.errorMessage = payload.error
        //       ? "Please try again (There was some network issue)."
        //       : "Please try again (There was some network issue).")
        //   : (state.errorMessage = "API Response Invalid. Please Check API");
      } catch (error) {
        console.error(
          "Error: [CinGetIndustryList.rejected] try catch error >>",
          error
        );
      }
    });
    builder.addCase(CinGetIndustryList.pending, (state) => {
      state.isCinGetIndustryListFetching = true;
    });
    //========= CinGetSegmentList
    builder.addCase(CinGetSegmentList.fulfilled, (state, { payload }) => {
      try {
        state.isCinGetSegmentList = true;
        state.CinGetSegmentListData = payload;

        state.isCinGetSegmentListFetching = false;
        state.isError = false;
        state.errorMessage = "";
        return state;
      } catch (error) {
        console.error(
          "Error: CinGetSegmentList.fulfilled try catch error >>",
          error
        );
      }
    });
    builder.addCase(CinGetSegmentList.rejected, (state, { payload }) => {
      try {
        state.CinGetSegmentListData = [];
        state.isCinGetSegmentList = false;
        state.isCinGetSegmentListFetching = false;
        // state.isError = true;
        // payload
        //   ? (state.errorMessage = payload.error
        //       ? "Please try again (There was some network issue)."
        //       : "Please try again (There was some network issue).")
        //   : (state.errorMessage = "API Response Invalid. Please Check API");
      } catch (error) {
        console.error(
          "Error: [CinGetSegmentList.rejected] try catch error >>",
          error
        );
      }
    });
    builder.addCase(CinGetSegmentList.pending, (state) => {
      state.isCinGetSegmentListFetching = true;
    });
    //========= CinRefreshCINDetails
    builder.addCase(CinRefreshCINDetails.fulfilled, (state, { payload }) => {
      try {
        state.isCin = true;
        state.CinData = payload.data;
        state.isCinRefreshCINDetailsFetching = false;
        state.isError = false;
        state.errorMessage = "";
        return state;
      } catch (error) {
        console.error(
          "Error: CinRefreshCINDetails.fulfilled try catch error >>",
          error
        );
      }
    });
    builder.addCase(CinRefreshCINDetails.rejected, (state, { payload }) => {
      try {
        // state.CinData = {};
        state.isCin = false;
        state.isCinRefreshCINDetailsFetching = false;
        state.isError = true;
        payload
          ? (state.errorMessage = payload.error
            ? "Please try again (There was some network issue)."
            : "Please try again (There was some network issue).")
          : (state.errorMessage = "API Response Invalid. Please Check API");
      } catch (error) {
        console.error(
          "Error: [CinRefreshCINDetails.rejected] try catch error >>",
          error
        );
      }
    });
    builder.addCase(CinRefreshCINDetails.pending, (state) => {
      state.isCinRefreshCINDetailsFetching = true;
    });
    //========= Din
    builder.addCase(Din.fulfilled, (state, { payload }) => {
      try {
        state.isDin = true;
        state.DinData = payload;

        state.isDinFetching = false;
        state.isError = false;
        state.errorMessage = "";
        return state;
      } catch (error) {
        console.error("Error: Din.fulfilled try catch error >>", error);
      }
    });
    builder.addCase(Din.rejected, (state, { payload }) => {
      try {
        state.DinData = {};
        state.isDin = false;
        state.isDinFetching = false;
        state.isError = true;
        payload
          ? (state.errorMessage = payload.error
            ? "Please try again (There was some network issue)."
            : "Please try again (There was some network issue).")
          : (state.errorMessage = "API Response Invalid. Please Check API");
      } catch (error) {
        console.error("Error: [Din.rejected] try catch error >>", error);
      }
    });
    builder.addCase(Din.pending, (state) => {
      state.isDinFetching = true;
    });
    //========= Msme
    builder.addCase(Msme.fulfilled, (state, { payload }) => {
      try {
        state.isMsme = true;
        state.MsmeData = payload;

        state.isMsmeFetching = false;
        state.isError = false;
        state.errorMessage = "";
        return state;
      } catch (error) {
        console.error("Error: Msme.fulfilled try catch error >>", error);
      }
    });
    builder.addCase(Msme.rejected, (state, { payload }) => {
      try {
        state.MsmeData = {};
        state.isMsme = false;
        state.isMsmeFetching = false;
        state.isError = true;
        payload
          ? (state.errorMessage = payload.error
            ? "Please try again (There was some network issue)."
            : "Please try again (There was some network issue).")
          : (state.errorMessage = "API Response Invalid. Please Check API");
      } catch (error) {
        console.error("Error: [Msme.rejected] try catch error >>", error);
      }
    });
    builder.addCase(Msme.pending, (state) => {
      state.isMsmeFetching = true;
    });
    //========= MsmeRefreshDetails
    builder.addCase(MsmeRefreshDetails.fulfilled, (state, { payload }) => {
      try {
        state.isMsme = true;
        state.MsmeData = payload;
        state.isMsmeRefreshDetailsFetching = false;
        state.isError = false;
        state.errorMessage = "";
        return state;
      } catch (error) {
        console.error(
          "Error: MsmeRefreshDetails.fulfilled try catch error >>",
          error
        );
      }
    });
    builder.addCase(MsmeRefreshDetails.rejected, (state, { payload }) => {
      try {
        // state.MsmeData = {};
        state.isMsme = false;
        state.isMsmeRefreshDetailsFetching = false;
        state.isError = true;
        payload
          ? (state.errorMessage = payload.error
            ? "Please try again (There was some network issue)."
            : "Please try again (There was some network issue).")
          : (state.errorMessage = "API Response Invalid. Please Check API");
      } catch (error) {
        console.error(
          "Error: [MsmeRefreshDetails.rejected] try catch error >>",
          error
        );
      }
    });
    builder.addCase(MsmeRefreshDetails.pending, (state) => {
      state.isMsmeRefreshDetailsFetching = true;
    });
    //========= GetNewGSTList
    builder.addCase(GetNewGSTList.fulfilled, (state, { payload }) => {
      try {
        state.isGetNewGSTList = true;
        state.GetNewGSTListData = payload;

        state.isGetNewGSTListFetching = false;
        state.isError = false;
        state.errorMessage = "";
        return state;
      } catch (error) {
        console.error(
          "Error: GetNewGSTList.fulfilled try catch error >>",
          error
        );
      }
    });
    builder.addCase(GetNewGSTList.rejected, (state, { payload }) => {
      try {
        state.GetNewGSTListData = {};
        state.isGetNewGSTList = false;
        state.isGetNewGSTListFetching = false;
        state.isError = true;
        payload
          ? (state.errorMessage = payload.error.message_detail
            ? "Please try again (There was some network issue)."
            : "Please try again (There was some network issue).")
          : (state.errorMessage = "API Response Invalid. Please Check API");
      } catch (error) {
        console.error(
          "Error: [GetNewGSTList.rejected] try catch error >>",
          error
        );
      }
    });
    builder.addCase(GetNewGSTList.pending, (state) => {
      state.isGetNewGSTListFetching = true;
    });
    //========= GetMCAReport
    builder.addCase(GetMCAReport.fulfilled, (state, { payload }) => {
      try {
        state.isGetMCAReport = true;
        state.GetMCAReportData = payload;
        state.isGetMCAReportFetching = false;
        state.isError = false;
        state.errorMessage = "";
        return state;
      } catch (error) {
        console.error(
          "Error: GetMCAReport.fulfilled try catch error >>",
          error
        );
      }
    });
    builder.addCase(GetMCAReport.rejected, (state, { payload }) => {
      try {
        state.GetMCAReportData = {};
        state.isGetMCAReport = false;
        state.isGetMCAReportFetching = false;
        state.isError = true;
        payload
          ? (state.errorMessage = payload.error.message_detail
            ? "Please try again (There was some network issue)."
            : "Please try again (There was some network issue).")
          : (state.errorMessage = "API Response Invalid. Please Check API");
      } catch (error) {
        console.error(
          "Error: [GetMCAReport.rejected] try catch error >>",
          error
        );
      }
    });
    builder.addCase(GetMCAReport.pending, (state) => {
      state.isGetMCAReportFetching = true;
    });
    //========= GetNewGSTDetail
    builder.addCase(GetNewGSTDetail.fulfilled, (state, { payload }) => {
      try {
        state.isGetNewGSTDetail = true;
        state.GetNewGSTDetailData = payload;
        state.MaltGstDetailData.push(payload);

        state.isGetNewGSTDetailFetching = false;
        state.isError = false;
        state.errorMessage = "";
        return state;
      } catch (error) {
        console.error(
          "Error: GetNewGSTDetail.fulfilled try catch error >>",
          error
        );
      }
    });
    builder.addCase(GetNewGSTDetail.rejected, (state, { payload }) => {
      try {
        state.GetNewGSTDetailData = payload;
        state.isGetNewGSTDetail = false;
        state.isGetNewGSTDetailFetching = false;
        state.isError = true;
        payload
          ? (state.errorMessage = payload.error.message_detail
            ? "Please try again (There was some network issue)."
            : "Please try again (There was some network issue).")
          : (state.errorMessage = "API Response Invalid. Please Check API");
      } catch (error) {
        console.error(
          "Error: [GetNewGSTDetail.rejected] try catch error >>",
          error
        );
      }
    });
    builder.addCase(GetNewGSTDetail.pending, (state) => {
      state.isGetNewGSTDetailFetching = true;
    });
    //========= GstContact
    builder.addCase(GstContact.fulfilled, (state, { payload }) => {
      try {
        state.isGstContact = true;
        state.GstContactData = payload;
        state.MaltGstContactData.push(payload);

        state.isGstContactFetching = false;
        state.isError = false;
        state.errorMessage = "";
        return state;
      } catch (error) {
        console.error("Error: GstContact.fulfilled try catch error >>", error);
      }
    });
    builder.addCase(GstContact.rejected, (state, { payload }) => {
      try {
        state.GstContactData = payload;
        state.isGstContact = false;
        state.isGstContactFetching = false;
        state.isError = true;
        payload
          ? (state.errorMessage = payload.error.message_detail
            ? "Please try again (There was some network issue)."
            : "Please try again (There was some network issue).")
          : (state.errorMessage = "API Response Invalid. Please Check API");
      } catch (error) {
        console.error("Error: [GstContact.rejected] try catch error >>", error);
      }
    });
    builder.addCase(GstContact.pending, (state) => {
      state.isGstContactFetching = true;
    });
    //========= PanSearch
    builder.addCase(PanSearch.fulfilled, (state, { payload }) => {
      try {
        state.isPanSearch = true;
        state.PanSearchData = payload;

        state.isPanSearchFetching = false;
        state.isError = false;
        state.errorMessage = "";
        return state;
      } catch (error) {
        console.error("Error: PanSearch.fulfilled try catch error >>", error);
      }
    });
    builder.addCase(PanSearch.rejected, (state, { payload }) => {
      try {
        state.PanSearchData = {};
        state.isPanSearch = false;
        state.isPanSearchFetching = false;
        state.isError = true;
        payload
          ? (state.errorMessage = payload.error
            ? payload.error
            : "Please try again (There was some network issue).")
          : (state.errorMessage = "API Response Invalid. Please Check API");
      } catch (error) {
        console.error("Error: [PanSearch.rejected] try catch error >>", error);
      }
    });
    builder.addCase(PanSearch.pending, (state) => {
      state.isPanSearchFetching = true;
    });

    //========= IESDetailApi
    builder.addCase(IESDetailApi.fulfilled, (state, { payload }) => {
      try {
        state.isIESDetailApi = true;
        state.IESDetailApiData = payload;

        state.isIESDetailApiFetching = false;
        state.isError = false;
        state.errorMessage = "";
        return state;
      } catch (error) {
        console.error(
          "Error: IESDetailApi.fulfilled try catch error >>",
          error
        );
      }
    });
    builder.addCase(IESDetailApi.rejected, (state, { payload }) => {
      try {
        state.IESDetailApiData = {};
        state.isIESDetailApi = false;
        state.isIESDetailApiFetching = false;
        state.isError = true;
        payload
          ? (state.errorMessage = payload.error
            ? "Please try again (There was some network issue)."
            : "Please try again (There was some network issue).")
          : (state.errorMessage = "API Response Invalid. Please Check API");
      } catch (error) {
        console.error(
          "Error: [IESDetailApi.rejected] try catch error >>",
          error
        );
      }
    });
    builder.addCase(IESDetailApi.pending, (state) => {
      state.isIESDetailApiFetching = true;
    });
    //========= PansearchRefreshDetails
    builder.addCase(PansearchRefreshDetails.fulfilled, (state, { payload }) => {
      try {
        state.isPanSearch = true;
        state.PanSearchData = payload;

        state.isPansearchRefreshDetailsFetching = false;
        state.isError = false;
        state.errorMessage = "";
        return state;
      } catch (error) {
        console.error(
          "Error: PansearchRefreshDetails.fulfilled try catch error >>",
          error
        );
      }
    });
    builder.addCase(PansearchRefreshDetails.rejected, (state, { payload }) => {
      try {
        // state.PanSearchData = {};
        state.isPanSearch = false;
        state.isPansearchRefreshDetailsFetching = false;
        state.isError = true;
        payload
          ? (state.errorMessage = payload.error
            ? payload.error
            : "Please try again (There was some network issue).")
          : (state.errorMessage = "API Response Invalid. Please Check API");
      } catch (error) {
        console.error(
          "Error: [PansearchRefreshDetails.rejected] try catch error >>",
          error
        );
      }
    });
    builder.addCase(PansearchRefreshDetails.pending, (state) => {
      state.isPansearchRefreshDetailsFetching = true;
    });

    //========= CINDetailsByDate
    builder.addCase(CINDetailsByDate.fulfilled, (state, { payload }) => {
      try {
        state.isCINDetailsByDate = true;
        state.CINDetailsByDateData = payload;

        state.isCINDetailsByDateFetching = false;
        state.isError = false;
        state.errorMessage = "";
        return state;
      } catch (error) {
        console.error(
          "Error: CINDetailsByDate.fulfilled try catch error >>",
          error
        );
      }
    });
    builder.addCase(CINDetailsByDate.rejected, (state, { payload }) => {
      try {
        state.CINDetailsByDateData = {};
        state.isCINDetailsByDate = false;
        state.isCINDetailsByDateFetching = false;
        state.isError = true;
        payload
          ? (state.errorMessage = payload.error
            ? "Please try again (There was some network issue)."
            : "Please try again (There was some network issue).")
          : (state.errorMessage = "API Response Invalid. Please Check API");
      } catch (error) {
        console.error(
          "Error: [CINDetailsByDate.rejected] try catch error >>",
          error
        );
      }
    });
    builder.addCase(CINDetailsByDate.pending, (state) => {
      state.isCINDetailsByDateFetching = true;
    });
    //========= Panverify
    builder.addCase(Panverify.fulfilled, (state, { payload }) => {
      try {
        state.isPanverify = true;
        state.PanverifyData = payload.data;

        state.isPanverifyFetching = false;
        state.isError = false;
        state.errorMessage = "";
        return state;
      } catch (error) {
        console.error("Error: Panverify.fulfilled try catch error >>", error);
      }
    });
    builder.addCase(Panverify.rejected, (state, { payload }) => {
      try {
        state.PanverifyData = {};
        state.isPanverify = false;

        state.isPanverifyFetching = false;
        state.isError = true;
        payload
          ? (state.errorMessage = payload.error?.errorMessage
            ? payload.error?.errorMessage
            : "Failed to retrieve PAN details.")
          : (state.errorMessage = "API Response Invalid. Please Check API");
      } catch (error) {
        console.error("Error: [Panverify.rejected] try catch error >>", error);
      }
    });
    builder.addCase(Panverify.pending, (state) => {
      state.isPanverifyFetching = true;
    });
    //========= GetPincodeLatLong
    builder.addCase(GetPincodeLatLong.fulfilled, (state, { payload }) => {
      try {
        state.isGetPincodeLatLong = true;
        state.GetPincodeLatLongData = payload?.[0]?.address_components;

        state.isGetPincodeLatLongFetching = false;
        state.isError = false;
        state.errorMessage = "";
        return state;
      } catch (error) {
        console.error(
          "Error: GetPincodeLatLong.fulfilled try catch error >>",
          error
        );
      }
    });
    builder.addCase(GetPincodeLatLong.rejected, (state, { payload }) => {
      try {
        state.GetPincodeLatLongData = {};
        state.isGetPincodeLatLong = false;

        state.isGetPincodeLatLongFetching = false;
        state.isError = true;
        payload
          ? (state.errorMessage = payload.error?.errorMessage
            ? "Please try again (There was some network issue)."
            : "Please try again (There was some network issue).")
          : (state.errorMessage = "API Response Invalid. Please Check API");
      } catch (error) {
        console.error(
          "Error: [GetPincodeLatLong.rejected] try catch error >>",
          error
        );
      }
    });
    builder.addCase(GetPincodeLatLong.pending, (state) => {
      state.isGetPincodeLatLongFetching = true;
    });
    //========= Sendmobileotp
    builder.addCase(Sendmobileotp.fulfilled, (state, { payload }) => {
      try {
        state.isSendmobileotp = true;
        state.SendmobileotpData = payload;

        state.isSendmobileotpFetching = false;
        state.isError = false;
        state.errorMessage = "";
        return state;
      } catch (error) {
        console.error(
          "Error: Sendmobileotp.fulfilled try catch error >>",
          error
        );
      }
    });
    builder.addCase(Sendmobileotp.rejected, (state, { payload }) => {
      try {
        state.SendmobileotpData = {};
        state.isSendmobileotp = false;
        state.isSendmobileotpFetching = false;
        state.isError = true;
        payload
          ? (state.errorMessage = payload.error.message_detail
            ? payload.error.message_detail
            : "no data found")
          : (state.errorMessage = "API Response Invalid. Please Check API");
      } catch (error) {
        console.error(
          "Error: [Sendmobileotp.rejected] try catch error >>",
          error
        );
      }
    });
    builder.addCase(Sendmobileotp.pending, (state) => {
      state.isSendmobileotpFetching = true;
    });
    //========= GSTByLastDays
    builder.addCase(GSTByLastDays.fulfilled, (state, { payload }) => {
      try {
        state.isGSTByLastDays = true;
        state.GSTByLastDaysData = payload.data;

        state.isGSTByLastDaysFetching = false;
        state.isError = false;
        state.errorMessage = "";
        return state;
      } catch (error) {
        console.error(
          "Error: GSTByLastDays.fulfilled try catch error >>",
          error
        );
      }
    });
    builder.addCase(GSTByLastDays.rejected, (state, { payload }) => {
      try {
        state.GSTByLastDaysData = [];
        state.isGSTByLastDays = false;
        state.isGSTByLastDaysFetching = false;
        state.isError = true;
        payload
          ? (state.errorMessage = payload.error
            ? "Please try again (There was some network issue)."
            : "Please try again (There was some network issue).")
          : (state.errorMessage = "API Response Invalid. Please Check API");
      } catch (error) {
        console.error(
          "Error: [GSTByLastDays.rejected] try catch error >>",
          error
        );
      }
    });
    builder.addCase(GSTByLastDays.pending, (state) => {
      state.isGSTByLastDaysFetching = true;
    });
    //========= GSTByLastDaysPincode
    builder.addCase(GSTByLastDaysPincode.fulfilled, (state, { payload }) => {
      try {
        state.isGSTByLastDaysPincode = true;
        state.GSTByLastDaysPincodeData = payload.data;

        state.isGSTByLastDaysPincodeFetching = false;
        state.isError = false;
        state.errorMessage = "";
        return state;
      } catch (error) {
        console.error(
          "Error: GSTByLastDaysPincode.fulfilled try catch error >>",
          error
        );
      }
    });
    builder.addCase(GSTByLastDaysPincode.rejected, (state, { payload }) => {
      try {
        state.GSTByLastDaysPincodeData = [];
        state.isGSTByLastDaysPincode = false;
        state.isGSTByLastDaysPincodeFetching = false;
        state.isError = true;
        payload
          ? (state.errorMessage = payload.error
            ? "Please try again (There was some network issue)."
            : "Please try again (There was some network issue).")
          : (state.errorMessage = "API Response Invalid. Please Check API");
      } catch (error) {
        console.error(
          "Error: [GSTByLastDaysPincode.rejected] try catch error >>",
          error
        );
      }
    });
    builder.addCase(GSTByLastDaysPincode.pending, (state) => {
      state.isGSTByLastDaysPincodeFetching = true;
    });
    //========= GetNewGSTDetailsCountByLastXDays
    builder.addCase(GetNewGSTDetailsCountByLastXDays.fulfilled, (state, { payload }) => {
      try {
        state.isGetNewGSTDetailsCountByLastXDays = true;
        state.GetNewGSTDetailsCountByLastXDaysData = payload.data;

        state.isGetNewGSTDetailsCountByLastXDaysFetching = false;
        state.isError = false;
        state.errorMessage = "";
        return state;
      } catch (error) {
        console.error(
          "Error: GetNewGSTDetailsCountByLastXDays.fulfilled try catch error >>",
          error
        );
      }
    });
    builder.addCase(GetNewGSTDetailsCountByLastXDays.rejected, (state, { payload }) => {
      try {
        state.GetNewGSTDetailsCountByLastXDaysData = [];
        state.isGetNewGSTDetailsCountByLastXDays = false;
        state.isGetNewGSTDetailsCountByLastXDaysFetching = false;
        state.isError = true;
        payload
          ? (state.errorMessage = payload.error
            ? "Please try again (There was some network issue)."
            : "Please try again (There was some network issue).")
          : (state.errorMessage = "API Response Invalid. Please Check API");
      } catch (error) {
        console.error(
          "Error: [GetNewGSTDetailsCountByLastXDays.rejected] try catch error >>",
          error
        );
      }
    });
    builder.addCase(GetNewGSTDetailsCountByLastXDays.pending, (state) => {
      state.isGetNewGSTDetailsCountByLastXDaysFetching = true;
    });
    //========= DarpanByLastDay
    builder.addCase(DarpanByLastDay.fulfilled, (state, { payload }) => {
      try {
        state.isDarpanByLastDay = true;
        state.DarpanByLastDayData = payload.data;

        state.isDarpanByLastDayFetching = false;
        state.isError = false;
        state.errorMessage = "";
        return state;
      } catch (error) {
        console.error(
          "Error: DarpanByLastDay.fulfilled try catch error >>",
          error
        );
      }
    });
    builder.addCase(DarpanByLastDay.rejected, (state, { payload }) => {
      try {
        state.DarpanByLastDayData = [];
        state.isDarpanByLastDay = false;
        state.isDarpanByLastDayFetching = false;
        state.isError = true;
        payload
          ? (state.errorMessage = payload.error
            ? "Please try again (There was some network issue)."
            : "Please try again (There was some network issue).")
          : (state.errorMessage = "API Response Invalid. Please Check API");
      } catch (error) {
        console.error(
          "Error: [DarpanByLastDay.rejected] try catch error >>",
          error
        );
      }
    });
    builder.addCase(DarpanByLastDay.pending, (state) => {
      state.isDarpanByLastDayFetching = true;
    });
    //========= IECByLastDays
    builder.addCase(IECByLastDays.fulfilled, (state, { payload }) => {
      try {
        state.isIECByLastDays = true;
        state.IECByLastDaysData = payload.data;

        state.isIECByLastDaysFetching = false;
        state.isError = false;
        state.errorMessage = "";
        return state;
      } catch (error) {
        console.error(
          "Error: IECByLastDays.fulfilled try catch error >>",
          error
        );
      }
    });
    builder.addCase(IECByLastDays.rejected, (state, { payload }) => {
      try {
        state.IECByLastDaysData = [];
        state.isIECByLastDays = false;
        state.isIECByLastDaysFetching = false;
        state.isError = true;
        payload
          ? (state.errorMessage = payload.error
            ? "Please try again (There was some network issue)."
            : "Please try again (There was some network issue).")
          : (state.errorMessage = "API Response Invalid. Please Check API");
      } catch (error) {
        console.error(
          "Error: [IECByLastDays.rejected] try catch error >>",
          error
        );
      }
    });
    builder.addCase(IECByLastDays.pending, (state) => {
      state.isIECByLastDaysFetching = true;
    });
    //========= GetCINDetailsCountByLastXDays
    builder.addCase(
      GetCINDetailsCountByLastXDays.fulfilled,
      (state, { payload }) => {
        try {
          state.isGetCINDetailsCountByLastXDays = true;
          state.GetCINDetailsCountByLastXDaysData = payload.data;
          state.isGetCINDetailsCountByLastXDaysFetching = false;
          state.isError = false;
          state.errorMessage = "";
          return state;
        } catch (error) {
          console.error(
            "Error: GetCINDetailsCountByLastXDays.fulfilled try catch error >>",
            error
          );
        }
      }
    );
    builder.addCase(
      GetCINDetailsCountByLastXDays.rejected,
      (state, { payload }) => {
        try {
          state.GetCINDetailsCountByLastXDaysData = [];
          state.isGetCINDetailsCountByLastXDays = false;
          state.isGetCINDetailsCountByLastXDaysFetching = false;
          state.isError = true;
          payload
            ? (state.errorMessage = payload.error
              ? "Please try again (There was some network issue)."
              : "Please try again (There was some network issue).")
            : (state.errorMessage = "API Response Invalid. Please Check API");
        } catch (error) {
          console.error(
            "Error: [GetCINDetailsCountByLastXDays.rejected] try catch error >>",
            error
          );
        }
      }
    );
    builder.addCase(GetCINDetailsCountByLastXDays.pending, (state) => {
      state.isGetCINDetailsCountByLastXDaysFetching = true;
    });
    //========= GetDashboardGstCinCount
    builder.addCase(
      GetDashboardGstCinCount.fulfilled,
      (state, { payload }) => {
        try {
          state.isGetDashboardGstCinCount = true;
          state.GetDashboardGstCinCountData = payload.data;
          state.isGetDashboardGstCinCountFetching = false;
          state.isError = false;
          state.errorMessage = "";
          return state;
        } catch (error) {
          console.error(
            "Error: GetDashboardGstCinCount.fulfilled try catch error >>",
            error
          );
        }
      }
    );
    builder.addCase(
      GetDashboardGstCinCount.rejected,
      (state, { payload }) => {
        try {
          state.GetDashboardGstCinCountData = [];
          state.isGetDashboardGstCinCount = false;
          state.isGetDashboardGstCinCountFetching = false;
          state.isError = true;
          payload
            ? (state.errorMessage = payload.error
              ? "Please try again (There was some network issue)."
              : "Please try again (There was some network issue).")
            : (state.errorMessage = "API Response Invalid. Please Check API");
        } catch (error) {
          console.error(
            "Error: [GetDashboardGstCinCount.rejected] try catch error >>",
            error
          );
        }
      }
    );
    builder.addCase(GetDashboardGstCinCount.pending, (state) => {
      state.isGetDashboardGstCinCountFetching = true;
    });
    //========= GetNewCINDetailsCountByLastXDays
    builder.addCase(
      GetNewCINDetailsCountByLastXDays.fulfilled,
      (state, { payload }) => {
        try {
          state.isGetNewCINDetailsCountByLastXDays = true;
          state.GetNewCINDetailsCountByLastXDaysData = payload.data;
          state.isGetNewCINDetailsCountByLastXDaysFetching = false;
          state.isError = false;
          state.errorMessage = "";
          return state;
        } catch (error) {
          console.error(
            "Error: GetNewCINDetailsCountByLastXDays.fulfilled try catch error >>",
            error
          );
        }
      }
    );
    builder.addCase(
      GetNewCINDetailsCountByLastXDays.rejected,
      (state, { payload }) => {
        try {
          state.GetNewCINDetailsCountByLastXDaysData = [];
          state.isGetNewCINDetailsCountByLastXDays = false;
          state.isGetNewCINDetailsCountByLastXDaysFetching = false;
          state.isError = true;
          payload
            ? (state.errorMessage = payload.error
              ? "Please try again (There was some network issue)."
              : "Please try again (There was some network issue).")
            : (state.errorMessage = "API Response Invalid. Please Check API");
        } catch (error) {
          console.error(
            "Error: [GetNewCINDetailsCountByLastXDays.rejected] try catch error >>",
            error
          );
        }
      }
    );
    builder.addCase(GetNewCINDetailsCountByLastXDays.pending, (state) => {
      state.isGetNewCINDetailsCountByLastXDaysFetching = true;
    });
    //========= GetPdfRequestList
    builder.addCase(
      GetPdfRequestList.fulfilled,
      (state, { payload }) => {
        try {
          state.isGetPdfRequestList = true;
          state.GetPdfRequestListData = payload.data;
          state.isGetPdfRequestListFetching = false;
          state.isError = false;
          state.errorMessage = "";
          return state;
        } catch (error) {
          console.error(
            "Error: GetPdfRequestList.fulfilled try catch error >>",
            error
          );
        }
      }
    );
    builder.addCase(
      GetPdfRequestList.rejected,
      (state, { payload }) => {
        try {
          state.GetPdfRequestListData = [];
          state.isGetPdfRequestList = false;
          state.isGetPdfRequestListFetching = false;
          state.isError = true;
          payload
            ? (state.errorMessage = payload.error
              ? "Please try again (There was some network issue)."
              : "Please try again (There was some network issue).")
            : (state.errorMessage = "API Response Invalid. Please Check API");
        } catch (error) {
          console.error(
            "Error: [GetPdfRequestList.rejected] try catch error >>",
            error
          );
        }
      }
    );
    builder.addCase(GetPdfRequestList.pending, (state) => {
      state.isGetPdfRequestListFetching = true;
    });
    //========= Ewallet
    builder.addCase(Ewallet.fulfilled, (state, { payload }) => {
      try {
        state.isEwallet = true;
        state.EwalletData = payload.credit;
        state.ProductName = payload.productvname;
        state.ProductValue = payload.value;
        state.ProductMoreValue = payload.MoreValue;
        state.isEwalletFetching = false;
        state.isError = false;
        state.errorMessage = "";
        return state;
      } catch (error) {
        console.error("Error: Ewallet.fulfilled try catch error >>", error);
      }
    });
    builder.addCase(Ewallet.rejected, (state, { payload }) => {
      try {
        state.isEwallet = false;
        state.isEwalletFetching = false;
        state.Ewalletexpired = payload.error.statuscode || "";
        state.isError = true;
        payload
          ? (state.errorMessage = payload.error
            ? payload.error.errorMessage || payload.error.message || payload.error
            : "no data found")
          : (state.errorMessage = "API Response Invalid. Please Check API");
      } catch (error) {
        console.error("Error: [Ewallet.rejected] try catch error >>", error);
      }
    });
    builder.addCase(Ewallet.pending, (state) => {
      state.isEwalletFetching = true;
    });
    //===
    //========= Sendmobileotp
    builder.addCase(Sendemailotp.fulfilled, (state, { payload }) => {
      try {
        state.isSendemailotp = true;
        state.SendemailotpData = payload;

        state.isSendemailotpFetching = false;
        state.isError = false;
        state.errorMessage = "";
        return state;
      } catch (error) {
        console.error(
          "Error: Sendemailotp.fulfilled try catch error >>",
          error
        );
      }
    });
    builder.addCase(Sendemailotp.rejected, (state, { payload }) => {
      try {
        state.SendemailotpData = {};
        state.isSendemailotp = false;
        state.isSendemailotpFetching = false;
        state.isError = true;
        payload
          ? (state.errorMessage = payload.error.message_detail
            ? payload.error.message_detail
            : "no data found")
          : (state.errorMessage = "API Response Invalid. Please Check API");
      } catch (error) {
        console.error(
          "Error: [Sendemailotp.rejected] try catch error >>",
          error
        );
      }
    });
    builder.addCase(Sendemailotp.pending, (state) => {
      state.isSendemailotpFetching = true;
    });
    //========= UploadCIN
    builder.addCase(UploadCIN.fulfilled, (state, { payload }) => {
      try {
        state.isUploadCIN = true;
        state.UploadCINData = payload;

        state.isUploadCINFetching = false;
        state.isError = false;
        state.errorMessage = "";
        return state;
      } catch (error) {
        console.error("Error: UploadCIN.fulfilled try catch error >>", error);
      }
    });
    builder.addCase(UploadCIN.rejected, (state, { payload }) => {
      try {
        state.UploadCINData = {};
        state.isUploadCIN = false;
        state.isUploadCINFetching = false;
        state.isError = true;
        payload
          ? (state.errorMessage = payload.error
            ? payload.error
            : "no data found")
          : (state.errorMessage = "API Response Invalid. Please Check API");
      } catch (error) {
        console.error("Error: [UploadCIN.rejected] try catch error >>", error);
      }
    });
    builder.addCase(UploadCIN.pending, (state) => {
      state.isUploadCINFetching = true;
    });
    //========= GetCINAddressByPin
    builder.addCase(GetCINAddressByPin.fulfilled, (state, { payload }) => {
      try {
        state.isGetCINAddressByPin = true;
        state.GetCINAddressByPinData = payload;

        state.isGetCINAddressByPinFetching = false;
        state.isError = false;
        state.errorMessage = "";
        return state;
      } catch (error) {
        console.error(
          "Error: GetCINAddressByPin.fulfilled try catch error >>",
          error
        );
      }
    });
    builder.addCase(GetCINAddressByPin.rejected, (state, { payload }) => {
      try {
        state.GetCINAddressByPinData = {};
        state.isGetCINAddressByPin = false;
        state.isGetCINAddressByPinFetching = false;
        state.isError = true;
        payload
          ? (state.errorMessage = payload.error
            ? "Please try again (There was some network issue)."
            : "Please try again (There was some network issue).")
          : (state.errorMessage = "API Response Invalid. Please Check API");
      } catch (error) {
        console.error("Error: [UploadCIN.rejected] try catch error >>", error);
      }
    });
    builder.addCase(GetCINAddressByPin.pending, (state) => {
      state.isGetCINAddressByPinFetching = true;
    });
    //========= SearchCompanyName
    builder.addCase(SearchCompanyName.fulfilled, (state, { payload }) => {
      try {
        state.isSearchCompanyName = true;
        state.SearchCompanyNameData = payload.data;
        state.isSearchCompanyNameFetching = false;
        state.isError = false;
        state.errorMessage = "";
        return state;
      } catch (error) {
        console.error("Error: UploadCIN.fulfilled try catch error >>", error);
      }
    });
    builder.addCase(SearchCompanyName.rejected, (state, { payload }) => {
      try {
        state.SearchCompanyNameData = [];
        state.isSearchCompanyName = false;
        state.isSearchCompanyNameFetching = false;
        state.isError = true;
        payload
          ? (state.errorMessage = payload.error
            ? "Please try again (There was some network issue)."
            : "Please try again (There was some network issue).")
          : (state.errorMessage = "API Response Invalid. Please Check API");
      } catch (error) {
        console.error("Error: [UploadCIN.rejected] try catch error >>", error);
      }
    });
    builder.addCase(SearchCompanyName.pending, (state) => {
      state.isSearchCompanyNameFetching = true;
    });
    //========= SearchCompanyNameGSt
    builder.addCase(SearchCompanyNameGSt.fulfilled, (state, { payload }) => {
      try {
        state.isSearchCompanyNameGSt = true;
        state.SearchCompanyNameGStData = payload.data;
        state.isSearchCompanyNameGStFetching = false;
        state.isError = false;
        state.errorMessage = "";
        return state;
      } catch (error) {
        console.error("Error: UploadCIN.fulfilled try catch error >>", error);
      }
    });
    builder.addCase(SearchCompanyNameGSt.rejected, (state, { payload }) => {
      try {
        state.SearchCompanyNameGStData = [];
        state.isSearchCompanyNameGSt = false;
        state.isSearchCompanyNameGStFetching = false;
        state.isError = true;
        payload
          ? (state.errorMessage = payload.error
            ? "Please try again (There was some network issue)."
            : "Please try again (There was some network issue).")
          : (state.errorMessage = "API Response Invalid. Please Check API");
      } catch (error) {
        console.error("Error: [UploadCIN.rejected] try catch error >>", error);
      }
    });
    builder.addCase(SearchCompanyNameGSt.pending, (state) => {
      state.isSearchCompanyNameGStFetching = true;
    });
    //========= EwalletHistory
    builder.addCase(EwalletHistory.fulfilled, (state, { payload }) => {
      try {
        state.isEwalletHistory = true;
        state.EwalletHistoryData = payload?.credit_history;
        state.CreditData = payload?.credit || 0;
        state.UsedCreditData = payload?.used_credit || 0;
        state.TotalCreditData = payload?.total_credit || 0;
        state.isEwalletHistoryFetching = false;
        state.isError = false;
        state.errorMessage = "";
        return state;
      } catch (error) {
        console.error(
          "Error: EwalletHistory.fulfilled try catch error >>",
          error
        );
      }
    });
    builder.addCase(EwalletHistory.rejected, (state, { payload }) => {
      try {
        // state.EwalletHistoryData = [];
        state.isEwalletHistory = false;
        state.isEwalletHistoryFetching = false;
        state.isError = true;
        payload
          ? (state.errorMessage = payload.error
            ? payload.error
            : payload.error.errorMessage)
          : (state.errorMessage =
            "Please try again (There was some network issue).");
      } catch (error) {
        console.error(
          "Error: [EwalletHistory.rejected] try catch error >>",
          error
        );
      }
    });
    builder.addCase(EwalletHistory.pending, (state) => {
      state.isEwalletHistoryFetching = true;
    });
    //========= dataStoreWalletUpadate
    builder.addCase(dataStoreWalletUpadate.fulfilled, (state, { payload }) => {
      try {
        state.isdataStoreWalletUpadate = true;
        state.dataStoreWalletUpadateData = payload;
        state.isdataStoreWalletUpadateFetching = false;
        state.ProductName = payload.navigetName;
        state.ProductValue = payload.value;
        state.isError = false;
        state.errorMessage = "";
        return state;
      } catch (error) {
        console.error(
          "Error: dataStoreWalletUpadate.fulfilled try catch error >>",
          error
        );
      }
    });
    builder.addCase(dataStoreWalletUpadate.rejected, (state, { payload }) => {
      try {
        state.dataStoreWalletUpadateData = {};
        state.isdataStoreWalletUpadate = false;
        state.isdataStoreWalletUpadateFetching = false;
        state.isError = true;
        payload
          ? (state.errorMessage = payload.error
            ? payload.error
            : payload.errorMessage)
          : (state.errorMessage = "API Response Invalid. Please Check API");
      } catch (error) {
        console.error(
          "Error: [dataStoreWalletUpadate.rejected] try catch error >>",
          error
        );
      }
    });
    builder.addCase(dataStoreWalletUpadate.pending, (state) => {
      state.isdataStoreWalletUpadateFetching = true;
    });
    //========= GetDashboardCount
    builder.addCase(GetDashboardCount.fulfilled, (state, { payload }) => {
      try {
        state.isGetDashboardCount = true;
        state.GetDashboardCountData = payload;
        state.isGetDashboardCountFetching = false;
        state.isError = false;
        state.errorMessage = "";
        return state;
      } catch (error) {
        console.error(
          "Error: GetDashboardCount.fulfilled try catch error >>",
          error
        );
      }
    });
    builder.addCase(GetDashboardCount.rejected, (state, { payload }) => {
      try {
        state.GetDashboardCountData = {};
        state.isGetDashboardCount = false;
        state.isGetDashboardCountFetching = false;
        // state.isError = true;
        // payload
        //   ? (state.errorMessage = payload.error
        //       ? "Please try again (There was some network issue)."
        //       : "Please try again (There was some network issue).")
        //   : (state.errorMessage =
        //       "Please try again (There was some network issue).");
      } catch (error) {
        console.error(
          "Error: [GetDashboardCount.rejected] try catch error >>",
          error
        );
      }
    });
    builder.addCase(GetDashboardCount.pending, (state) => {
      state.isGetDashboardCountFetching = true;
    });
    //========= GetDashboardCount
    builder.addCase(HelpdeskTicketList.fulfilled, (state, { payload }) => {
      try {
        state.isHelpdeskTicketList = true;
        state.HelpdeskTicketListData = payload;
        state.isHelpdeskTicketListFetching = false;
        state.isError = false;
        state.errorMessage = "";
        return state;
      } catch (error) {
        console.error(
          "Error: HelpdeskTicketList.fulfilled try catch error >>",
          error
        );
      }
    });
    builder.addCase(HelpdeskTicketList.rejected, (state, { payload }) => {
      try {
        state.HelpdeskTicketListData = {};
        state.isHelpdeskTicketList = false;
        state.isHelpdeskTicketListFetching = false;
        state.isError = true;
        payload
          ? (state.errorMessage = payload.error
            ? "Please try again (There was some network issue)."
            : "Please try again (There was some network issue).")
          : (state.errorMessage =
            "Please try again (There was some network issue).");
      } catch (error) {
        console.error(
          "Error: [HelpdeskTicketList.rejected] try catch error >>",
          error
        );
      }
    });
    builder.addCase(HelpdeskTicketList.pending, (state) => {
      state.isHelpdeskTicketListFetching = true;
    });
    //========= HelpdeskTicketCreate
    builder.addCase(HelpdeskTicketCreate.fulfilled, (state, { payload }) => {
      try {
        state.isHelpdeskTicketCreate = true;
        state.HelpdeskTicketCreateData = payload;
        state.isHelpdeskTicketCreateFetching = false;
        state.successMessage = payload?.successMessage || "Ticket created successfully.";
        state.isError = false;
        state.errorMessage = "";
        return state;
      } catch (error) {
        console.error(
          "Error: HelpdeskTicketCreate.fulfilled try catch error >>",
          error
        );
      }
    });
    builder.addCase(HelpdeskTicketCreate.rejected, (state, { payload }) => {
      try {
        state.HelpdeskTicketCreateData = {};
        state.isHelpdeskTicketCreate = false;
        state.isHelpdeskTicketCreateFetching = false;
        state.isError = true;
        payload
          ? (state.errorMessage = payload.error
            ? "Please try again (There was some network issue)."
            : "Please try again (There was some network issue).")
          : (state.errorMessage =
            "Please try again (There was some network issue).");
      } catch (error) {
        console.error(
          "Error: [HelpdeskTicketCreate.rejected] try catch error >>",
          error
        );
      }
    });
    builder.addCase(HelpdeskTicketCreate.pending, (state) => {
      state.isHelpdeskTicketCreateFetching = true;
    });
    //========= GetDashboardCategoryCount
    builder.addCase(
      GetDashboardCategoryCount.fulfilled,
      (state, { payload }) => {
        try {
          state.isGetDashboardCategoryCount = true;
          state.GetDashboardCategoryCountData = payload;
          state.isGetDashboardCategoryCountFetching = false;
          state.isError = false;
          state.errorMessage = "";
          return state;
        } catch (error) {
          console.error(
            "Error: GetDashboardCategoryCount.fulfilled try catch error >>",
            error
          );
        }
      }
    );
    builder.addCase(
      GetDashboardCategoryCount.rejected,
      (state, { payload }) => {
        try {
          state.GetDashboardCategoryCountData = {};
          state.isGetDashboardCategoryCount = false;
          state.isGetDashboardCategoryCountFetching = false;
          // state.isError = true;
          // payload
          //   ? (state.errorMessage = payload.error
          //       ? "Please try again (There was some network issue)."
          //       : "Please try again (There was some network issue).")
          //   : (state.errorMessage = "API Response Invalid. Please Check API");
        } catch (error) {
          console.error(
            "Error: [GetDashboardCategoryCount.rejected] try catch error >>",
            error
          );
        }
      }
    );
    builder.addCase(GetDashboardCategoryCount.pending, (state) => {
      state.isGetDashboardCategoryCountFetching = true;
    });
    //========= GetDashboardCategoryCount
    builder.addCase(
      BankPincode.fulfilled,
      (state, { payload }) => {
        try {
          state.isBankPincode = true;
          state.BankPincodeData = payload.data;
          state.isBankPincodeFetching = false;
          state.isError = false;
          state.errorMessage = "";
          return state;
        } catch (error) {
          console.error(
            "Error: BankPincode.fulfilled try catch error >>",
            error
          );
        }
      }
    );
    builder.addCase(
      BankPincode.rejected,
      (state, { payload }) => {
        try {
          state.BankPincodeData = [];
          state.isBankPincode = false;
          state.isBankPincodeFetching = false;
          state.isError = true;
          payload
            ? (state.errorMessage = payload.error
              ? "Please try again (There was some network issue)."
              : "Please try again (There was some network issue).")
            : (state.errorMessage = "API Response Invalid. Please Check API");
        } catch (error) {
          console.error(
            "Error: [BankPincode.rejected] try catch error >>",
            error
          );
        }
      }
    );
    builder.addCase(BankPincode.pending, (state) => {
      state.isBankPincodeFetching = true;
    });
    builder.addCase(
      GetBankMasterDataList.fulfilled,
      (state, { payload }) => {
        try {
          state.isGetBankMasterDataList = true;
          state.GetBankMasterDataListData = payload.data;
          state.isGetBankMasterDataListFetching = false;
          state.isError = false;
          state.errorMessage = "";
          return state;
        } catch (error) {
          console.error(
            "Error: GetBankMasterDataList.fulfilled try catch error >>",
            error
          );
        }
      }
    );
    builder.addCase(
      GetBankMasterDataList.rejected,
      (state, { payload }) => {
        try {
          state.GetBankMasterDataListData = {};
          state.isGetBankMasterDataList = false;
          state.isGetBankMasterDataListFetching = false;
          state.isError = true;
          payload
            ? (state.errorMessage = payload.error
              ? "Please try again (There was some network issue)."
              : "Please try again (There was some network issue).")
            : (state.errorMessage = "API Response Invalid. Please Check API");
        } catch (error) {
          console.error(
            "Error: [BankPincode.rejected] try catch error >>",
            error
          );
        }
      }
    );
    builder.addCase(GetBankMasterDataList.pending, (state) => {
      state.isGetBankMasterDataListFetching = true;
    });

    builder.addCase(
      GetPopulationMasterDataList.fulfilled,
      (state, { payload }) => {
        try {
          state.isGetPopulationMasterDataList = true;
          state.GetPopulationMasterDataListData = payload.data;
          state.isGetPopulationMasterDataListFetching = false;
          state.isError = false;
          state.errorMessage = "";
          return state;
        } catch (error) {
          console.error(
            "Error: GetPopulationMasterDataList.fulfilled try catch error >>",
            error
          );
        }
      }
    );
    builder.addCase(
      GetPopulationMasterDataList.rejected,
      (state, { payload }) => {
        try {
          state.GetPopulationMasterDataListData = {};
          state.isGetPopulationMasterDataList = false;
          state.isGetPopulationMasterDataListFetching = false;
          state.isError = true;
          payload
            ? (state.errorMessage = payload.error
              ? "Please try again (There was some network issue)."
              : "Please try again (There was some network issue).")
            : (state.errorMessage = "API Response Invalid. Please Check API");
        } catch (error) {
          console.error(
            "Error: [BankPincode.rejected] try catch error >>",
            error
          );
        }
      }
    );
    builder.addCase(GetPopulationMasterDataList.pending, (state) => {
      state.isGetPopulationMasterDataListFetching = true;
    });
    builder.addCase(
      GetBankDependentDropdown.fulfilled,
      (state, { payload }) => {
        try {
          state.isGetBankDependentDropdown = true;
          state.GetBankDependentDropdownData = payload.data;
          state.isGetBankDependentDropdownFetching = false;
          state.isError = false;
          state.errorMessage = "";
          return state;
        } catch (error) {
          console.error(
            "Error: GetBankDependentDropdown.fulfilled try catch error >>",
            error
          );
        }
      }
    );
    builder.addCase(
      GetBankDependentDropdown.rejected,
      (state, { payload }) => {
        try {
          // state.GetBankDependentDropdownData = {};
          state.isGetBankDependentDropdown = false;
          state.isGetBankDependentDropdownFetching = false;
          state.isError = true;
          payload
            ? (state.errorMessage = payload.error
              ? "Please try again (There was some network issue)."
              : "Please try again (There was some network issue).")
            : (state.errorMessage = "API Response Invalid. Please Check API");
        } catch (error) {
          console.error(
            "Error: [BankPincode.rejected] try catch error >>",
            error
          );
        }
      }
    );
    builder.addCase(GetBankDependentDropdown.pending, (state) => {
      state.isGetBankDependentDropdownFetching = true;
    });
    builder.addCase(
      GetPopulationDependentDropdown.fulfilled,
      (state, { payload }) => {
        try {
          state.isGetPopulationDependentDropdown = true;
          state.GetPopulationDependentDropdownData = payload.data;
          state.isGetPopulationDependentDropdownFetching = false;
          state.isError = false;
          state.errorMessage = "";
          return state;
        } catch (error) {
          console.error(
            "Error: GetPopulationDependentDropdown.fulfilled try catch error >>",
            error
          );
        }
      }
    );
    builder.addCase(
      GetPopulationDependentDropdown.rejected,
      (state, { payload }) => {
        try {
          // state.GetPopulationDependentDropdownData = {};
          state.isGetPopulationDependentDropdown = false;
          state.isGetPopulationDependentDropdownFetching = false;
          state.isError = true;
          payload
            ? (state.errorMessage = payload.error
              ? "Please try again (There was some network issue)."
              : "Please try again (There was some network issue).")
            : (state.errorMessage = "API Response Invalid. Please Check API");
        } catch (error) {
          console.error(
            "Error: [BankPincode.rejected] try catch error >>",
            error
          );
        }
      }
    );
    builder.addCase(GetPopulationDependentDropdown.pending, (state) => {
      state.isGetPopulationDependentDropdownFetching = true;
    });
  },
});

export const { updateState } = TBSlice.actions;
export const TBSelector = (state) => state.main.TB;
